import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, debounceTime, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Cacheable } from 'ngx-cacheable';
import { PagedResult } from '../_models/models';
import { StringViewModel, StreamBoxLayoutViewModel, StreamBoxStateViewModel, GetStreamboxStateViewModel, OpenTokAuthModel, ConferenceRoomViewModel, StreamboxViewModel, AssessmentViewModel, GhostWriterQuestion, SegmentProgressViewModel, AssessmentResponsesViewModel, CourseCompletionViewModel, BlobBrowserListingViewModel, BlobBrowserDownloadUrlViewModel, AzureBlobSASViewModel, BlobUploadRequestViewModel, CertificationBodyViewModel, OrganizationCertificationViewModel, ConferenceWithCertificateViewModel, CertificationBodyFeedbackSurveyViewModel, AddSurveyResultModel, CEUEventSummary, ConferenceEventSummariesViewModel, QuizAnswerViewModel, ConferenceCertificateViewModel, ConferenceUserCertificateViewModelWithDetails, CEUPricingViewModel, PurchaseCEUsViewModel, PageViewModel, InstructorViewModel, MemberLookupResult, ModifyRegistrationViewModel, UserPackagePurchaseViewModel, RegistrationPackageViewModel, PackageGroupDiscountViewModel, SponsorshipLandingPageViewModel, SponsorListingSearchParameters, ConferenceAnnouncementViewModel, ConferenceConnectionViewModel, ConferenceChatViewModel, ChatMembersViewModel, CreateChatroomViewModel, ConferenceChatMessageViewModel, ConferenceSpeakerViewModel, AddEditConferencePurchaseOrderViewModel, ConferenceAnalyticsViewModel, CourseEventWithMaterialsViewModel, CourseViewModel, CourseSearchResultsViewModel, CourseSearchParameters, CourseViewModelSimple, OnDemandSearchParameters, SearchFilterDataModel, CreateCourseViewModel, PromoCodeResultViewModel, CourseReviewViewModel, CardTokenViewModel, SegmentStatus, PlayheadLocationModel, ExternalEducationViewModel, EducationResultsViewModel, EducationSearchParameters, EducationTrackingProgressViewModel, EventViewModel, EventSearchParameters, EventConferenceItemListing, ConferenceViewModelSimple, BasicSearchParameters, ScheduleUserEventViewModel, EventDisplayViewModel, CourseEventViewModel, LiveEventViewModel, ChatHistoryViewModel, QuestionHistoryViewModel, QuestionHistoryTitlesViewModel, MaterialViewModel, RegisterUserViewModel, UserProfileViewModel, PurchasePackageViewModel, ConferencePurchaseOrderTotalsViewModel, PromoCodeCheckViewModel, TipViewModel, EventCompletionViewModel, CreateReviewViewModel, APAEvaluationViewModel, EventVideoViewModel, ExhibitSummaryViewModel, ExhibitDesignerViewModel, ActiveExhibitUserViewModel, LogExhibitVisitModel, PosterViewModel, UpdateExhibitViewModel, NameValuePair, CreateInstructorViewModel, MergeInstructorViewModel, JobSearchHistoryParameters, JobSearchResultsViewModel, JobApplicationViewModel, JobSearchParameters, JobViewModel, LocationViewModel, JobStatisticsModel, CreateJobViewModel, CreateLocationViewModel, JobSearchResultViewModel, CompanyViewModel, JobWithSummaryViewModel, UpdateCompanyModel, LiveEventDashboardViewModel, EventDashboardViewModel, BooleanViewModel, PagedActiveUserViewModel, PagedLobbyActiveUserViewModel, LobbyViewModel, OrganizationViewModel, SuperUserOrganizationSearchParameters, PackageDropdownViewModel, EventSummaryViewModel, StrNameValuePair, TagViewModel, PackageAddonViewModel, OrganizationEventSearchParams, ConferenceRegistrantViewModel, AddPageViewModel, OrderedIdModel, AuthenticatedDomainViewModel, CreateConferenceRegistrationViewModel, CEUReconciliationViewModel, DeletePackageModel, UserSearchResultsViewModel, UserSearchParameters, CreateEventViewModel, CourseEventEmailViewModel, OrganizationSettingsViewModel, CreatePaymentMethodViewModel, ConferenceViewModelWithDetails, CreateSubscriptionViewModel, OrganizationInvoiceViewModel, OrganizationSubscriptionViewModel, StripeProductViewModel, ConferenceViewModel, ConferenceRegistrantSummaryViewModel, RegistrantSearchParameters, WebsiteSettings, UserLookupViewModel, LegacyExternalConfernceRegistration, PromoCodeViewModel, UserViewModel, EmployeeSearchParams, EmployeeUploadViewModel, PromoCodeUploadViewModel, GabaSurveyModel, CEUPrintSheetParameters, UserPackagePurchaseChangeLogViewModel, RegistrantChangeLogSearchParameters, PollViewModel, CreatePollViewModel, UpdatePollViewModel, CreatePosterViewModel, ActivePosterUserViewModel, PosterSessionViewModel, DeviceInstallation, IntegrationFieldConfig, ArrayViewModel, CampaignListResult, SpreadsheetMetaData, GiftCardClaimViewModel, CaptivePortalAuthorizeRequest, PlaidToken, PublicTokenModel, TodaysEventViewmodel, StripeBalanceViewModel, ExistingConferenceRegistrationResultsViewModel, PurchaseOrderViewModel, CreateExistingConferenceRegistrationViewModel, ExistingConferenceRegistrationViewModel, ConferenceReconciliationData, ConferenceExpenseViewModel, UploadSpreadsheetModel, InstructorSummaryViewModel, ExhibitInviteViewModel, CreateUpdateExhibitViewModel, UserAuthenticationViewModel, CreateSegmentViewModel, CreateAssessmentViewModel, CourseEventStatus, UserPurchaseHistoryViewModel, UpdateCEUModel, UserCourseEventPurchaseUpdateViewModel, MergeSponsorOrganizationsViewModel, UserPackagePurchaseHistoryViewModel, SuperUserPackageLinkViewModel, SuperUserCourseEventLinkViewModel, GeneralLedgerViewModel, CourseEventDropdownViewModel, CreateUpdatePackageViewModel, UpdateEventModeratorsViewModel, ContractViewModel, UpdateContractViewModel, WowzaChannelViewModel, SuperUserCertBodySearchParameters, SponsorshipOrderEditViewModel, OrganizationContractViewModel, OrganizationContractSearchParameters, ConferencePurchaseOrderViewModel, ConferencePurchaseOrderSearchParameters, GeneralLedgerSummaryViewModel, GeneralLedgerUnpaidTotalViewModel, ConferenceLineItemCategoryViewModel, ConferenceLineItemViewModel, EventSummarySearchViewModel, SuperUserEventSearchParameters, ConferenceSearchViewModel, SuperUserConferenceSearchParameters, CourseSearchViewModel, SuperUserCourseSearchParameters, StreamCaseRecordingViewModel, StreamCaseRecordingSearchParameters, StreamRecordingDownloadUrlViewModel, StreamRecordingTranscodeResultViewModel, AdCampaignSummaryViewModel, AdCampaignViewModel, ServedAdViewModel, PaperTypeViewModel, CallForPapersViewModel, FinalizePaperModel, PromoCodeSponsorshipResultViewModel, PromoCodeSponsorshipCheckViewModel, SponsorStoreSettings, ConferenceMapViewModel, ConferenceMapViewModelWithSponsorInfo, SponsorshipProductViewModel, SponsorshipOrderModel, SponsorOrganizationViewModel, ConferenceGroupWithTasksViewModel, TaskSearchParameters, DateTimeViewModel, ConferenceTaskViewModel, TaskOrderUpdateViewModel, UpdateTaskOrderAndGroupViewModel, UpdateAssigneesViewModel, ConferenceTaskGroupViewModel, GroupOrderUpdateViewModel, ConferenceTaskStatusViewModel, ConferenceTaskCommentViewModel, MobileEventSummaryViewModel, OrganizationViewModelSimple, PosCategoryViewModel, PosProductViewModel, PosOrderViewModel, CreatePosOrderViewModel, CreateUpdatePosCategoryViewModel, CreateUpdatePosProductViewModel, UserSubscriptionViewModel, UserCertificationViewModel, ConferenceCEUScannerViewModel, ConferenceOrEventSummaryViewModel, ConferenceViewModeMobileApp, ConferenceViewModeMobileAppV2, ExhibitCEUScannerViewModel, CEUScanAdvertisement, UpdateProfileViewModel, UpdateProfileViewModelV2, UserRegistrationFieldsViewModel, LoginViewModel, StripeDataViewModel, MobileAppEventListingViewModel, ReferralBonusViewModel, SalesHistoryViewModel, CEUCheckinModel, CEUHistory, CEUScanHistory, ConferenceCEUModel, UsersAuthoredCoursesViewModel, UsersAuthoredEventsViewModel, AuthorCourseVewModel, ChangePasswordViewModel, ResetPasswordViewModel, PaperSubmissionListViewModel, SavedJobSearchParameters, SuperUserSponsorOrganizationSearchParameters, ConferenceSponsorOrganizationViewModel, SponsorshipOrderItemViewModel, SponsorshipAssetViewModel, ViewSponsorshipVoucherViewModel, SponsorshipConferenceScanResultViewModel, SponsorConfigurationViewModel, AssetMetadataViewModel, SponsorshipExhibitViewModel, SponsorDashboardViewModel, PaperSubmissionSummaryViewModel, PaperSubmissionFilterViewModel, PaperEmailViewModel, PaperTagViewModel, PaperSubmissionViewModel, PaperConfigurationViewModel, PaperNotesViewModel, ComposeEmailViewModel, PaperReviewModel, ConvertToEventViewModel, CustomSurveyReturnModel, OrganizationIntegrationViewModel, ConferenceCheckinSettingsViewModel, ConferenceRegistrationSettingsViewModel, ConferenceSpeakerSearchParameters, ConferenceGuestRoomTypeViewModel, AttendeeUploadViewModel, PackageAddonDetailsViewModel, RegistrantDetailsViewModel, BadgeTemplateViewModel, SponsorshipProductAddOnViewModel, SponsorshipOrderViewModel, SponsorshipAssetListingViewModel, SponsorshipVoucherItemViewModel, VoucherSearchParams, PurchaseOrderSearchViewModel, PurchaseOrderTotalsViewModel, ConferenceMapBoothViewModel, ConferenceMapViewModelSimple, LinkSponsorOrderToSponsorOrganizationModel, SponsorshipProductTagViewModel, CloneFromConferenceViewModel, ConferencePaperReviewerViewModel, BadgePrinterViewModel, PrintNodeComputerViewModel, CardReaderDisplayViewModel, ConferenceDashboardStatsViewModel, ManualAddOnViewModel, ConferenceWebsiteAdViewModel, MembershipProfileViewModel, ProfileSearchParams, MembershipTypeViewModel, OnDemandReportViewModel, AttendanceReportViewModel, DateRangeViewModel, AttendanceSummaryReportViewModel, CourseSummaryViewModel, OrganizationCourseSearchParameters, PosCustomerListItemViewModel, PosCustomerSearchParams, PosCustomerDetailViewModel, PosCustomerViewModel, UpdatePosCustomerViewModel, PosOrderListItemViewModel, PosOrderSearchParams, PosOrderSummaryViewModel, PosOrderStatusViewModel, ConferenceBadgeElementViewModel, ConferenceSpeakerExpenseDetailsViewModel, ConferenceSpeakerExpenseSearchParameters, ConferenceSpeakerExpenseViewModel, ListCampaignsViewModel, CampaignUser, CampaignViewModel, CampaignValidationResult, CampaignSummary, CampaignListViewModel, TestEmailViewModel, FilterProperty, CampaignFilter, CampaignListSearchParams, ProgramEventViewModel, GenerateProgramViewModel, ProgramExportTemplateViewModel, SchedulerSettingsViewModel, UpdateEventFromScheduleViewModel, SurveySummaryViewModel, SurveyViewModel, SurveyWithDataViewModel, SecurityGroupViewModel, EmploymentTagViewModel, OrganizationUserViewModel, OrganizationUserSearchParams, BulkUpdateOrganizationUsersViewModel, OrganizationUserViewModelSimple, OrganizationUserPermissionsViewModel, CreateUpdateOrganizationUserViewModel, LearningPlanListViewModel, LearningPlanSearchParams, CategoryViewModel, CourseEventViewModelSimple, LearningPlanViewModel, CreateUpdateLearningPlanViewModel, UserLearningPlanAssignmentListViewModel, ContentAssignmentSearchParams, IndividualUserCourseEventAssignmentViewModel, CreateBulkContentAssignmentViewModel, OrganizationUserAssignmentSummaryViewModel, UserCourseEventAssignmentViewModel, OrganizationUserAssignmentEventSearchParams, UserLearningPlanAssignmentViewModel, OrganizationUserAssignmentOnDemandSearchParams, UserLearningPlanAssignmentDetailsViewModel, UserCourseEventAssignmentDetailsViewModel, UserCertificationDetailsViewModel, EducationTrackingSearchParams } from '../_models/generatedModels';
import { SettingsProvider } from './settingsProvider.service';
import { UUID } from '../_helpers/extensions.module';

@Injectable()
export class StreamBoxService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  startStreaming(streamBoxId: number, theModel: StreamBoxLayoutViewModel): Observable<StringViewModel> {
       return this.http.post<StringViewModel>(`${this.baseUrl}/streambox/${streamBoxId}/startStreaming`, theModel)
            .pipe(map((result: StringViewModel) => result));
  }

  stopStreaming(streamBoxId: number): Observable<StringViewModel> {
       return this.http.post<StringViewModel>(`${this.baseUrl}/streambox/${streamBoxId}/stopStreaming`, null)
            .pipe(map((result: StringViewModel) => result));
  }

  getState(theModel: GetStreamboxStateViewModel): Observable<StreamBoxStateViewModel[]> {
       return this.http.post<StreamBoxStateViewModel[]>(`${this.baseUrl}/streambox/get-state`, theModel)
            .pipe(map((result: StreamBoxStateViewModel[]) => result));
  }

  startRecording(streamBoxId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/streambox/${streamBoxId}/startRecording`, null)
            .pipe(map((result: boolean) => result));
  }

  stopRecording(streamBoxId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/streambox/${streamBoxId}/stopRecording`, null)
            .pipe(map((result: boolean) => result));
  }

  updateLayout(streamBoxId: number, theModel: StreamBoxLayoutViewModel): Observable<StringViewModel> {
       return this.http.post<StringViewModel>(`${this.baseUrl}/streambox/${streamBoxId}/update-layout`, theModel)
            .pipe(map((result: StringViewModel) => result));
  }

  getOpenTokToken(streamBoxId: number): Observable<OpenTokAuthModel> {
       return this.http.get<OpenTokAuthModel>(`${this.baseUrl}/streambox/${streamBoxId}/opentok-token`);
   }

  getRoomsForConferences(): Observable<ConferenceRoomViewModel[]> {
       return this.http.get<ConferenceRoomViewModel[]>(`${this.baseUrl}/streambox/get-rooms`);
   }

  updateChannelForStreambox(streamBoxId: number, roomId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/streambox/${streamBoxId}/update-room/${roomId}`, null)
            .pipe(map((result: boolean) => result));
  }

  updatePeplinkForRoom(streamBoxId: number, roomId: number, peplinkId: string): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/streambox/${streamBoxId}/update-room-peplink/${roomId}/${peplinkId}`, null)
            .pipe(map((result: boolean) => result));
  }

  getOpenTokCaptionToken(streamBoxId: number): Observable<OpenTokAuthModel> {
       return this.http.get<OpenTokAuthModel>(`${this.baseUrl}/streambox/${streamBoxId}/opentok-caption-token`);
   }

  getStreamboxForRoomId(roomId: number): Observable<StreamboxViewModel> {
       return this.http.get<StreamboxViewModel>(`${this.baseUrl}/rooms/${roomId}/streambox`);
   }

  getAllStreamboxes(): Observable<StreamboxViewModel[]> {
       return this.http.get<StreamboxViewModel[]>(`${this.baseUrl}/streamboxes/all`);
   }

  startCaptions(streamBoxId: number): Observable<boolean> {
       return this.http.get<boolean>(`${this.baseUrl}/streambox/${streamBoxId}/start-captions`);
   }

  stopCaptions(streamBoxId: number): Observable<boolean> {
       return this.http.get<boolean>(`${this.baseUrl}/streambox/${streamBoxId}/stop-captions`);
   }

  getOpenTokTokenForMultiView(): Observable<OpenTokAuthModel> {
       return this.http.get<OpenTokAuthModel>(`${this.baseUrl}/streambox/opentok-token-multiview`);
   }

  getOpenTokSessionId(streamBoxId: number): Observable<boolean> {
       return this.http.get<boolean>(`${this.baseUrl}/streambox/${streamBoxId}/opentok-session`);
   }

  getOpenTokCaptionSessionId(streamBoxId: number): Observable<boolean> {
       return this.http.get<boolean>(`${this.baseUrl}/streambox/${streamBoxId}/opentok-caption-session`);
   }

}
@Injectable()
export class AssessmentService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getAssessment(assessmentId: number): Observable<AssessmentViewModel> {
       return this.http.get<AssessmentViewModel>(`${this.baseUrl}/assessments/${assessmentId}`);
   }

  ghostWriteAssessment(eventId: number, skip: number): Observable<GhostWriterQuestion[]> {
       return this.http.get<GhostWriterQuestion[]>(`${this.baseUrl}/assessments/${eventId}/ghost-writer?skip=${skip}`);
   }

  submitResponses(segmentId: number, model: AssessmentResponsesViewModel): Observable<SegmentProgressViewModel> {
       return this.http.post<SegmentProgressViewModel>(`${this.baseUrl}/segments/${segmentId}/assessments/responses`, model)
            .pipe(map((result: SegmentProgressViewModel) => result));
  }

  submitAssessmentAndGetCeus(courseId: number, model: AssessmentResponsesViewModel): Observable<CourseCompletionViewModel> {
       return this.http.post<CourseCompletionViewModel>(`${this.baseUrl}/courses/${courseId}/assessments/responses`, model)
            .pipe(map((result: CourseCompletionViewModel) => result));
  }

}
@Injectable()
export class BlobBrowserService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  list(prefix: string): Observable<BlobBrowserListingViewModel> {
       return this.http.get<BlobBrowserListingViewModel>(`${this.baseUrl}/superuser/blob-browser/list/?prefix=${prefix}`);
   }

  getDownloadUrl(path: string): Observable<BlobBrowserDownloadUrlViewModel> {
       return this.http.get<BlobBrowserDownloadUrlViewModel>(`${this.baseUrl}/superuser/blob-browser/download-url/?path=${path}`);
   }

  getUploadUrl(model: BlobUploadRequestViewModel): Observable<AzureBlobSASViewModel> {
       return this.http.post<AzureBlobSASViewModel>(`${this.baseUrl}/superuser/blob-browser/upload-url/`, model)
            .pipe(map((result: AzureBlobSASViewModel) => result));
  }

}
@Injectable()
export class CEUService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getCertificationBodies(): Observable<CertificationBodyViewModel[]> {
       return this.http.get<CertificationBodyViewModel[]>(`${this.baseUrl}/ceus/certificationBodies`);
   }

  getCertificationBodiesWithEducationTracking(): Observable<CertificationBodyViewModel[]> {
       return this.http.get<CertificationBodyViewModel[]>(`${this.baseUrl}/ceus/certificationBodies/education-tracking`);
   }

  getCertificationsForOrganization(organizationIdOrSlug: string): Observable<OrganizationCertificationViewModel[]> {
       return this.http.get<OrganizationCertificationViewModel[]>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/certifications`);
   }

  getCertificationsForPlatform(): Observable<OrganizationCertificationViewModel[]> {
       return this.http.get<OrganizationCertificationViewModel[]>(`${this.baseUrl}/ceus/platform-certifications`);
   }

  createCertificationForConference(organizationIdOrSlug: string, model: OrganizationCertificationViewModel): Observable<OrganizationCertificationViewModel[]> {
       return this.http.post<OrganizationCertificationViewModel[]>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/certifications`, model)
            .pipe(map((result: OrganizationCertificationViewModel[]) => result));
  }

  updateCertificationForConference(organizationIdOrSlug: string, certificationId: number, model: OrganizationCertificationViewModel): Observable<OrganizationCertificationViewModel[]> {
       return this.http.put<OrganizationCertificationViewModel[]>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/certifications/${certificationId}`, model)
            .pipe(map((result: OrganizationCertificationViewModel[]) => result));
  }

  getConferencesWithCertificates(): Observable<ConferenceWithCertificateViewModel[]> {
       return this.http.get<ConferenceWithCertificateViewModel[]>(`${this.baseUrl}/user/ceus/conferences`);
   }

  getFeedbackSurvey(feedbackSurveyId: number): Observable<CertificationBodyFeedbackSurveyViewModel> {
       return this.http.get<CertificationBodyFeedbackSurveyViewModel>(`${this.baseUrl}/user/ceus/feedback-survey/${feedbackSurveyId}`);
   }

  submitFeedbackSurvey(feedbackSurveyId: number, courseEventId: number, model: AddSurveyResultModel): Observable<CertificationBodyFeedbackSurveyViewModel> {
       return this.http.post<CertificationBodyFeedbackSurveyViewModel>(`${this.baseUrl}/user/ceus/feedback-survey/${feedbackSurveyId}/event/${courseEventId}`, model)
            .pipe(map((result: CertificationBodyFeedbackSurveyViewModel) => result));
  }

  getEventSummariesForConference(conferenceId: number): Observable<CEUEventSummary[]> {
       return this.http.get<CEUEventSummary[]>(`${this.baseUrl}/user/ceus/conferences/${conferenceId}/event-summaries`);
   }

  getEventSummariesForConferenceV2(conferenceId: number): Observable<ConferenceEventSummariesViewModel> {
       return this.http.get<ConferenceEventSummariesViewModel>(`${this.baseUrl}/user/ceus/conferences/${conferenceId}/event-summariesV2`);
   }

  getCEURawDataForUser(courseEventId: number, userId: number): Observable<CEUEventSummary> {
       return this.http.get<CEUEventSummary>(`${this.baseUrl}/user/ceus/raw-data/event-summaries/${courseEventId}/user/${userId}`);
   }

  getIndividualEventSummaries(): Observable<CEUEventSummary[]> {
       return this.http.get<CEUEventSummary[]>(`${this.baseUrl}/user/ceus/event-summaries`);
   }

  getTeachingEventSummaries(): Observable<CEUEventSummary[]> {
       return this.http.get<CEUEventSummary[]>(`${this.baseUrl}/user/ceus/teaching-event-summaries`);
   }

  resolveCEUsWithQuiz(courseEventId: number, answers: QuizAnswerViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/user/ceus/courseEvents/${courseEventId}/resolve`, answers)
            .pipe(map((result: boolean) => result));
  }

  getCertificationsWithGeneratedCertificatesForForOrganization(conferenceId: number, organizationIdOrSlug: string): Observable<OrganizationCertificationViewModel[]> {
       return this.http.get<OrganizationCertificationViewModel[]>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/conferences/${conferenceId}/certifications`);
   }

  getCertificationsWithGeneratedCertificatesForForCourseEvent(courseEventId: number): Observable<OrganizationCertificationViewModel[]> {
       return this.http.get<OrganizationCertificationViewModel[]>(`${this.baseUrl}/courseEvents/${courseEventId}/certifications`);
   }

  getTeachingCertificationsWithGeneratedCertificatesForForCourseEvent(courseEventId: number): Observable<OrganizationCertificationViewModel[]> {
       return this.http.get<OrganizationCertificationViewModel[]>(`${this.baseUrl}/courseEvents/${courseEventId}/certifications/teaching`);
   }

  generateCertificateForConference(conferenceId: number, certificationBodyId: number, forceRegenerate: boolean): Observable<ConferenceCertificateViewModel> {
       return this.http.get<ConferenceCertificateViewModel>(`${this.baseUrl}/user/ceus/conferences/${conferenceId}/certificates/${certificationBodyId}?forceRegenerate=${forceRegenerate}`);
   }

  getConferenceCertificatesByOrganizationBody(conferenceId: number, certificationBodyId: number): Observable<ConferenceUserCertificateViewModelWithDetails[]> {
       return this.http.get<ConferenceUserCertificateViewModelWithDetails[]>(`${this.baseUrl}/ceus/conferences/${conferenceId}/all-certificates/${certificationBodyId}`);
   }

  getCEUPricesForBody(conferenceId: number, certificationBodyId: number): Observable<CEUPricingViewModel> {
       return this.http.get<CEUPricingViewModel>(`${this.baseUrl}/user/ceus/conferences/${conferenceId}/ceu-prices/${certificationBodyId}`);
   }

  payForCEUs(conferenceId: number, certificationBodyId: number, model: PurchaseCEUsViewModel): Observable<CEUPricingViewModel> {
       return this.http.post<CEUPricingViewModel>(`${this.baseUrl}/user/ceus/conferences/${conferenceId}/ceu-prices/${certificationBodyId}/purchase`, model)
            .pipe(map((result: CEUPricingViewModel) => result));
  }

  generateCertificateForCourseEvent(courseEventId: number, certificationBodyId: number, forceRegenerate: boolean): Observable<ConferenceCertificateViewModel> {
       return this.http.get<ConferenceCertificateViewModel>(`${this.baseUrl}/user/ceus/courseEvents/${courseEventId}/certificates/${certificationBodyId}?forceRegenerate=${forceRegenerate}`);
   }

  generateTeachingCertificateForCourseEvent(courseEventId: number, certificationBodyId: number, forceRegenerate: boolean): Observable<ConferenceCertificateViewModel> {
       return this.http.get<ConferenceCertificateViewModel>(`${this.baseUrl}/user/ceus/courseEvents/${courseEventId}/certificates/teaching/${certificationBodyId}?forceRegenerate=${forceRegenerate}`);
   }

  downloadRBTCertificateForCourseEvent(courseEventId: number, certificationBodyId: number): Observable<Blob> {
       return this.http.get(`${this.longRunningServerUrl}/user/ceus/courseEvents/${courseEventId}/certificates/${certificationBodyId}/download-rbt-cert`, {responseType: 'blob' });
   }

  downloadRBTCertificatesForConference(conferenceId: number, certificationBodyId: number): Observable<Blob> {
       return this.http.get(`${this.longRunningServerUrl}/user/ceus/conferences/${conferenceId}/certificates/${certificationBodyId}/download-rbt-cert`, {responseType: 'blob' });
   }

}
@Injectable()
export class OrganizationCMSService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getWebsitePagesForOrganization(organizationIdOrSlug: string): Observable<PageViewModel[]> {
       return this.http.get<PageViewModel[]>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/cms/pages`);
   }

  getOrganizationPage(organizationIdOrSlug: string, slug: string): Observable<PageViewModel> {
       return this.http.get<PageViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/pages/${slug}`);
   }

  getOrganizationPageById(organizationIdOrSlug: string, pageId: number): Observable<PageViewModel> {
       return this.http.get<PageViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/cms/pages/${pageId}`);
   }

  getInstructorsForNonConferenceCourseEvents(organizationIdOrSlug: string): Observable<InstructorViewModel[]> {
       return this.http.get<InstructorViewModel[]>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/cms/instructors`);
   }

}
@Injectable()
export class ConferenceCMSService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getWebsitePagesForConference(conferenceIdOrSlug: string): Observable<PageViewModel[]> {
       return this.http.get<PageViewModel[]>(`${this.baseUrl}/conferences/${conferenceIdOrSlug}/cms/pages`);
   }

  externalMemberLookup(conferenceIdOrSlug: string, packageId: number, model: StringViewModel): Observable<MemberLookupResult> {
       return this.http.post<MemberLookupResult>(`${this.baseUrl}/conferences/${conferenceIdOrSlug}/${packageId}/external-member-lookup`, model)
            .pipe(map((result: MemberLookupResult) => result));
  }

  updatePackage(packageId: number, userId: number, model: ModifyRegistrationViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/conference/users/${userId}/packages/${packageId}/modify/`, model)
            .pipe(map((result: boolean) => result));
  }

  hasRegisteredForConference(conferenceIdOrSlug: string, userId: number): Observable<UserPackagePurchaseViewModel> {
       return this.http.get<UserPackagePurchaseViewModel>(`${this.baseUrl}/conference/users/${userId}/has-registered-for-conference/${conferenceIdOrSlug}`);
   }

  externalMemberLookupCourseEvent(courseEventId: number, model: StringViewModel): Observable<MemberLookupResult> {
       return this.http.post<MemberLookupResult>(`${this.baseUrl}/courseEvents/${courseEventId}/external-member-lookup`, model)
            .pipe(map((result: MemberLookupResult) => result));
  }

  getSinglePage(conferenceId: number, pageId: number): Observable<PageViewModel> {
       return this.http.get<PageViewModel>(`${this.baseUrl}/conferences/${conferenceId}/cms/pages/${pageId}`);
   }

  getPackagesForRegistration(conferenceId: number): Observable<RegistrationPackageViewModel[]> {
       return this.http.get<RegistrationPackageViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/cms/packages`);
   }

  getPackagesForGroupRegistration(conferenceId: number, conferencePurchaseOrderId: (any|number), queryStringPackageId: (any|number), queryStringLockToPackageId: (any|number)): Observable<RegistrationPackageViewModel[]> {
       return this.http.get<RegistrationPackageViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/cms/packages/group-registration?conferencePurchaseOrderId=${conferencePurchaseOrderId}&queryStringPackageId=${queryStringPackageId}&queryStringLockToPackageId=${queryStringLockToPackageId}`);
   }

  getOrganizationPackagesForRegistration(organizationIdOrSlug: string): Observable<RegistrationPackageViewModel[]> {
       return this.http.get<RegistrationPackageViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/cms/packages`);
   }

  getPackageGroupDiscountsOnly(conferenceId: number, conferencePurchaseOrderId: (any|number)): Observable<PackageGroupDiscountViewModel[]> {
       return this.http.get<PackageGroupDiscountViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/cms/packages/discounts?conferencePurchaseOrderId=${conferencePurchaseOrderId}`);
   }

  getSingleRegistrationPackage(conferenceIdOrSlug: string, packageId: number): Observable<RegistrationPackageViewModel> {
       return this.http.get<RegistrationPackageViewModel>(`${this.baseUrl}/conferences/${conferenceIdOrSlug}/cms/packages/${packageId}`);
   }

  getSingleRegistrationPackageForGroupRegistration(conferenceIdOrSlug: string, packageId: number, conferencePurchaseOrderId: (any|number)): Observable<RegistrationPackageViewModel> {
       return this.http.get<RegistrationPackageViewModel>(`${this.baseUrl}/conferences/${conferenceIdOrSlug}/cms/packages/${packageId}/group-registration?conferencePurchaseOrderId=${conferencePurchaseOrderId}`);
   }

  getSingleRegistrationPackageForOrganization(organizationIdOrSlug: string, packageId: number): Observable<RegistrationPackageViewModel> {
       return this.http.get<RegistrationPackageViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/cms/packages/${packageId}`);
   }

  getSponsorshipLandingPages(conferenceId: number): Observable<SponsorshipLandingPageViewModel[]> {
       return this.http.get<SponsorshipLandingPageViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/cms/sponsors/landing-pages`);
   }

  getExhibitLandingPages(conferenceId: number): Observable<SponsorshipLandingPageViewModel[]> {
       return this.http.get<SponsorshipLandingPageViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/cms/exhibits/landing-pages`);
   }

  getLandingPagesForAllSponsorsAndExhibits(conferenceId: number, searchModel: SponsorListingSearchParameters): Observable<SponsorshipLandingPageViewModel[]> {
       return this.http.post<SponsorshipLandingPageViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/cms/sponsors-and-exhibits/landing-pages`, searchModel)
            .pipe(map((result: SponsorshipLandingPageViewModel[]) => result));
  }

  addConnection(conferenceId: number, toUserId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/conferences/${conferenceId}/connections/${toUserId}`, null)
            .pipe(map((result: boolean) => result));
  }

  postAnnouncement(conferenceId: number, model: ConferenceAnnouncementViewModel): Observable<ConferenceAnnouncementViewModel> {
       return this.http.post<ConferenceAnnouncementViewModel>(`${this.baseUrl}/conferences/${conferenceId}/announcements`, model)
            .pipe(map((result: ConferenceAnnouncementViewModel) => result));
  }

  updateAnnouncement(conferenceId: number, announcementId: number, model: ConferenceAnnouncementViewModel): Observable<ConferenceAnnouncementViewModel> {
       return this.http.put<ConferenceAnnouncementViewModel>(`${this.baseUrl}/conferences/${conferenceId}/announcements/${announcementId}`, model)
            .pipe(map((result: ConferenceAnnouncementViewModel) => result));
  }

  getConnections(conferenceId: number): Observable<ConferenceConnectionViewModel[]> {
       return this.http.get<ConferenceConnectionViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/connections`);
   }

  getAnnouncements(conferenceId: number): Observable<ConferenceAnnouncementViewModel[]> {
       return this.http.get<ConferenceAnnouncementViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/announcements`);
   }

  getAllAnnouncements(conferenceId: number): Observable<ConferenceAnnouncementViewModel[]> {
       return this.http.get<ConferenceAnnouncementViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/announcements-all`);
   }

  hasAnnouncementTile(conferenceId: number): Observable<boolean> {
       return this.http.get<boolean>(`${this.baseUrl}/conferences/${conferenceId}/announcements/check-mobile-tile`);
   }

  deleteAnnouncement(conferenceId: number, announcementId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/conferences/${conferenceId}/announcements/${announcementId}`);
   }

  getAnnouncementById(conferenceId: number, announcementId: number): Observable<ConferenceAnnouncementViewModel> {
       return this.http.get<ConferenceAnnouncementViewModel>(`${this.baseUrl}/conferences/${conferenceId}/announcements/${announcementId}`);
   }

  approveConnection(conferenceId: number, fromUserId: number): Observable<boolean> {
       return this.http.get<boolean>(`${this.baseUrl}/conferences/${conferenceId}/connections/${fromUserId}/approve`);
   }

  checkConnection(conferenceId: number, fromUserId: number): Observable<boolean> {
       return this.http.get<boolean>(`${this.baseUrl}/conferences/${conferenceId}/connections/${fromUserId}/check`);
   }

  isConferenceAdmin(conferenceId: number): Observable<boolean> {
       return this.http.get<boolean>(`${this.baseUrl}/conferences/${conferenceId}/conference-admin`);
   }

  getChats(conferenceId: number): Observable<ConferenceChatViewModel[]> {
       return this.http.get<ConferenceChatViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/chats`);
   }

  getChatRooms(conferenceId: number): Observable<ConferenceChatViewModel[]> {
       return this.http.get<ConferenceChatViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/chat-rooms`);
   }

  addChat(conferenceId: number, membersViewModel: ChatMembersViewModel): Observable<ConferenceChatViewModel> {
       return this.http.post<ConferenceChatViewModel>(`${this.baseUrl}/conferences/${conferenceId}/chats`, membersViewModel)
            .pipe(map((result: ConferenceChatViewModel) => result));
  }

  addChatRoom(conferenceId: number, model: CreateChatroomViewModel): Observable<ConferenceChatViewModel> {
       return this.http.post<ConferenceChatViewModel>(`${this.baseUrl}/conferences/${conferenceId}/chat-rooms`, model)
            .pipe(map((result: ConferenceChatViewModel) => result));
  }

  joinChatRoom(conferenceId: number, chatRoomId: number): Observable<ConferenceChatViewModel> {
       return this.http.post<ConferenceChatViewModel>(`${this.baseUrl}/conferences/${conferenceId}/chat-rooms/${chatRoomId}/join`, null)
            .pipe(map((result: ConferenceChatViewModel) => result));
  }

  approveChatRoom(conferenceId: number, chatRoomId: number): Observable<ConferenceChatViewModel> {
       return this.http.post<ConferenceChatViewModel>(`${this.baseUrl}/conferences/${conferenceId}/chat-rooms/${chatRoomId}/approve`, null)
            .pipe(map((result: ConferenceChatViewModel) => result));
  }

  deleteChatRoom(conferenceId: number, chatRoomId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/conferences/${conferenceId}/chat-rooms/${chatRoomId}`);
   }

  leaveChatRoom(conferenceId: number, chatRoomId: number): Observable<ConferenceChatViewModel> {
       return this.http.delete<ConferenceChatViewModel>(`${this.baseUrl}/conferences/${conferenceId}/chat-rooms/${chatRoomId}/join`);
   }

  getMessagesForChatGroup(conferenceId: number, chatGroupId: number): Observable<ConferenceChatMessageViewModel[]> {
       return this.http.get<ConferenceChatMessageViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/chats/${chatGroupId}`);
   }

  getSingleGuestRoomPerson(conferenceIdOrSlug: string, userId: number): Observable<ConferenceSpeakerViewModel> {
       return this.http.get<ConferenceSpeakerViewModel>(`${this.baseUrl}/organization/conferences/${conferenceIdOrSlug}/people/guest-rooms/${userId}`);
   }

  getConferencePurchaseOrderForEditByLinkUniqueId(model: StringViewModel): Observable<AddEditConferencePurchaseOrderViewModel> {
       return this.http.post<AddEditConferencePurchaseOrderViewModel>(`${this.baseUrl}/conferences/conferencePurchaseOrders/getByLink`, model)
            .pipe(map((result: AddEditConferencePurchaseOrderViewModel) => result));
  }

  addConferenceAnalytics(conferenceId: number, model: ConferenceAnalyticsViewModel): Observable<ConferenceAnalyticsViewModel> {
       return this.http.post<ConferenceAnalyticsViewModel>(`${this.baseUrl}/conferences/${conferenceId}/analytics`, model)
            .pipe(map((result: ConferenceAnalyticsViewModel) => result));
  }

  getEventMaterialsForConference(conferenceId: number): Observable<CourseEventWithMaterialsViewModel[]> {
       return this.http.get<CourseEventWithMaterialsViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/event-materials`);
   }

}
@Injectable()
export class CourseService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getAll(tagFilter: string, onlyShowPublished: boolean): Observable<CourseViewModel[]> {
       return this.http.get<CourseViewModel[]>(`${this.baseUrl}/courses/?tagFilter=${tagFilter}&onlyShowPublished=${onlyShowPublished}`);
   }

  search(parameters: CourseSearchParameters): Observable<CourseSearchResultsViewModel> {
       return this.http.post<CourseSearchResultsViewModel>(`${this.baseUrl}/courses/search`, parameters)
            .pipe(map((result: CourseSearchResultsViewModel) => result));
  }

  searchCoursesPaged(organizationId: number, parameters: OnDemandSearchParameters, page: number, pageSize: number): Observable<PagedResult<CourseViewModelSimple>> {
       return this.http.post<PagedResult<CourseViewModelSimple>>(`${this.baseUrl}/organizations/${organizationId}/courses/search-paged?page=${page}&pageSize=${pageSize}`, parameters)
            .pipe(map((result: PagedResult<CourseViewModelSimple>) => result));
  }

  getFilterData(): Observable<SearchFilterDataModel> {
       return this.http.post<SearchFilterDataModel>(`${this.baseUrl}/courses/get-filter-data`, null)
            .pipe(map((result: SearchFilterDataModel) => result));
  }

  getFilterDataForUser(): Observable<SearchFilterDataModel> {
       return this.http.post<SearchFilterDataModel>(`${this.baseUrl}/courses/get-filter-data/users`, null)
            .pipe(map((result: SearchFilterDataModel) => result));
  }

  getCoursesForInstructor(instructorIdOrSlug: string): Observable<CourseViewModelSimple[]> {
       return this.http.get<CourseViewModelSimple[]>(`${this.baseUrl}/instructors/${instructorIdOrSlug}/courses`);
   }

  getFeatured(count: number): Observable<CourseViewModelSimple[]> {
       return this.http.get<CourseViewModelSimple[]>(`${this.baseUrl}/courses/featured?count=${count}`);
   }

  createCourse(model: CreateCourseViewModel): Observable<CourseViewModel> {
       return this.http.post<CourseViewModel>(`${this.baseUrl}/courses/`, model)
            .pipe(map((result: CourseViewModel) => result));
  }

  updateCourse(courseId: number, model: CreateCourseViewModel): Observable<CourseViewModel> {
       return this.http.put<CourseViewModel>(`${this.baseUrl}/courses/${courseId}`, model)
            .pipe(map((result: CourseViewModel) => result));
  }

  getCourseUserCompletionStatus(courseId: number): Observable<CourseCompletionViewModel> {
       return this.http.get<CourseCompletionViewModel>(`${this.baseUrl}/courses/${courseId}/completion-status/`);
   }

  checkPromoCode(courseEventId: number, model: StringViewModel): Observable<PromoCodeResultViewModel> {
       return this.http.put<PromoCodeResultViewModel>(`${this.baseUrl}/courseEvents/${courseEventId}/checkPromoCode`, model)
            .pipe(map((result: PromoCodeResultViewModel) => result));
  }

  getSpecificCourse(courseIdOrSlug: string): Observable<CourseViewModel> {
       return this.http.get<CourseViewModel>(`${this.baseUrl}/courses/${courseIdOrSlug}`);
   }

  getSpecificCourseOverrideAccess(courseIdOrSlug: string): Observable<CourseViewModel> {
       return this.http.get<CourseViewModel>(`${this.baseUrl}/courses/${courseIdOrSlug}/overrideAccess`);
   }

  getReviews(courseId: number): Observable<CourseReviewViewModel[]> {
       return this.http.get<CourseReviewViewModel[]>(`${this.baseUrl}/courses/${courseId}/reviews`);
   }

  purchase(courseId: number, cardToken: CardTokenViewModel): Observable<CourseViewModel> {
       return this.http.post<CourseViewModel>(`${this.baseUrl}/courses/${courseId}/Purchase/`, cardToken)
            .pipe(map((result: CourseViewModel) => result));
  }

  getSegmentStatus(courseId: number): Observable<SegmentProgressViewModel[]> {
       return this.http.get<SegmentProgressViewModel[]>(`${this.baseUrl}/courses/${courseId}/segmentStatus/`);
   }

  updateSegmentStatus(courseId: number, courseSegmentId: number, segmentStatus: any): Observable<SegmentProgressViewModel> {
       return this.http.post<SegmentProgressViewModel>(`${this.baseUrl}/courses/${courseId}/segmentStatus/${courseSegmentId}`, segmentStatus)
            .pipe(map((result: SegmentProgressViewModel) => result));
  }

  updateSegmentPlayhead(courseId: number, courseSegmentId: number, playheadLocation: number): Observable<SegmentProgressViewModel> {
       return this.http.post<SegmentProgressViewModel>(`${this.baseUrl}/courses/${courseId}/segments/${courseSegmentId}/playhead`, playheadLocation)
            .pipe(map((result: SegmentProgressViewModel) => result));
  }

  updatePlayhead(courseId: number, playheadLocation: number): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/courses/${courseId}/playhead`, playheadLocation)
            .pipe(map((result: boolean) => result));
  }

  getPLayheadLocation(courseId: number): Observable<PlayheadLocationModel> {
       return this.http.get<PlayheadLocationModel>(`${this.baseUrl}/courses/${courseId}/playhead`);
   }

}
@Injectable()
export class EducationService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  createExternalEducationEntry(userId: number, certificationBodyId: number, model: ExternalEducationViewModel): Observable<ExternalEducationViewModel> {
       return this.http.post<ExternalEducationViewModel>(`${this.baseUrl}/users/${userId}/certification-body/${certificationBodyId}/external-education`, model)
            .pipe(map((result: ExternalEducationViewModel) => result));
  }

  updateExternalEducationEntry(externalEducationId: number, model: ExternalEducationViewModel): Observable<ExternalEducationViewModel> {
       return this.http.put<ExternalEducationViewModel>(`${this.baseUrl}/external-education/${externalEducationId}`, model)
            .pipe(map((result: ExternalEducationViewModel) => result));
  }

  getExternalEducationEntry(externalEducationId: number): Observable<ExternalEducationViewModel> {
       return this.http.get<ExternalEducationViewModel>(`${this.baseUrl}/external-education/${externalEducationId}`);
   }

  deleteExternalEducationEntry(externalEducationId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/external-education/${externalEducationId}`);
   }

  getEducationResultsPaged(userId: number, certificationBodyId: number, model: EducationSearchParameters): Observable<PagedResult<EducationResultsViewModel>> {
       return this.http.post<PagedResult<EducationResultsViewModel>>(`${this.baseUrl}/education-tracking/users/${userId}/certification-body/${certificationBodyId}/paged/`, model)
            .pipe(map((result: PagedResult<EducationResultsViewModel>) => result));
  }

  getEducationTrackingProgress(userId: number, certificationBodyId: number): Observable<EducationTrackingProgressViewModel> {
       return this.http.get<EducationTrackingProgressViewModel>(`${this.baseUrl}/users/${userId}/certification-body/${certificationBodyId}/education-tracking-progress`);
   }

}
@Injectable()
export class EventService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getAll(eventSearchParameters: EventSearchParameters): Observable<EventViewModel[]> {
       return this.http.post<EventViewModel[]>(`${this.baseUrl}/events/search`, eventSearchParameters)
            .pipe(map((result: EventViewModel[]) => result));
  }

  getAllEventsPaged(currentPage: number, pageSize: number, eventSearchParameters: EventSearchParameters): Observable<PagedResult<EventConferenceItemListing>> {
       return this.http.post<PagedResult<EventConferenceItemListing>>(`${this.baseUrl}/events/search/paged?currentPage=${currentPage}&pageSize=${pageSize}`, eventSearchParameters)
            .pipe(map((result: PagedResult<EventConferenceItemListing>) => result));
  }

  getConferenceSimple(conferenceId: number): Observable<ConferenceViewModelSimple> {
       return this.http.get<ConferenceViewModelSimple>(`${this.baseUrl}/events/conferences/${conferenceId}/basics`);
   }

  getUpcomingConferences(onlyShowPublished: boolean): Observable<ConferenceViewModelSimple[]> {
       return this.http.get<ConferenceViewModelSimple[]>(`${this.baseUrl}/events/conferences?onlyShowPublished=${onlyShowPublished}`);
   }

  getUpcomingConferencesCachable(onlyShowPublished: boolean): Observable<ConferenceViewModelSimple[]> {
       return this.http.get<ConferenceViewModelSimple[]>(`${this.baseUrl}/events/conferences/cacheable?onlyShowPublished=${onlyShowPublished}`);
   }

  getAllConferences(): Observable<ConferenceViewModelSimple[]> {
       return this.http.get<ConferenceViewModelSimple[]>(`${this.baseUrl}/events/conferences/all`);
   }

  getPastConferences(): Observable<ConferenceViewModelSimple[]> {
       return this.http.get<ConferenceViewModelSimple[]>(`${this.baseUrl}/events/conferences/past`);
   }

  searchConferences(searchParameters: BasicSearchParameters): Observable<ConferenceViewModelSimple[]> {
       return this.http.post<ConferenceViewModelSimple[]>(`${this.baseUrl}/events/conferences/search`, searchParameters)
            .pipe(map((result: ConferenceViewModelSimple[]) => result));
  }

  getEventsForInstructor(instructorIdOrSlug: string): Observable<EventViewModel[]> {
       return this.http.get<EventViewModel[]>(`${this.baseUrl}/instructors/${instructorIdOrSlug}/events`);
   }

  getUserScheduledEvent(eventIdOrSlug: string): Observable<EventViewModel> {
       return this.http.get<EventViewModel>(`${this.baseUrl}/users/events/${eventIdOrSlug}`);
   }

  scheduleUserEvent(model: ScheduleUserEventViewModel): Observable<EventViewModel> {
       return this.http.post<EventViewModel>(`${this.baseUrl}/events/`, model)
            .pipe(map((result: EventViewModel) => result));
  }

  updateUserEvent(eventId: number, model: ScheduleUserEventViewModel): Observable<EventViewModel> {
       return this.http.put<EventViewModel>(`${this.baseUrl}/events/${eventId}`, model)
            .pipe(map((result: EventViewModel) => result));
  }

  getSpecificEvent(eventIdOrSlug: string): Observable<EventDisplayViewModel> {
       return this.http.get<EventDisplayViewModel>(`${this.baseUrl}/events/${eventIdOrSlug}`);
   }

  getSpecificCourseEvent(eventIdOrSlug: string): Observable<CourseEventViewModel> {
       return this.http.get<CourseEventViewModel>(`${this.baseUrl}/course-events/${eventIdOrSlug}`);
   }

  getLiveEvent(eventIdOrSlug: string): Observable<LiveEventViewModel> {
       return this.http.get<LiveEventViewModel>(`https://bxlimages.blob.core.windows.net/live-event-cache/${eventIdOrSlug}-liveEvent.json?v=`+ UUID.UUID())
            .pipe(catchError(() => {return this.http.get<LiveEventViewModel>(`${this.baseUrl}/events/${eventIdOrSlug}/live`)}));
   }

  getLiveEventIgnoreCache(eventIdOrSlug: string): Observable<LiveEventViewModel> {
       return this.http.get<LiveEventViewModel>(`${this.baseUrl}/events/${eventIdOrSlug}/live`);
   }

  getChatHistory(eventId: number): Observable<ChatHistoryViewModel[]> {
       return this.http.get<ChatHistoryViewModel[]>(`${this.baseUrl}/events/${eventId}/chatHistory`);
   }

  getQuestionHistory(eventId: number): Observable<QuestionHistoryViewModel[]> {
       return this.http.get<QuestionHistoryViewModel[]>(`${this.baseUrl}/events/${eventId}/questionHistory`);
   }

  getQuestionHistoryForTitles(eventId: number, filterBySelected: boolean): Observable<QuestionHistoryTitlesViewModel[]> {
       return this.http.get<QuestionHistoryTitlesViewModel[]>(`${this.baseUrl}/events/${eventId}/questionHistory/titles?filterBySelected=${filterBySelected}`);
   }

  deleteMaterial(eventId: number, materialId: number): Observable<MaterialViewModel> {
       return this.http.delete<MaterialViewModel>(`${this.baseUrl}/events/${eventId}/materials/${materialId}`);
   }

  createMaterial(eventId: number, model: MaterialViewModel): Observable<MaterialViewModel> {
       return this.http.post<MaterialViewModel>(`${this.baseUrl}/events/${eventId}/materials`, model)
            .pipe(map((result: MaterialViewModel) => result));
  }

  getMaterials(eventId: number): Observable<MaterialViewModel[]> {
       return this.http.get<MaterialViewModel[]>(`${this.baseUrl}/events/${eventId}/materials`);
   }

  addQuestion(eventId: number, model: StringViewModel): Observable<QuestionHistoryViewModel> {
       return this.http.post<QuestionHistoryViewModel>(`${this.baseUrl}/events/${eventId}/questions`, model)
            .pipe(map((result: QuestionHistoryViewModel) => result));
  }

  registerExistingUser(eventId: number, model: RegisterUserViewModel): Observable<EventViewModel> {
       return this.http.post<EventViewModel>(`${this.baseUrl}/events/${eventId}/registerCurrentUser/`, model)
            .pipe(map((result: EventViewModel) => result));
  }

  completeLinkedInRegistrationViaOauth(code: string, state: string): Observable<UserProfileViewModel> {
       return this.http.get<UserProfileViewModel>(`${this.baseUrl}/users/linked-in/complete-oauth?code=${code}`);
   }

  purchasePackage(packageId: number, model: PurchasePackageViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/packages/${packageId}/purchase/`, model)
            .pipe(map((result: boolean) => result));
  }

  updatePackage(packageId: number, model: ModifyRegistrationViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/packages/${packageId}/purchase/`, model)
            .pipe(map((result: boolean) => result));
  }

  purchaseGroupRegistration(conferenceId: number, model: AddEditConferencePurchaseOrderViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/conferences/${conferenceId}/purchase-group/`, model)
            .pipe(map((result: boolean) => result));
  }

  isDuplicateConferencePurchaseOrder(conferenceId: number, email: string): Observable<boolean> {
       return this.http.get<boolean>(`${this.baseUrl}/conferences/${conferenceId}/is-purchase-order-duplicate/?email=${email}`);
   }

  updateConferencePurchaseOrder(conferencePurchaseOrderId: number, model: AddEditConferencePurchaseOrderViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/conferences/conferencePurchaseOrders/${conferencePurchaseOrderId}`, model)
            .pipe(map((result: boolean) => result));
  }

  getGroupRegistrationTotals(conferenceId: number, model: AddEditConferencePurchaseOrderViewModel): Observable<ConferencePurchaseOrderTotalsViewModel> {
       return this.http.post<ConferencePurchaseOrderTotalsViewModel>(`${this.baseUrl}/conferences/${conferenceId}/groupRegistrationTotals`, model)
            .pipe(map((result: ConferencePurchaseOrderTotalsViewModel) => result));
  }

  checkPackagePromoCode(packageId: number, model: StringViewModel): Observable<PromoCodeResultViewModel> {
       return this.http.put<PromoCodeResultViewModel>(`${this.baseUrl}/packages/${packageId}/checkPromoCode`, model)
            .pipe(map((result: PromoCodeResultViewModel) => result));
  }

  checkPromoCodeForGroupRegistrant(model: PromoCodeCheckViewModel): Observable<PromoCodeResultViewModel> {
       return this.http.put<PromoCodeResultViewModel>(`${this.baseUrl}/packages/checkPromoCode/groupRegistrant`, model)
            .pipe(map((result: PromoCodeResultViewModel) => result));
  }

  addTipToEvent(eventId: number, model: TipViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/events/${eventId}/tips/`, model)
            .pipe(map((result: boolean) => result));
  }

  completeEvent(eventId: number, model: CreateReviewViewModel): Observable<EventCompletionViewModel> {
       return this.http.post<EventCompletionViewModel>(`${this.baseUrl}/events/${eventId}/complete/`, model)
            .pipe(map((result: EventCompletionViewModel) => result));
  }

  addAPAEvaluation(courseEventId: number, model: APAEvaluationViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/courseEvents/${courseEventId}/apa-evaluation/`, model)
            .pipe(map((result: boolean) => result));
  }

  addCEUScanReview(eventId: number, model: CreateReviewViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/events/${eventId}/ceu-scan-review/`, model)
            .pipe(map((result: boolean) => result));
  }

  submitToken(eventId: number, tokenNumber: number, model: StringViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/events/${eventId}/submitToken/${tokenNumber}`, model)
            .pipe(map((result: boolean) => result));
  }

  getEventUserCompletionStatus(eventId: number): Observable<EventCompletionViewModel> {
       return this.http.get<EventCompletionViewModel>(`${this.baseUrl}/events/${eventId}/completion-status/`);
   }

  slideControl(key: string): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/slidecontrol?key=${key}`, null)
            .pipe(map((result: boolean) => result));
  }

}
@Injectable()
export class EventVideoService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getVideosForEvent(eventId: number): Observable<EventVideoViewModel[]> {
       return this.http.get<EventVideoViewModel[]>(`${this.baseUrl}/events/${eventId}/videos`);
   }

  updateVideoVisibility(eventId: number, videoId: number, visible: boolean): Observable<EventVideoViewModel> {
       return this.http.post<EventVideoViewModel>(`${this.baseUrl}/events/${eventId}/videos/${videoId}/visibility?visible=${visible}`, null)
            .pipe(map((result: EventVideoViewModel) => result));
  }

  getSASForAssetContainer(eventId: number): Observable<AzureBlobSASViewModel> {
       return this.http.get<AzureBlobSASViewModel>(`${this.baseUrl}/events/${eventId}/sas`);
   }

  uploadComplete(eventId: number, model: AzureBlobSASViewModel): Observable<EventVideoViewModel> {
       return this.http.post<EventVideoViewModel>(`${this.baseUrl}/events/${eventId}/uploadComplete`, model)
            .pipe(map((result: EventVideoViewModel) => result));
  }

}
@Injectable()
export class ExhibitService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getExhibitsForUser(): Observable<ExhibitSummaryViewModel[]> {
       return this.http.get<ExhibitSummaryViewModel[]>(`${this.baseUrl}/exhibits`);
   }

  getExhibitsForConference(conferenceId: number): Observable<ExhibitDesignerViewModel[]> {
       return this.http.get<ExhibitDesignerViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/exhibits`);
   }

  getExhibitById(exhibitId: number): Observable<ExhibitDesignerViewModel> {
       return this.http.get<ExhibitDesignerViewModel>(`${this.baseUrl}/exhibits/${exhibitId}`);
   }

  getActiveUsers(exhibitId: number): Observable<ActiveExhibitUserViewModel[]> {
       return this.http.get<ActiveExhibitUserViewModel[]>(`${this.baseUrl}/exhibits/${exhibitId}/active-users`);
   }

  updateExhibitNotes(exhibitId: number, userId: number, model: StringViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/exhibits/${exhibitId}/active-users/${userId}/notes`, model)
            .pipe(map((result: boolean) => result));
  }

  linkExhibitUser(exhibitId: number, userId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/exhibits/${exhibitId}/users/${userId}`, null)
            .pipe(map((result: boolean) => result));
  }

  checkIn(exhibitId: number): Observable<ActiveExhibitUserViewModel> {
       return this.http.post<ActiveExhibitUserViewModel>(`${this.baseUrl}/exhibits/${exhibitId}/checkin`, null)
            .pipe(map((result: ActiveExhibitUserViewModel) => result));
  }

  logVisitor(model: LogExhibitVisitModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/exhibits/log-visitor`, model)
            .pipe(map((result: boolean) => result));
  }

  websiteClicked(exhibitId: number): Observable<ActiveExhibitUserViewModel> {
       return this.http.post<ActiveExhibitUserViewModel>(`${this.baseUrl}/exhibits/${exhibitId}/website-clicked`, null)
            .pipe(map((result: ActiveExhibitUserViewModel) => result));
  }

  filesDownloaded(exhibitId: number): Observable<ActiveExhibitUserViewModel> {
       return this.http.post<ActiveExhibitUserViewModel>(`${this.baseUrl}/exhibits/${exhibitId}/downloaded-files`, null)
            .pipe(map((result: ActiveExhibitUserViewModel) => result));
  }

  exportUserData(exhibitId: number): Observable<Blob> {
       return this.http.get(`${this.longRunningServerUrl}/exhibits/${exhibitId}/export`, {responseType: 'blob' });
   }

  turnedOnCamera(exhibitId: number): Observable<ActiveExhibitUserViewModel> {
       return this.http.post<ActiveExhibitUserViewModel>(`${this.baseUrl}/exhibits/${exhibitId}/turned-on-camera`, null)
            .pipe(map((result: ActiveExhibitUserViewModel) => result));
  }

  updateExhibit(exhibitId: number, model: UpdateExhibitViewModel): Observable<PosterViewModel> {
       return this.http.put<PosterViewModel>(`${this.baseUrl}/exhibits/${exhibitId}`, model)
            .pipe(map((result: PosterViewModel) => result));
  }

  getOpenTokToken(exhibitId: number): Observable<OpenTokAuthModel> {
       return this.http.get<OpenTokAuthModel>(`${this.baseUrl}/exhibits/${exhibitId}/opentok-token`);
   }

}
@Injectable()
export class FABAPayoutService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  downloadReport(organizationIdOrSlug: string, year: number, month: number): Observable<Blob> {
       return this.http.get<Blob>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/payout-report?year=${year}&month=${month}`);
   }

}
@Injectable()
export class FileService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getSASForVideoContainer(filename: string, container: string): Observable<AzureBlobSASViewModel> {
       return this.http.post<AzureBlobSASViewModel>(`${this.baseUrl}/azure-sas?filename=${filename}&container=${container}`, null)
            .pipe(map((result: AzureBlobSASViewModel) => result));
  }

}
@Injectable()
export class InstructorService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getAll(onlyShowFeatured: boolean): Observable<InstructorViewModel[]> {
       return this.http.get<InstructorViewModel[]>(`${this.baseUrl}/instructors/?onlyShowFeatured=${onlyShowFeatured}`);
   }

  getAllNameValue(onlyShowFeatured: boolean): Observable<NameValuePair[]> {
       return this.http.get<NameValuePair[]>(`${this.baseUrl}/instructors/name-value?onlyShowFeatured=${onlyShowFeatured}`);
   }

  getInstructorsForConference(conferenceId: number): Observable<InstructorViewModel[]> {
       return this.http.get<InstructorViewModel[]>(`${this.baseUrl}/conference/${conferenceId}/instructors/`);
   }

  getById(instructorIdOrSlug: string): Observable<InstructorViewModel> {
       return this.http.get<InstructorViewModel>(`${this.baseUrl}/instructors/${instructorIdOrSlug}`);
   }

  getSimilar(instructorIdOrSlug: string, count: number): Observable<InstructorViewModel[]> {
       return this.http.get<InstructorViewModel[]>(`${this.baseUrl}/instructors/${instructorIdOrSlug}/similar?count=${count}`);
   }

  getSimilarInstructorsForOrganization(instructorIdOrSlug: string, organizationIdOrSlug: string, count: number): Observable<InstructorViewModel[]> {
       return this.http.get<InstructorViewModel[]>(`${this.baseUrl}/instructors/${instructorIdOrSlug}/similar/${organizationIdOrSlug}?count=${count}`);
   }

  create(model: CreateInstructorViewModel): Observable<InstructorViewModel> {
       return this.http.post<InstructorViewModel>(`${this.baseUrl}/instructors/`, model)
            .pipe(map((result: InstructorViewModel) => result));
  }

  mergeUser(model: MergeInstructorViewModel): Observable<InstructorViewModel> {
       return this.http.post<InstructorViewModel>(`${this.baseUrl}/instructors/merge`, model)
            .pipe(map((result: InstructorViewModel) => result));
  }

  update(instructorId: number, model: CreateInstructorViewModel): Observable<InstructorViewModel> {
       return this.http.put<InstructorViewModel>(`${this.baseUrl}/instructors/${instructorId}`, model)
            .pipe(map((result: InstructorViewModel) => result));
  }

}
@Injectable()
export class JobsService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getRecentSearches(count: number, sessionId: string, currentSessionId: string): Observable<JobSearchHistoryParameters[]> {
       return this.http.get<JobSearchHistoryParameters[]>(`${this.baseUrl}/jobs/recentsearches/${count}/session/${sessionId}/currentSessionId/${currentSessionId}`);
   }

  getExternalApplicationDataExport(organizationIdOrSlug: string): Observable<Blob> {
       return this.http.get(`${this.longRunningServerUrl}/organization/${organizationIdOrSlug}/reporting/hiring/external-applications/export`, {responseType: 'blob' });
   }

  getInternalApplicationDataExport(organizationIdOrSlug: string): Observable<Blob> {
       return this.http.get(`${this.longRunningServerUrl}/organization/${organizationIdOrSlug}/reporting/hiring/internal-applications/export`, {responseType: 'blob' });
   }

  apply(jobId: number, clientIdentifier: string, jobApplicationViewModel: JobApplicationViewModel): Observable<JobSearchResultsViewModel> {
       return this.http.post<JobSearchResultsViewModel>(`${this.baseUrl}/jobs/${jobId}/${clientIdentifier}/apply`, jobApplicationViewModel)
            .pipe(map((result: JobSearchResultsViewModel) => result));
  }

  searchApplicationsForOrganization(organizationIdOrSlug: string, parameters: BasicSearchParameters, page: number): Observable<PagedResult<JobApplicationViewModel>> {
       return this.http.post<PagedResult<JobApplicationViewModel>>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/jobs/applications?page=${page}`, parameters)
            .pipe(map((result: PagedResult<JobApplicationViewModel>) => result));
  }

  search(parameters: JobSearchParameters): Observable<JobSearchResultsViewModel> {
       return this.http.post<JobSearchResultsViewModel>(`${this.baseUrl}/jobs/search`, parameters)
            .pipe(map((result: JobSearchResultsViewModel) => result));
  }

  deleteFavorite(jobId: number): Observable<JobViewModel[]> {
       return this.http.delete<JobViewModel[]>(`${this.baseUrl}/jobs/${jobId}/favorite`);
   }

  setFavorite(jobId: number): Observable<JobViewModel[]> {
       return this.http.post<JobViewModel[]>(`${this.baseUrl}/jobs/${jobId}/favorite`, null)
            .pipe(map((result: JobViewModel[]) => result));
  }

  getAllLocations(organizationIdOrSlug: string): Observable<LocationViewModel[]> {
       return this.http.get<LocationViewModel[]>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/locations/`);
   }

  getJobStatistics(organizationIdOrSlug: string, period: any): Observable<JobStatisticsModel> {
       return this.http.get<JobStatisticsModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/statistics/?period=${period}`);
   }

  delete(organizationIdOrSlug: string, locationId: number): Observable<LocationViewModel> {
       return this.http.delete<LocationViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/locations/${locationId}`);
   }

  createJob(organizationIdOrSlug: string, model: CreateJobViewModel): Observable<JobViewModel> {
       return this.http.post<JobViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/jobs/`, model)
            .pipe(map((result: JobViewModel) => result));
  }

  cloneJob(organizationIdOrSlug: string, jobId: number): Observable<JobViewModel> {
       return this.http.post<JobViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/jobs/${jobId}/clone`, null)
            .pipe(map((result: JobViewModel) => result));
  }

  closeJob(organizationIdOrSlug: string, jobId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/jobs/${jobId}`);
   }

  updateJob(organizationIdOrSlug: string, jobId: number, model: CreateJobViewModel): Observable<JobViewModel> {
       return this.http.post<JobViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/jobs/${jobId}`, model)
            .pipe(map((result: JobViewModel) => result));
  }

  getSingleLocation(organizationIdOrSlug: string, locationId: number): Observable<LocationViewModel> {
       return this.http.get<LocationViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/locations/${locationId}`);
   }

  createLocation(organizationIdOrSlug: string, model: CreateLocationViewModel): Observable<LocationViewModel> {
       return this.http.post<LocationViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/locations`, model)
            .pipe(map((result: LocationViewModel) => result));
  }

  updateLocation(organizationIdOrSlug: string, locationId: number, model: CreateLocationViewModel): Observable<LocationViewModel> {
       return this.http.put<LocationViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/locations/${locationId}`, model)
            .pipe(map((result: LocationViewModel) => result));
  }

  getSingleJob(jobId: number): Observable<JobViewModel> {
       return this.http.get<JobViewModel>(`${this.baseUrl}/jobs/${jobId}`);
   }

  getSimilarJobs(jobId: number, count: number): Observable<JobSearchResultViewModel[]> {
       return this.http.get<JobSearchResultViewModel[]>(`${this.baseUrl}/jobs/${jobId}/similar?count=${count}`);
   }

  getSimilarCompanies(organizationIdOrSlug: string, count: number): Observable<CompanyViewModel[]> {
       return this.http.get<CompanyViewModel[]>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/similar?count=${count}`);
   }

  getCompanyById(organizationIdOrSlug: string): Observable<CompanyViewModel> {
       return this.http.get<CompanyViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/hiring-profile`);
   }

  getJobsWithSummaries(organizationIdOrSlug: string): Observable<JobWithSummaryViewModel[]> {
       return this.http.get<JobWithSummaryViewModel[]>(`${this.baseUrl}/ogranizations/${organizationIdOrSlug}/jobs/summary/`);
   }

  updateCompany(organizationIdOrSlug: string, model: UpdateCompanyModel): Observable<CompanyViewModel> {
       return this.http.put<CompanyViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/hiring-profile`, model)
            .pipe(map((result: CompanyViewModel) => result));
  }

}
@Injectable()
export class LiveEventService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getChannelStatus(eventId: number): Observable<string> {
       return this.http.get<string>(`${this.baseUrl}/events/${eventId}/channelStatus`);
   }

  getSignalRData(eventId: number): Observable<LiveEventDashboardViewModel> {
       return this.http.get<LiveEventDashboardViewModel>(`${this.baseUrl}/events/${eventId}/signalR`);
   }

  requestSupport(eventId: number): Observable<LiveEventDashboardViewModel> {
       return this.http.get<LiveEventDashboardViewModel>(`${this.baseUrl}/events/${eventId}/request-support`);
   }

  startChannel(eventId: number): Observable<string> {
       return this.http.get<string>(`${this.baseUrl}/events/${eventId}/start`);
   }

  stopChannel(eventId: number): Observable<string> {
       return this.http.get<string>(`${this.baseUrl}/events/${eventId}/stop`);
   }

  startStreaming(eventId: number): Observable<StringViewModel> {
       return this.http.get<StringViewModel>(`${this.baseUrl}/events/${eventId}/startStreaming`);
   }

  scheduleCEUChecks(eventId: number): Observable<boolean> {
       return this.http.get<boolean>(`${this.baseUrl}/events/${eventId}/scheduleCEUChecks`);
   }

  getDashboard(eventId: number): Observable<EventDashboardViewModel> {
       return this.http.get<EventDashboardViewModel>(`https://bxlimages.blob.core.windows.net/live-event-cache/${eventId}-dashboard.json?v=`+ UUID.UUID())
            .pipe(catchError(() => {return this.http.get<EventDashboardViewModel>(`${this.baseUrl}/events/${eventId}/dashboard`)}));
   }

  getDashboardIgnoreCache(eventId: number): Observable<EventDashboardViewModel> {
       return this.http.get<EventDashboardViewModel>(`${this.baseUrl}/events/${eventId}/dashboard`);
   }

  setOpenForCEUs(eventId: number, val: boolean): Observable<BooleanViewModel> {
       return this.http.post<BooleanViewModel>(`${this.baseUrl}/events/${eventId}/openForCEUs?val=${val}`, null)
            .pipe(map((result: BooleanViewModel) => result));
  }

  startWebRTCStream(eventId: number): Observable<LiveEventViewModel> {
       return this.http.post<LiveEventViewModel>(`${this.baseUrl}/events/${eventId}/startStreaming`, null)
            .pipe(map((result: LiveEventViewModel) => result));
  }

  testConnection(eventId: number, userId: number): Observable<EventVideoViewModel[]> {
       return this.http.get<EventVideoViewModel[]>(`${this.baseUrl}/events/${eventId}/testconneciton/${userId}`);
   }

  startOpenTokStreamOnly(eventId: number): Observable<LiveEventViewModel> {
       return this.http.post<LiveEventViewModel>(`${this.baseUrl}/events/${eventId}/startOpenTokStreamOnly`, null)
            .pipe(map((result: LiveEventViewModel) => result));
  }

  startOpenTokRTMPOnly(eventId: number): Observable<LiveEventViewModel> {
       return this.http.post<LiveEventViewModel>(`${this.baseUrl}/events/${eventId}/startOpenTokRTMPOnly`, null)
            .pipe(map((result: LiveEventViewModel) => result));
  }

  stopOpenTokRTMP(eventId: number): Observable<LiveEventViewModel> {
       return this.http.post<LiveEventViewModel>(`${this.baseUrl}/events/${eventId}/stopOpenTokRTMP`, null)
            .pipe(map((result: LiveEventViewModel) => result));
  }

  startOpenTokArchiveOnly(eventId: number): Observable<LiveEventViewModel> {
       return this.http.post<LiveEventViewModel>(`${this.baseUrl}/events/${eventId}/startOpenTokArchiveOnly`, null)
            .pipe(map((result: LiveEventViewModel) => result));
  }

  stopOpenTokArchiveOnly(eventId: number): Observable<LiveEventViewModel> {
       return this.http.post<LiveEventViewModel>(`${this.baseUrl}/events/${eventId}/stopOpenTokArchiveOnly`, null)
            .pipe(map((result: LiveEventViewModel) => result));
  }

  switchToYouTube(eventId: number): Observable<LiveEventViewModel> {
       return this.http.post<LiveEventViewModel>(`${this.baseUrl}/events/${eventId}/switchToYouTube`, null)
            .pipe(map((result: LiveEventViewModel) => result));
  }

  failoverToOpenTok(eventId: number): Observable<LiveEventViewModel> {
       return this.http.post<LiveEventViewModel>(`${this.baseUrl}/events/${eventId}/failoverToOpenTok`, null)
            .pipe(map((result: LiveEventViewModel) => result));
  }

  startSecondaryOpenTokArchive(eventId: number): Observable<LiveEventViewModel> {
       return this.http.post<LiveEventViewModel>(`${this.baseUrl}/events/${eventId}/startSecondaryOpenTokArchive`, null)
            .pipe(map((result: LiveEventViewModel) => result));
  }

  stopWebRTCStream(eventId: number): Observable<LiveEventViewModel> {
       return this.http.post<LiveEventViewModel>(`${this.baseUrl}/events/${eventId}/stopStreaming`, null)
            .pipe(map((result: LiveEventViewModel) => result));
  }

  setStreamLayouts(eventId: number): Observable<LiveEventViewModel> {
       return this.http.post<LiveEventViewModel>(`${this.baseUrl}/events/${eventId}/layout-streams`, null)
            .pipe(map((result: LiveEventViewModel) => result));
  }

  setAttendeesCamerasAllowed(eventId: number, allowed: boolean): Observable<LiveEventViewModel> {
       return this.http.post<LiveEventViewModel>(`${this.baseUrl}/events/${eventId}/attendee-cameras-allowed?allowed=${allowed}`, null)
            .pipe(map((result: LiveEventViewModel) => result));
  }

  getAllowJoin(eventId: number): Observable<BooleanViewModel> {
       return this.http.get<BooleanViewModel>(`${this.baseUrl}/events/${eventId}/allowJoin`);
   }

  stopStreaming(eventId: number): Observable<StringViewModel> {
       return this.http.get<StringViewModel>(`${this.baseUrl}/events/${eventId}/stopStreaming`);
   }

  getEventStreamingStatus(eventId: number): Observable<StringViewModel> {
       return this.http.get<StringViewModel>(`${this.baseUrl}/events/${eventId}/status`);
   }

  getPlaybackUrl(eventId: number): Observable<StringViewModel> {
       return this.http.get<StringViewModel>(`${this.baseUrl}/events/${eventId}/playbackUrl`);
   }

  getActiveUsers(eventId: number, page: number, filter: string): Observable<PagedActiveUserViewModel> {
       return this.http.get<PagedActiveUserViewModel>(`${this.baseUrl}/events/${eventId}/active-users?page=${page}&filter=${filter}`);
   }

  getOpenTokToken(eventId: number): Observable<OpenTokAuthModel> {
       return this.http.get<OpenTokAuthModel>(`${this.baseUrl}/events/${eventId}/opentok-token`);
   }

  connectToSipConference(eventId: number): Observable<OpenTokAuthModel> {
       return this.http.get<OpenTokAuthModel>(`${this.baseUrl}/events/${eventId}/sipConference`);
   }

  getOpenTokTokenForSlides(): Observable<OpenTokAuthModel> {
       return this.http.get<OpenTokAuthModel>(`${this.baseUrl}/slidecontrol/opentok-token`);
   }

}
@Injectable()
export class LobbyService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getOpenTokToken(lobbyId: number): Observable<OpenTokAuthModel> {
       return this.http.get<OpenTokAuthModel>(`${this.baseUrl}/lobbies/${lobbyId}/opentok-token`);
   }

  createOpenTokToken(lobbyId: number): Observable<OpenTokAuthModel> {
       return this.http.get<OpenTokAuthModel>(`${this.baseUrl}/lobbies/${lobbyId}/create-opentok-token`);
   }

  getChatHistory(lobbyId: number): Observable<ChatHistoryViewModel[]> {
       return this.http.get<ChatHistoryViewModel[]>(`${this.baseUrl}/lobbies/${lobbyId}/chatHistory`);
   }

  getActiveUsers(lobbyId: number, page: number, filter: string): Observable<PagedLobbyActiveUserViewModel> {
       return this.http.get<PagedLobbyActiveUserViewModel>(`${this.baseUrl}/lobbies/${lobbyId}/active-users?page=${page}&filter=${filter}`);
   }

  getLobbyById(lobbyId: number): Observable<LobbyViewModel> {
       return this.http.get<LobbyViewModel>(`${this.baseUrl}/lobbies/${lobbyId}`);
   }

}
@Injectable()
export class OrganizationService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getAll(): Observable<OrganizationViewModel[]> {
       return this.http.get<OrganizationViewModel[]>(`${this.baseUrl}/organizations`);
   }

  getOrganizationsPaged(model: SuperUserOrganizationSearchParameters, page: number, pageSize: number): Observable<PagedResult<OrganizationViewModel>> {
       return this.http.post<PagedResult<OrganizationViewModel>>(`${this.baseUrl}/organizations/paged/?page=${page}&pageSize=${pageSize}`, model)
            .pipe(map((result: PagedResult<OrganizationViewModel>) => result));
  }

  getAllPackages(showHidden: boolean): Observable<PackageDropdownViewModel[]> {
       return this.http.get<PackageDropdownViewModel[]>(`${this.baseUrl}/packages?showHidden=${showHidden}`);
   }

  getAllEventsForConference(conferenceId: number, onlyPublished: boolean, currentPage: number, pageSize: number): Observable<PagedResult<EventSummaryViewModel>> {
       return this.http.get<PagedResult<EventSummaryViewModel>>(`${this.baseUrl}/conferences/${conferenceId}/events?onlyPublished=${onlyPublished}&currentPage=${currentPage}&pageSize=${pageSize}`);
   }

  getTimeslotsForConference(conferenceId: number): Observable<StrNameValuePair[]> {
       return this.http.get<StrNameValuePair[]>(`${this.baseUrl}/conferences/${conferenceId}/events/time-slots`);
   }

  getTagsForConference(conferenceId: number): Observable<TagViewModel[]> {
       return this.http.get<TagViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/tags`);
   }

  getPackageAddonsForConference(conferenceId: number): Observable<PackageAddonViewModel[]> {
       return this.http.get<PackageAddonViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/addons`);
   }

  getTagsForOrganization(organizationIdOrSlug: string): Observable<TagViewModel[]> {
       return this.http.get<TagViewModel[]>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/tags`);
   }

  searchEventsForConference(conferenceId: number, currentPage: number, pageSize: number, adjustPricing: boolean, searchModel: OrganizationEventSearchParams): Observable<PagedResult<EventSummaryViewModel>> {
       return this.http.post<PagedResult<EventSummaryViewModel>>(`${this.baseUrl}/conferences/${conferenceId}/events/search?currentPage=${currentPage}&pageSize=${pageSize}`, searchModel)
            .pipe(map((result: PagedResult<EventSummaryViewModel>) => result));
  }

  searchEventsForOrganization(organizationIdOrSlug: string, currentPage: number, pageSize: number, adjustPricing: boolean, searchModel: OrganizationEventSearchParams): Observable<PagedResult<EventSummaryViewModel>> {
       return this.http.post<PagedResult<EventSummaryViewModel>>(`${this.baseUrl}/organization/${organizationIdOrSlug}/events/search?currentPage=${currentPage}&pageSize=${pageSize}`, searchModel)
            .pipe(map((result: PagedResult<EventSummaryViewModel>) => result));
  }

  getAllCourseEventsForConference(conferenceId: number, onlyPublished: boolean): Observable<CourseEventViewModel[]> {
       return this.http.get<CourseEventViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/course-events?onlyPublished=${onlyPublished}`);
   }

  getAllCourseEventsForOrganization(organizationIdOrSlug: string): Observable<CourseEventViewModel[]> {
       return this.http.get<CourseEventViewModel[]>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/course-events`);
   }

  markAsCheckedIn(conferenceId: number, userId: number, allowConnectionDiscovery: boolean): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/conferences/${conferenceId}/users/${userId}/mark-checked-in?allowConnectionDiscovery=${allowConnectionDiscovery}`, null)
            .pipe(map((result: boolean) => result));
  }

  checkinToConference(conferenceId: number, reKeyOnly: boolean, computerId: string, model: ConferenceRegistrantViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/conferences/${conferenceId}/check-in?reKeyOnly=${reKeyOnly}&computerId=${computerId}`, model)
            .pipe(map((result: boolean) => result));
  }

  addConferencePage(conferenceId: number, model: AddPageViewModel): Observable<PageViewModel[]> {
       return this.http.post<PageViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/pages`, model)
            .pipe(map((result: PageViewModel[]) => result));
  }

  updateConferencePage(conferenceId: number, pageId: number, model: PageViewModel): Observable<PageViewModel> {
       return this.http.put<PageViewModel>(`${this.baseUrl}/conferences/${conferenceId}/pages/${pageId}`, model)
            .pipe(map((result: PageViewModel) => result));
  }

  deleteConferencePage(conferenceId: number, pageId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/conferences/${conferenceId}/pages/${pageId}`);
   }

  reorderConferencePages(conferenceId: number, model: OrderedIdModel): Observable<PageViewModel[]> {
       return this.http.post<PageViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/pages/reorder`, model)
            .pipe(map((result: PageViewModel[]) => result));
  }

  addOrganizationPage(organizationIdOrSlug: string, model: AddPageViewModel): Observable<PageViewModel[]> {
       return this.http.post<PageViewModel[]>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/pages`, model)
            .pipe(map((result: PageViewModel[]) => result));
  }

  updateOrganizationPage(organizationIdOrSlug: string, pageId: number, model: PageViewModel): Observable<PageViewModel> {
       return this.http.put<PageViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/pages/${pageId}`, model)
            .pipe(map((result: PageViewModel) => result));
  }

  deleteOrganizationPage(organizationIdOrSlug: string, pageId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/pages/${pageId}`);
   }

  getAuthenticatedDomains(organizationIdOrSlug: string): Observable<AuthenticatedDomainViewModel[]> {
       return this.http.delete<AuthenticatedDomainViewModel[]>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/domains`);
   }

  createStripeConnectedAccount(organizationIdOrSlug: string): Observable<AuthenticatedDomainViewModel[]> {
       return this.http.get<AuthenticatedDomainViewModel[]>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/connected-account`);
   }

  reorderPagesForOrganization(organizationIdOrSlug: string, model: OrderedIdModel): Observable<PageViewModel[]> {
       return this.http.post<PageViewModel[]>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/pages/reorder`, model)
            .pipe(map((result: PageViewModel[]) => result));
  }

  getRoomsForConference(conferenceIdOrSlug: string): Observable<ConferenceRoomViewModel[]> {
       return this.http.get<ConferenceRoomViewModel[]>(`${this.baseUrl}/conferences/${conferenceIdOrSlug}/rooms/`);
   }

  getDayLabelsForConference(conferenceId: number): Observable<string[]> {
       return this.http.get<string[]>(`${this.baseUrl}/conferences/${conferenceId}/day-labels/`);
   }

  getAllPackagesForOrganization(organizationIdOrSlug: string): Observable<PackageDropdownViewModel[]> {
       return this.http.get<PackageDropdownViewModel[]>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/packages`);
   }

  getAllPackagesForConference(conferenceId: number, showHidden: boolean): Observable<PackageDropdownViewModel[]> {
       return this.http.get<PackageDropdownViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/packages?showHidden=${showHidden}`);
   }

  getConferencePage(conferenceId: number, slug: string): Observable<PageViewModel> {
       return this.http.get<PageViewModel>(`${this.baseUrl}/conferences/${conferenceId}/pages/${slug}`);
   }

  addConferenceRegistration(conferenceId: number, model: CreateConferenceRegistrationViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/conferences/${conferenceId}/registrations`, model)
            .pipe(map((result: boolean) => result));
  }

  updateConferenceRegistration(conferenceId: number, userId: number, model: CreateConferenceRegistrationViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/conferences/${conferenceId}/registrations/${userId}`, model)
            .pipe(map((result: boolean) => result));
  }

  transferConferenceRegistration(conferenceId: number, oldUserId: number, model: CreateConferenceRegistrationViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/conferences/${conferenceId}/registrations/${oldUserId}/transfer`, model)
            .pipe(map((result: boolean) => result));
  }

  cEUReconciliation(conferenceId: number): Observable<CEUReconciliationViewModel[]> {
       return this.http.get<CEUReconciliationViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/ceu-reconciliation`);
   }

  getCEUScanData(courseEventId: number, userId: number): Observable<CEUReconciliationViewModel[]> {
       return this.http.get<CEUReconciliationViewModel[]>(`${this.baseUrl}/purchases/${courseEventId}/scan-data/${userId}`);
   }

  issueCEUs(conferenceId: number, model: CEUReconciliationViewModel[]): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/conferences/${conferenceId}/ceu-reconciliation`, model)
            .pipe(map((result: boolean) => result));
  }

  exportRegistrationData(conferenceId: number): Observable<Blob> {
       return this.http.get(`${this.longRunningServerUrl}/conferences/${conferenceId}/reconciliation/export`, {responseType: 'blob' });
   }

  reorderBundles(organizationIdOrSlug: string, model: OrderedIdModel): Observable<PackageDropdownViewModel[]> {
       return this.http.post<PackageDropdownViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/bundles/reorder`, model)
            .pipe(map((result: PackageDropdownViewModel[]) => result));
  }

  exportTranscript(courseEventId: number): Observable<Blob> {
       return this.http.get(`${this.longRunningServerUrl}/course-events/${courseEventId}/transcript/export`, {responseType: 'blob' });
   }

  exportCEUScanData(conferenceId: number): Observable<Blob> {
       return this.http.get(`${this.longRunningServerUrl}/conferences/${conferenceId}/ceu-scans/export`, {responseType: 'blob' });
   }

  deleteUserPackagePurchase(conferenceId: number, packageId: number, userId: number, refundModel: DeletePackageModel): Observable<StringViewModel> {
       return this.http.post<StringViewModel>(`${this.baseUrl}/conferences/${conferenceId}/registrations/${packageId}/delete/${userId}`, refundModel)
            .pipe(map((result: StringViewModel) => result));
  }

  getExhibits(conferenceId: number): Observable<ExhibitSummaryViewModel[]> {
       return this.http.get<ExhibitSummaryViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/admin/exhibits`);
   }

  getCoursesForOrganization(organizationIdOrSlug: string, parameters: CourseSearchParameters): Observable<CourseViewModel[]> {
       return this.http.post<CourseViewModel[]>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/courses`, parameters)
            .pipe(map((result: CourseViewModel[]) => result));
  }

  getEventsForOrganization(organizationIdOrSlug: string): Observable<EventViewModel[]> {
       return this.http.get<EventViewModel[]>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/events`);
   }

  searchEventSummariesForOrganization(organizationIdOrSlug: string, currentPage: number, pageSize: number, searchModel: OrganizationEventSearchParams): Observable<PagedResult<EventSummaryViewModel>> {
       return this.http.post<PagedResult<EventSummaryViewModel>>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/admin/events/search?currentPage=${currentPage}&pageSize=${pageSize}`, searchModel)
            .pipe(map((result: PagedResult<EventSummaryViewModel>) => result));
  }

  getSpecificEvent(organizationIdOrSlug: string, eventId: number): Observable<EventViewModel> {
       return this.http.get<EventViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/admin/event/${eventId}`);
   }

  getAllUsers(organizationIdOrSlug: string, uparams: UserSearchParameters): Observable<UserSearchResultsViewModel> {
       return this.http.post<UserSearchResultsViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/admin/users/`, uparams)
            .pipe(map((result: UserSearchResultsViewModel) => result));
  }

  createEvent(organizationIdOrSlug: string, model: CreateEventViewModel): Observable<EventViewModel> {
       return this.http.post<EventViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/admin/events/`, model)
            .pipe(map((result: EventViewModel) => result));
  }

  updateEvent(organizationIdOrSlug: string, eventId: number, model: CreateEventViewModel): Observable<EventViewModel> {
       return this.http.put<EventViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/admin/events/${eventId}`, model)
            .pipe(map((result: EventViewModel) => result));
  }

  deleteEvent(organizationIdOrSlug: string, eventId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/admin/events/${eventId}`);
   }

  deletePackage(organizationIdOrSlug: string, packageId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/admin/packages/${packageId}`);
   }

  moveToContentHub(organizationIdOrSlug: string, eventId: number): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/admin/events/${eventId}/content-hub`, null)
            .pipe(map((result: boolean) => result));
  }

  getSpecialEventsForOrganization(organizationIdOrSlug: string, tag: string): Observable<EventViewModel[]> {
       return this.http.get<EventViewModel[]>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/specialEvents/${tag}`);
   }

  sendEmailToRegistrants(organizationIdOrSlug: string, courseEventId: number, model: CourseEventEmailViewModel): Observable<number> {
       return this.http.post<number>(`${this.baseUrl}/organization/${organizationIdOrSlug}/courseEvents/${courseEventId}/email-registrants`, model)
            .pipe(map((result: number) => result));
  }

  duplicateEvent(organizationIdOrSlug: string, eventId: number): Observable<EventViewModel> {
       return this.http.post<EventViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/events/${eventId}/duplicate`, null)
            .pipe(map((result: EventViewModel) => result));
  }

  duplicateCourse(organizationIdOrSlug: string, courseId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/courses/${courseId}/duplicate`, null)
            .pipe(map((result: boolean) => result));
  }

  getOrganization(organizationIdOrSlug: string): Observable<OrganizationViewModel> {
       return this.http.get<OrganizationViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}`);
   }

  getOrganizationSettings(organizationIdOrSlug: string): Observable<OrganizationSettingsViewModel> {
       return this.http.get<OrganizationSettingsViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/settings`);
   }

  updateOrganizationSettings(organizationIdOrSlug: string, model: OrganizationSettingsViewModel): Observable<OrganizationSettingsViewModel> {
       return this.http.put<OrganizationSettingsViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/settings`, model)
            .pipe(map((result: OrganizationSettingsViewModel) => result));
  }

  addPaymentMethod(organizationIdOrSlug: string, model: CreatePaymentMethodViewModel): Observable<OrganizationViewModel> {
       return this.http.post<OrganizationViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/addPaymentMethod`, model)
            .pipe(map((result: OrganizationViewModel) => result));
  }

  getUpcomingConferenceForOrg(organizationIdOrSlug: string): Observable<ConferenceViewModelWithDetails> {
       return this.http.get<ConferenceViewModelWithDetails>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/upcoming-conferences`);
   }

  createSubscriptionForOrg(organizationIdOrSlug: string, model: CreateSubscriptionViewModel): Observable<ConferenceViewModelWithDetails> {
       return this.http.post<ConferenceViewModelWithDetails>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/subscription`, model)
            .pipe(map((result: ConferenceViewModelWithDetails) => result));
  }

  createInvoiceForOrg(organizationIdOrSlug: string, model: CreateSubscriptionViewModel): Observable<ConferenceViewModelWithDetails> {
       return this.http.post<ConferenceViewModelWithDetails>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/invoice`, model)
            .pipe(map((result: ConferenceViewModelWithDetails) => result));
  }

  getInvoicesForOrg(organizationIdOrSlug: string): Observable<OrganizationInvoiceViewModel[]> {
       return this.http.get<OrganizationInvoiceViewModel[]>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/invoices`);
   }

  getSubscriptionForOrg(organizationIdOrSlug: string): Observable<OrganizationSubscriptionViewModel[]> {
       return this.http.get<OrganizationSubscriptionViewModel[]>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/subscription`);
   }

  getStripeProducts(): Observable<StripeProductViewModel[]> {
       return this.http.get<StripeProductViewModel[]>(`${this.baseUrl}/organizations/billing/products`);
   }

  getConferenceBySlug(conferenceIdOrSlug: string): Observable<ConferenceViewModelWithDetails> {
       return this.http.get<ConferenceViewModelWithDetails>(`${this.baseUrl}/conferences/${conferenceIdOrSlug}`);
   }

  getConferenceBySlugBasic(conferenceIdOrSlug: string): Observable<ConferenceViewModel> {
       return this.http.get<ConferenceViewModel>(`${this.baseUrl}/conferences/${conferenceIdOrSlug}/basic`);
   }

  doesConferenceHaveLegacyPOs(conferenceIdOrSlug: string): Observable<boolean> {
       return this.http.get<boolean>(`${this.baseUrl}/conferences/${conferenceIdOrSlug}/has-legacy-pos`);
   }

  getConference(organizationIdOrSlug: string, conferenceId: number): Observable<ConferenceViewModel> {
       return this.http.get<ConferenceViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/admin/conferences/${conferenceId}`);
   }

  reprocessCEUs(organizationIdOrSlug: string, eventId: number): Observable<ConferenceViewModel> {
       return this.http.post<ConferenceViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/events/${eventId}/reprocess-ceus`, null)
            .pipe(map((result: ConferenceViewModel) => result));
  }

  reprocessCEUsForUserAndConference(organizationIdOrSlug: string, conferenceId: number, userId: number): Observable<ConferenceViewModel> {
       return this.http.post<ConferenceViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/conferences/${conferenceId}/re-evealuate-ceus-for-user/${userId}`, null)
            .pipe(map((result: ConferenceViewModel) => result));
  }

  getRegistrantsForConference(organizationIdOrSlug: string, conferenceId: number, userParams: RegistrantSearchParameters): Observable<ConferenceRegistrantSummaryViewModel> {
       return this.http.post<ConferenceRegistrantSummaryViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/admin/conferences/${conferenceId}/registrants`, userParams)
            .pipe(map((result: ConferenceRegistrantSummaryViewModel) => result));
  }

  suspendRegistrant(organizationIdOrSlug: string, conferenceId: number, userId: number): Observable<ConferenceRegistrantSummaryViewModel> {
       return this.http.post<ConferenceRegistrantSummaryViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/admin/conferences/${conferenceId}/registrants/${userId}/suspend`, null)
            .pipe(map((result: ConferenceRegistrantSummaryViewModel) => result));
  }

  unSuspendRegistrant(organizationIdOrSlug: string, conferenceId: number, userId: number): Observable<ConferenceRegistrantSummaryViewModel> {
       return this.http.post<ConferenceRegistrantSummaryViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/admin/conferences/${conferenceId}/registrants/${userId}/unsuspend`, null)
            .pipe(map((result: ConferenceRegistrantSummaryViewModel) => result));
  }

  updateConference(organizationIdOrSlug: string, conferenceId: number, model: ConferenceViewModel): Observable<ConferenceViewModel> {
       return this.http.put<ConferenceViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/admin/conferences/${conferenceId}`, model)
            .pipe(map((result: ConferenceViewModel) => result));
  }

  createConference(organizationIdOrSlug: string, model: ConferenceViewModel): Observable<ConferenceViewModel> {
       return this.http.post<ConferenceViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/admin/conferences`, model)
            .pipe(map((result: ConferenceViewModel) => result));
  }

  getAllConferencesForOrg(organizationIdOrSlug: string): Observable<ConferenceViewModelSimple[]> {
       return this.http.get<ConferenceViewModelSimple[]>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/conferences`);
   }

  updateOrganization(organizationId: number, model: OrganizationViewModel): Observable<OrganizationViewModel> {
       return this.http.put<OrganizationViewModel>(`${this.baseUrl}/organizations/${organizationId}`, model)
            .pipe(map((result: OrganizationViewModel) => result));
  }

  createOrganization(model: OrganizationViewModel): Observable<OrganizationViewModel> {
       return this.http.post<OrganizationViewModel>(`${this.baseUrl}/organizations`, model)
            .pipe(map((result: OrganizationViewModel) => result));
  }

  linkSpeakerToOrganization(organizationIdOrSlug: string, userId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/${organizationIdOrSlug}/speakers/${userId}`, null)
            .pipe(map((result: boolean) => result));
  }

  updateOrganizationWebsiteSettings(organizationIdOrSlug: string, settings: WebsiteSettings): Observable<WebsiteSettings> {
       return this.http.post<WebsiteSettings>(`${this.baseUrl}/organization/${organizationIdOrSlug}/website/settings`, settings)
            .pipe(map((result: WebsiteSettings) => result));
  }

  getOrganizationWebsiteSettings(organizationIdOrSlug: string): Observable<WebsiteSettings> {
       return this.http.get<WebsiteSettings>(`${this.baseUrl}/organization/${organizationIdOrSlug}/website/settings`);
   }

  linkAdminUserToOrganization(organizationIdOrSlug: string, userId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/${organizationIdOrSlug}/admin-users/${userId}`, null)
            .pipe(map((result: boolean) => result));
  }

  lookupUserByEmail(model: StringViewModel): Observable<UserLookupViewModel> {
       return this.http.post<UserLookupViewModel>(`${this.baseUrl}/users/check-existing-user`, model)
            .pipe(map((result: UserLookupViewModel) => result));
  }

  addExternalConferenceRegistration(conferenceId: number, model: LegacyExternalConfernceRegistration): Observable<OrganizationViewModel> {
       return this.http.post<OrganizationViewModel>(`${this.baseUrl}/conferences/${conferenceId}/external-registration`, model)
            .pipe(map((result: OrganizationViewModel) => result));
  }

  getSpeakersForOrganization(organizationIdOrSlug: string): Observable<InstructorViewModel[]> {
       return this.http.get<InstructorViewModel[]>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/speakers`);
   }

  getPromoCodesForConference(conferenceId: number, includeInactiveCodes: boolean): Observable<PromoCodeViewModel[]> {
       return this.http.get<PromoCodeViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/promo-codes?includeInactiveCodes=${includeInactiveCodes}`);
   }

  getPromoCodesForOrganization(organizationIdOrSlug: string, includeInactiveCodes: boolean): Observable<PromoCodeViewModel[]> {
       return this.http.get<PromoCodeViewModel[]>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/promo-codes?includeInactiveCodes=${includeInactiveCodes}`);
   }

  getPromoCodesForSponsorship(conferenceId: number, includeInactiveCodes: boolean): Observable<PromoCodeViewModel[]> {
       return this.http.get<PromoCodeViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/promo-codes/sponsorship?includeInactiveCodes=${includeInactiveCodes}`);
   }

  updatePromoCode(conferenceId: number, promoCodeId: number, model: PromoCodeViewModel): Observable<PackageDropdownViewModel> {
       return this.http.put<PackageDropdownViewModel>(`${this.baseUrl}/conferences/${conferenceId}/promo-codes/${promoCodeId}`, model)
            .pipe(map((result: PackageDropdownViewModel) => result));
  }

  updatePromoCodeOrganization(organizationIdOrSlug: string, promoCodeId: number, model: PromoCodeViewModel): Observable<PackageDropdownViewModel> {
       return this.http.put<PackageDropdownViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/promo-codes/${promoCodeId}`, model)
            .pipe(map((result: PackageDropdownViewModel) => result));
  }

  updatePromoCodeSponsorship(conferenceId: number, promoCodeId: number, model: PromoCodeViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/conferences/${conferenceId}/promo-codes/${promoCodeId}/sponsorship`, model)
            .pipe(map((result: boolean) => result));
  }

  deletePromoCode(promoCodeId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/promo-codes/${promoCodeId}`);
   }

  deletePromoCodeSponsorship(promoCodeId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/promo-codes/${promoCodeId}/sponsorship`);
   }

  addPromoCode(conferenceId: number, model: PromoCodeViewModel): Observable<PackageDropdownViewModel> {
       return this.http.post<PackageDropdownViewModel>(`${this.baseUrl}/conferences/${conferenceId}/promo-codes`, model)
            .pipe(map((result: PackageDropdownViewModel) => result));
  }

  addPromoCodeOrganization(organizationIdOrSlug: string, model: PromoCodeViewModel): Observable<PackageDropdownViewModel> {
       return this.http.post<PackageDropdownViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/promo-codes`, model)
            .pipe(map((result: PackageDropdownViewModel) => result));
  }

  addPromoCodeSponsorship(conferenceId: number, model: PromoCodeViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/conferences/${conferenceId}/promo-codes/sponsorship`, model)
            .pipe(map((result: boolean) => result));
  }

  getPromoCode(promoCodeId: number): Observable<PromoCodeViewModel> {
       return this.http.get<PromoCodeViewModel>(`${this.baseUrl}/organizations/promo-codes/${promoCodeId}`);
   }

  getAdminUsersForOrganization(organizationIdOrSlug: string): Observable<UserViewModel[]> {
       return this.http.get<UserViewModel[]>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/admin-users`);
   }

  getEmployeesForOrganization(organizationIdOrSlug: string, searchParams: EmployeeSearchParams): Observable<PagedResult<UserViewModel>> {
       return this.http.post<PagedResult<UserViewModel>>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/employees`, searchParams)
            .pipe(map((result: PagedResult<UserViewModel>) => result));
  }

  getUsersForOrganizationWithTag(organizationIdOrSlug: string, searchParams: EmployeeSearchParams, tagId: number): Observable<PagedResult<UserViewModel>> {
       return this.http.post<PagedResult<UserViewModel>>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/users/by-tag?tagId=${tagId}`, searchParams)
            .pipe(map((result: PagedResult<UserViewModel>) => result));
  }

  uploadEmployeesFromSpreadsheet(organizationIdOrSlug: string, model: EmployeeUploadViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.longRunningServerUrl}/organizations/${organizationIdOrSlug}/employees/spreadsheet`, model)
            .pipe(map((result: boolean) => result));
  }

  uploadPromoCodesFromSpreadsheet(organizationIdOrSlug: string, model: PromoCodeUploadViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.longRunningServerUrl}/organizations/${organizationIdOrSlug}/promo-codes/spreadsheet`, model)
            .pipe(map((result: boolean) => result));
  }

  submitGABASurvey(model: GabaSurveyModel): Observable<OrganizationViewModel> {
       return this.http.post<OrganizationViewModel>(`${this.baseUrl}/gabasurvey`, model)
            .pipe(map((result: OrganizationViewModel) => result));
  }

  generateQRCodes(organizationIdOrSlug: string, model: CEUPrintSheetParameters): Observable<Blob> {
       return this.http.post(`${this.longRunningServerUrl}/organization/${organizationIdOrSlug}/ceu-pdf-sheet`, model, {responseType: 'blob' })
            .pipe(map((result: Blob) => result));
  }

  getCEUPrintSheetForSingleEvent(organizationIdOrSlug: string, eventId: number, singlePage: boolean): Observable<Blob> {
       return this.http.get(`${this.longRunningServerUrl}/organization/${organizationIdOrSlug}/events/${eventId}/ceu-pdf/?singlePage=${singlePage}`, {responseType: 'blob' });
   }

  resendConfirmationEmail(conferenceId: number, packageId: number, userId: number, model: StringViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/conferences/${conferenceId}/registrations/${packageId}/${userId}/resend-confirmation-email`, model)
            .pipe(map((result: boolean) => result));
  }

  getRegistrantChangeLogForConference(organizationIdOrSlug: string, conferenceId: number, model: RegistrantChangeLogSearchParameters): Observable<PagedResult<UserPackagePurchaseChangeLogViewModel>> {
       return this.http.post<PagedResult<UserPackagePurchaseChangeLogViewModel>>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/admin/conferences/${conferenceId}/registrant-change-log`, model)
            .pipe(map((result: PagedResult<UserPackagePurchaseChangeLogViewModel>) => result));
  }

  isConferenceSlugDuplicate(slug: string, existingConferenceId: (any|number)): Observable<boolean> {
       return this.http.get<boolean>(`${this.baseUrl}/conferences/duplicateSlug?slug=${slug}&existingConferenceId=${existingConferenceId}`).pipe(debounceTime(500));
   }

}
@Injectable()
export class PollService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getPollsForEvent(eventId: number): Observable<PollViewModel[]> {
       return this.http.get<PollViewModel[]>(`${this.baseUrl}/events/${eventId}/polls`);
   }

  createPoll(eventId: number, model: CreatePollViewModel): Observable<PollViewModel> {
       return this.http.post<PollViewModel>(`${this.baseUrl}/events/${eventId}/polls`, model)
            .pipe(map((result: PollViewModel) => result));
  }

  resetPoll(eventId: number, pollId: number): Observable<PollViewModel> {
       return this.http.put<PollViewModel>(`${this.baseUrl}/events/${eventId}/polls/${pollId}/reset`, null)
            .pipe(map((result: PollViewModel) => result));
  }

  updatePoll(eventId: number, pollId: number, model: UpdatePollViewModel): Observable<PollViewModel> {
       return this.http.put<PollViewModel>(`${this.baseUrl}/events/${eventId}/polls/${pollId}`, model)
            .pipe(map((result: PollViewModel) => result));
  }

  deletePoll(eventId: number, pollId: number): Observable<PollViewModel> {
       return this.http.delete<PollViewModel>(`${this.baseUrl}/events/${eventId}/polls/${pollId}`);
   }

  updatePollVisibility(eventId: number, pollId: number, visible: boolean): Observable<PollViewModel> {
       return this.http.post<PollViewModel>(`${this.baseUrl}/events/${eventId}/polls/${pollId}/visibility?visible=${visible}`, null)
            .pipe(map((result: PollViewModel) => result));
  }

  logResponse(eventId: number, pollId: number, optionId: number): Observable<PollViewModel> {
       return this.http.post<PollViewModel>(`${this.baseUrl}/events/${eventId}/polls/${pollId}/responses/${optionId}`, null)
            .pipe(map((result: PollViewModel) => result));
  }

}
@Injectable()
export class PosterService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  createPoster(posterSessionId: number, model: CreatePosterViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/poster-sessions/${posterSessionId}/posters`, model)
            .pipe(map((result: boolean) => result));
  }

  submitReview(posterId: number, model: StringViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/poster/${posterId}/reviews`, model)
            .pipe(map((result: boolean) => result));
  }

  getPostersForUser(): Observable<PosterViewModel[]> {
       return this.http.get<PosterViewModel[]>(`${this.baseUrl}/users/posters`);
   }

  getActiveUsers(posterId: number): Observable<ActivePosterUserViewModel[]> {
       return this.http.get<ActivePosterUserViewModel[]>(`${this.baseUrl}/posters/${posterId}/active-users`);
   }

  getPostersForConference(conferenceId: number): Observable<PosterViewModel[]> {
       return this.http.get<PosterViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/posters`);
   }

  getPosterById(posterId: number): Observable<PosterViewModel> {
       return this.http.get<PosterViewModel>(`${this.baseUrl}/users/posters/${posterId}`);
   }

  updatePoster(posterId: number, model: CreatePosterViewModel): Observable<PosterViewModel> {
       return this.http.put<PosterViewModel>(`${this.baseUrl}/users/posters/${posterId}`, model)
            .pipe(map((result: PosterViewModel) => result));
  }

  getPosterSessionsForConference(conferenceId: number): Observable<PosterSessionViewModel[]> {
       return this.http.get<PosterSessionViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/poster-sessions`);
   }

  getOpenTokToken(posterId: number): Observable<OpenTokAuthModel> {
       return this.http.get<OpenTokAuthModel>(`${this.baseUrl}/posters/${posterId}/opentok-token`);
   }

}
@Injectable()
export class PushNotificationService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  updateInstallation(deviceInstallation: DeviceInstallation): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/installations`, deviceInstallation)
            .pipe(map((result: boolean) => result));
  }

  deleteInstallation(installationId: string): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/installations/${installationId}`);
   }

}
@Injectable()
export class StaticDataService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getTags(): Observable<TagViewModel[]> {
       return this.http.get<TagViewModel[]>(`${this.baseUrl}/staticData/tags`);
   }

  getIntegrationConfig(): Observable<IntegrationFieldConfig[]> {
       return this.http.get<IntegrationFieldConfig[]>(`${this.baseUrl}/staticData/integration-config`);
   }

  verifyEventPurchase(userId: number, eventId: number): Observable<boolean> {
       return this.http.get<boolean>(`${this.baseUrl}/staticData/${userId}/verify-event/${eventId}`);
   }

  verifyAddonPurchase(userId: number, addonId: (any|number)): Observable<boolean> {
       return this.http.get<boolean>(`${this.baseUrl}/staticData/${userId}/verify-addon/${addonId}`);
   }

  getNavTags(): Observable<TagViewModel[]> {
       return this.http.get<TagViewModel[]>(`${this.baseUrl}/staticData/nav-tags`);
   }

  getConferenceIdsInOrder(): Observable<ArrayViewModel> {
       return this.http.get<ArrayViewModel>(`${this.baseUrl}/staticData/conference-ids`);
   }

  deleteConnectedAccount(accountId: string): Observable<TagViewModel[]> {
       return this.http.delete<TagViewModel[]>(`${this.baseUrl}/staticData/connected-account`);
   }

  getAssetDuration(): Observable<TagViewModel[]> {
       return this.http.get<TagViewModel[]>(`${this.baseUrl}/testmethod`);
   }

  getLobbyToken(lobbyId: number): Observable<TagViewModel[]> {
       return this.http.get<TagViewModel[]>(`${this.baseUrl}/generateLobbyToken?lobbyId=${lobbyId}`);
   }

  getMembershipStatus(conferenceId: number): Observable<TagViewModel[]> {
       return this.http.get<TagViewModel[]>(`${this.baseUrl}/getmembershipStatus?conferenceId=${conferenceId}`);
   }

  createChannel(channelName: string): Observable<TagViewModel[]> {
       return this.http.get<TagViewModel[]>(`${this.baseUrl}/createChannel?channelName=${channelName}`);
   }

  createConfPages(conferenceId: number): Observable<TagViewModel[]> {
       return this.http.get<TagViewModel[]>(`${this.baseUrl}/createConfPages?conferenceId=${conferenceId}`);
   }

  createOrgPages(organizationId: number): Observable<TagViewModel[]> {
       return this.http.get<TagViewModel[]>(`${this.baseUrl}/createOrgPages?organizationId=${organizationId}`);
   }

  rebuldCacheForConference(conferenceId: number): Observable<TagViewModel[]> {
       return this.http.get<TagViewModel[]>(`${this.baseUrl}/rebuildcacheforconference?conferenceId=${conferenceId}`);
   }

  messagingFilterTests(conferenceId: number): Observable<CampaignListResult> {
       return this.http.get<CampaignListResult>(`${this.baseUrl}/messagingFilterTests?conferenceId=${conferenceId}`);
   }

  getColumnsForSpreadsheet(asset: string): Observable<SpreadsheetMetaData[]> {
       return this.http.get<SpreadsheetMetaData[]>(`${this.baseUrl}/spreadsheet/columns?asset=${asset}`);
   }

  createTiles(conferenceId: number): Observable<boolean> {
       return this.http.get<boolean>(`${this.baseUrl}/createTiles?conferenceId=${conferenceId}`);
   }

  test(conferenceId: number): Observable<boolean> {
       return this.http.get<boolean>(`${this.baseUrl}/test?conferenceId=${conferenceId}`);
   }

  getGiftCard(token: string): Observable<GiftCardClaimViewModel> {
       return this.http.get<GiftCardClaimViewModel>(`${this.baseUrl}/get-gift-card?token=${token}`);
   }

  captivePortalAuthorize(request: CaptivePortalAuthorizeRequest): Observable<CaptivePortalAuthorizeRequest> {
       return this.http.post<CaptivePortalAuthorizeRequest>(`${this.baseUrl}/captive-portal-authorize`, request)
            .pipe(map((result: CaptivePortalAuthorizeRequest) => result));
  }

  claimGiftCard(token: string): Observable<GiftCardClaimViewModel> {
       return this.http.get<GiftCardClaimViewModel>(`${this.baseUrl}/claim-gift-card?token=${token}`);
   }

  getOrganizationCurrencyCode(organizationIdOrSlug: string): Observable<StringViewModel> {
       return this.http.get<StringViewModel>(`${this.baseUrl}/staticData/organizations/${organizationIdOrSlug}/currency`);
   }

  getConferenceTimeZone(conferenceId: number): Observable<StringViewModel> {
       return this.http.get<StringViewModel>(`${this.baseUrl}/staticData/conferences/${conferenceId}/timezone`);
   }

}
@Injectable()
export class SuperUserService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getPLaidData(): Observable<PlaidToken> {
       return this.http.get<PlaidToken>(`${this.baseUrl}/generate-plaid`);
   }

  exchangePublicToken(model: PublicTokenModel): Observable<PlaidToken> {
       return this.http.post<PlaidToken>(`${this.baseUrl}/exchange-plaid`, model)
            .pipe(map((result: PlaidToken) => result));
  }

  getBalance(): Observable<PlaidToken> {
       return this.http.get<PlaidToken>(`${this.baseUrl}/get-balance`);
   }

  getEventsForToday(): Observable<TodaysEventViewmodel[]> {
       return this.http.get<TodaysEventViewmodel[]>(`${this.baseUrl}/superuser/events/today`);
   }

  getStripeBalance(): Observable<StripeBalanceViewModel> {
       return this.http.get<StripeBalanceViewModel>(`${this.baseUrl}/superuser/stripe-balance`);
   }

  getAllUsers(uparams: UserSearchParameters): Observable<UserSearchResultsViewModel> {
       return this.http.post<UserSearchResultsViewModel>(`${this.baseUrl}/superuser/users/`, uparams)
            .pipe(map((result: UserSearchResultsViewModel) => result));
  }

  markVerified(userId: number): Observable<UserSearchResultsViewModel> {
       return this.http.post<UserSearchResultsViewModel>(`${this.baseUrl}/superuser/users/${userId}/markverified`, null)
            .pipe(map((result: UserSearchResultsViewModel) => result));
  }

  reactivateUser(userId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/users/${userId}/reactivate`, null)
            .pipe(map((result: boolean) => result));
  }

  incrementIdempotencyKey(userId: number): Observable<UserSearchResultsViewModel> {
       return this.http.post<UserSearchResultsViewModel>(`${this.baseUrl}/superuser/users/${userId}/increment-idempotency-key`, null)
            .pipe(map((result: UserSearchResultsViewModel) => result));
  }

  getExistingConferenceRegistrations(conferenceId: number, uparams: UserSearchParameters): Observable<ExistingConferenceRegistrationResultsViewModel> {
       return this.http.post<ExistingConferenceRegistrationResultsViewModel>(`${this.baseUrl}/superuser/conferences/${conferenceId}/users/`, uparams)
            .pipe(map((result: ExistingConferenceRegistrationResultsViewModel) => result));
  }

  getPurchaseOrders(): Observable<PurchaseOrderViewModel[]> {
       return this.http.get<PurchaseOrderViewModel[]>(`${this.baseUrl}/superuser/purchase-orders/`);
   }

  updateStreamingChannelsFromRooms(conferenceId: number): Observable<boolean> {
       return this.http.get<boolean>(`${this.baseUrl}/superuser/conferences/${conferenceId}/update-channels`);
   }

  releaseCEUs(conferenceId: number): Observable<boolean> {
       return this.http.get<boolean>(`${this.baseUrl}/superuser/conferences/${conferenceId}/releaseCEUs`);
   }

  activatePurchaseOrderRegistration(purchaseOrderId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/purchase-orders/${purchaseOrderId}/activate`, null)
            .pipe(map((result: boolean) => result));
  }

  payPurchaseOrder(purchaseOrderId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/purchase-orders/${purchaseOrderId}/pay`, null)
            .pipe(map((result: boolean) => result));
  }

  payConferencePurchaseOrder(conferencePurchaseOrderId: number, paymentReceivedByOrg: boolean): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/conference-purchase-orders/${conferencePurchaseOrderId}/pay?paymentReceivedByOrg=${paymentReceivedByOrg}`, null)
            .pipe(map((result: boolean) => result));
  }

  createExistingConferenceRegistration(conferenceId: number, model: CreateExistingConferenceRegistrationViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/conferences/${conferenceId}/registrations/`, model)
            .pipe(map((result: boolean) => result));
  }

  reorderPackages(conferenceId: number, model: OrderedIdModel): Observable<PackageDropdownViewModel[]> {
       return this.http.post<PackageDropdownViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/packages/reorder`, model)
            .pipe(map((result: PackageDropdownViewModel[]) => result));
  }

  reProcessContracts(organizationId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/organizations/${organizationId}/contracts/reprocess`, null)
            .pipe(map((result: boolean) => result));
  }

  updateConferenceRegistration(conferenceId: number, registrationId: number, model: CreateExistingConferenceRegistrationViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/superuser/conferences/${conferenceId}/registrations/${registrationId}`, model)
            .pipe(map((result: boolean) => result));
  }

  updateConference(conferenceId: number, model: ConferenceViewModel): Observable<ConferenceViewModel> {
       return this.http.put<ConferenceViewModel>(`${this.baseUrl}/superuser/conferences/${conferenceId}`, model)
            .pipe(map((result: ConferenceViewModel) => result));
  }

  createConference(organizationId: number, model: ConferenceViewModel): Observable<ConferenceViewModel> {
       return this.http.put<ConferenceViewModel>(`${this.baseUrl}/superuser/organizations/${organizationId}/conferences/`, model)
            .pipe(map((result: ConferenceViewModel) => result));
  }

  getExistingConferenceRegistration(conferenceId: number, registrationId: number): Observable<ExistingConferenceRegistrationViewModel> {
       return this.http.get<ExistingConferenceRegistrationViewModel>(`${this.baseUrl}/superuser/conferences/${conferenceId}/registrations/${registrationId}`);
   }

  getReconciliationData(conferenceId: number): Observable<ConferenceReconciliationData> {
       return this.http.get<ConferenceReconciliationData>(`${this.baseUrl}/superuser/conferences/${conferenceId}/reconciliation`);
   }

  addExpense(conferenceId: number, model: ConferenceExpenseViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/conferences/${conferenceId}/reconciliation/expenses`, model)
            .pipe(map((result: boolean) => result));
  }

  transferOutstandingMoney(conferenceId: number, amount: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/conferences/${conferenceId}/reconciliation/transfer-outstanding`, amount)
            .pipe(map((result: boolean) => result));
  }

  exportRegistrationData(conferenceId: number): Observable<Blob> {
       return this.http.get(`${this.longRunningServerUrl}/superuser/conferences/${conferenceId}/reconciliation/export`, {responseType: 'blob' });
   }

  processXml(): Observable<Blob> {
       return this.http.get(`${this.longRunningServerUrl}/superuser/channels/export`, {responseType: 'blob' });
   }

  exportPresenterData(courseEventId: number): Observable<Blob> {
       return this.http.get(`${this.longRunningServerUrl}/superuser/courseevents/${courseEventId}/reconciliation/export`, {responseType: 'blob' });
   }

  uploadUsersToCourseEventFromSpreadsheet(courseEventId: number, model: UploadSpreadsheetModel): Observable<number> {
       return this.http.post<number>(`${this.longRunningServerUrl}/superuser/courseEvents/${courseEventId}/import-spreadsheet`, model)
            .pipe(map((result: number) => result));
  }

  getInstructorSummaries(): Observable<InstructorSummaryViewModel[]> {
       return this.http.get<InstructorSummaryViewModel[]>(`${this.baseUrl}/superuser/instructors/`);
   }

  getConferencesSimple(): Observable<ConferenceViewModelSimple[]> {
       return this.http.get<ConferenceViewModelSimple[]>(`${this.baseUrl}/superuser/conferences/`);
   }

  getConferencesNameValue(): Observable<NameValuePair[]> {
       return this.http.get<NameValuePair[]>(`${this.baseUrl}/superuser/conferences/name-value`);
   }

  getConference(conferenceId: number): Observable<ConferenceViewModel> {
       return this.http.get<ConferenceViewModel>(`${this.baseUrl}/superuser/conferences/${conferenceId}`);
   }

  getConferencesTotalAmountOwed(): Observable<number> {
       return this.http.get<number>(`${this.baseUrl}/superuser/conferences/totalAmountOwed`);
   }

  getFutureAmountOwed(): Observable<number> {
       return this.http.get<number>(`${this.baseUrl}/superuser/conferences/futureAmountOwed`);
   }

  getExhibits(conferenceId: number): Observable<ExhibitSummaryViewModel[]> {
       return this.http.get<ExhibitSummaryViewModel[]>(`${this.baseUrl}/superuser/conferences/${conferenceId}/exhibits`);
   }

  getSuperUsers(): Observable<InstructorViewModel[]> {
       return this.http.get<InstructorViewModel[]>(`${this.baseUrl}/superuser/users`);
   }

  inviteExhibitUser(exhibitId: number, model: ExhibitInviteViewModel): Observable<ExhibitSummaryViewModel[]> {
       return this.http.post<ExhibitSummaryViewModel[]>(`${this.baseUrl}/superuser/exhibits/${exhibitId}/invite`, model)
            .pipe(map((result: ExhibitSummaryViewModel[]) => result));
  }

  createExhibit(conferenceId: number, model: CreateUpdateExhibitViewModel): Observable<ExhibitDesignerViewModel[]> {
       return this.http.post<ExhibitDesignerViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/exhibits`, model)
            .pipe(map((result: ExhibitDesignerViewModel[]) => result));
  }

  updateExhibit(conferenceId: number, exhibitId: number, model: CreateUpdateExhibitViewModel): Observable<ExhibitDesignerViewModel[]> {
       return this.http.put<ExhibitDesignerViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/exhibits/${exhibitId}`, model)
            .pipe(map((result: ExhibitDesignerViewModel[]) => result));
  }

  getExhibitById(exhibitId: number): Observable<CreateUpdateExhibitViewModel> {
       return this.http.get<CreateUpdateExhibitViewModel>(`${this.baseUrl}/superuser/exhibits/${exhibitId}`);
   }

  inviteInstructorToComplete(eventId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/events/${eventId}/invite-instructor-to-complete`, null)
            .pipe(map((result: boolean) => result));
  }

  sendInstructionsToAttendees(eventId: number): Observable<number> {
       return this.http.post<number>(`${this.baseUrl}/superuser/events/${eventId}/email-attendees`, null)
            .pipe(map((result: number) => result));
  }

  sendInstructionsToPresenters(eventId: number): Observable<number> {
       return this.http.post<number>(`${this.baseUrl}/superuser/events/${eventId}/email-presenters`, null)
            .pipe(map((result: number) => result));
  }

  sendInstructionsToConferenceAttendees(conferenceId: number): Observable<number> {
       return this.http.post<number>(`${this.baseUrl}/conferences/${conferenceId}/email-attendees`, null)
            .pipe(map((result: number) => result));
  }

  sendInstructionsToConferencePresenters(conferenceId: number): Observable<number> {
       return this.http.post<number>(`${this.baseUrl}/conferences/${conferenceId}/email-presenters`, null)
            .pipe(map((result: number) => result));
  }

  initiateUserInvite(userId: number, model: BooleanViewModel): Observable<StringViewModel> {
       return this.http.post<StringViewModel>(`${this.baseUrl}/superuser/users/${userId}/initiateUserInvite`, model)
            .pipe(map((result: StringViewModel) => result));
  }

  sendInstructionsToUserForEvent(userId: number, eventId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/events/${eventId}/users/${userId}/send-instructions`, null)
            .pipe(map((result: boolean) => result));
  }

  sendInstructionsToUserForConference(userId: number, packageId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/package/${packageId}/users/${userId}/send-instructions`, null)
            .pipe(map((result: boolean) => result));
  }

  getSpecificCourse(courseIdOrSlug: string): Observable<CourseViewModel> {
       return this.http.get<CourseViewModel>(`${this.baseUrl}/superuser/courses/${courseIdOrSlug}`);
   }

  getSpecificEvent(eventId: number): Observable<EventViewModel> {
       return this.http.get<EventViewModel>(`${this.baseUrl}/superuser/events/${eventId}`);
   }

  showToken(eventId: number, tokenNumber: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/events/${eventId}/showToken?tokenNumber=${tokenNumber}`, null)
            .pipe(map((result: boolean) => result));
  }

  resetChat(eventId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/events/${eventId}/reset-chat`, null)
            .pipe(map((result: boolean) => result));
  }

  resetQuestions(eventId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/events/${eventId}/reset-questions`, null)
            .pipe(map((result: boolean) => result));
  }

  resetEvent(eventId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/events/${eventId}/reset-event`, null)
            .pipe(map((result: boolean) => result));
  }

  rebuildCacheForEvent(eventId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/events/${eventId}/rebuild-cache`, null)
            .pipe(map((result: boolean) => result));
  }

  impersonateUser(userId: number): Observable<UserAuthenticationViewModel> {
       return this.http.post<UserAuthenticationViewModel>(`${this.baseUrl}/superuser/users/${userId}/impersonateUser`, null)
            .pipe(map((result: UserAuthenticationViewModel) => result));
  }

  getInvoices(): Observable<OrganizationInvoiceViewModel[]> {
       return this.http.get<OrganizationInvoiceViewModel[]>(`${this.baseUrl}/superuser/invoices`);
   }

  getSegment(courseId: number, segmentId: number): Observable<CreateSegmentViewModel> {
       return this.http.get<CreateSegmentViewModel>(`${this.baseUrl}/superuser/courses/${courseId}/segments/${segmentId}`);
   }

  getAssessment(courseId: number): Observable<CreateAssessmentViewModel> {
       return this.http.get<CreateAssessmentViewModel>(`${this.baseUrl}/superuser/courses/${courseId}/assessments`);
   }

  createAssessment(courseId: number, model: CreateAssessmentViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/courses/${courseId}/assessments`, model)
            .pipe(map((result: boolean) => result));
  }

  publishCourse(courseId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/courses/${courseId}/publish`, null)
            .pipe(map((result: boolean) => result));
  }

  updateCourseStatus(courseId: number, status: any): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/courses/${courseId}/updateStatus`, status)
            .pipe(map((result: boolean) => result));
  }

  updateAssessment(courseId: number, assessmentId: number, model: CreateAssessmentViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/superuser/courses/${courseId}/assessments/${assessmentId}`, model)
            .pipe(map((result: boolean) => result));
  }

  deleteCourse(courseId: number): Observable<CreateSegmentViewModel> {
       return this.http.delete<CreateSegmentViewModel>(`${this.baseUrl}/superuser/courses/${courseId}`);
   }

  deleteUser(userId: number): Observable<CreateSegmentViewModel> {
       return this.http.delete<CreateSegmentViewModel>(`${this.baseUrl}/superuser/users/${userId}`);
   }

  getCourseEventPurchaseHistoryForUser(userId: number): Observable<UserPurchaseHistoryViewModel[]> {
       return this.http.get<UserPurchaseHistoryViewModel[]>(`${this.baseUrl}/superuser/users/${userId}/purchase-history`);
   }

  updateCEUStatusForPurchase(userId: number, courseEventId: number, model: UpdateCEUModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/superuser/users/${userId}/${courseEventId}/ceu-credit`, model)
            .pipe(map((result: boolean) => result));
  }

  getAlACartePurchaseHistory(userId: number): Observable<UserPurchaseHistoryViewModel[]> {
       return this.http.get<UserPurchaseHistoryViewModel[]>(`${this.baseUrl}/superuser/users/${userId}/a-la-carte-purchase-history`);
   }

  getSingleCourseEventPurchase(userId: number, courseEventId: number): Observable<UserCourseEventPurchaseUpdateViewModel> {
       return this.http.get<UserCourseEventPurchaseUpdateViewModel>(`${this.baseUrl}/superuser/courseEvents/${courseEventId}/courseEventPurchase/${userId}`);
   }

  updateCourseEventPurchase(userId: number, courseEventId: number, model: UserCourseEventPurchaseUpdateViewModel): Observable<UserCourseEventPurchaseUpdateViewModel> {
       return this.http.put<UserCourseEventPurchaseUpdateViewModel>(`${this.baseUrl}/superuser/courseEvents/${courseEventId}/courseEventPurchase/${userId}`, model)
            .pipe(map((result: UserCourseEventPurchaseUpdateViewModel) => result));
  }

  markCourseEventWatched(userId: number, courseEventId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/users/${userId}/courseEvent/${courseEventId}/mark-watched`, null)
            .pipe(map((result: boolean) => result));
  }

  mergeSponsorOrgs(model: MergeSponsorOrganizationsViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/sponsor-organizations/merge`, model)
            .pipe(map((result: boolean) => result));
  }

  getPackagePurchaseHistoryForUser(userId: number): Observable<UserPackagePurchaseHistoryViewModel[]> {
       return this.http.get<UserPackagePurchaseHistoryViewModel[]>(`${this.baseUrl}/superuser/users/${userId}/package-purchase-history`);
   }

  getSinglePackagePurchaseHistory(userId: number, packageId: number): Observable<UserPackagePurchaseHistoryViewModel> {
       return this.http.get<UserPackagePurchaseHistoryViewModel>(`${this.baseUrl}/superuser/users/${userId}/package-purchase-history/${packageId}`);
   }

  getUserPackagePurchase(userId: number, packageId: number): Observable<UserPackagePurchaseViewModel> {
       return this.http.get<UserPackagePurchaseViewModel>(`${this.baseUrl}/superuser/users/${userId}/package-purchase/${packageId}`);
   }

  updateUserPackagePurchase(userId: number, packageId: number, model: UserPackagePurchaseViewModel): Observable<UserPackagePurchaseViewModel> {
       return this.http.put<UserPackagePurchaseViewModel>(`${this.baseUrl}/superuser/users/${userId}/package-purchase/${packageId}`, model)
            .pipe(map((result: UserPackagePurchaseViewModel) => result));
  }

  setUserPassword(userId: number, model: StringViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/users/${userId}/set-password`, model)
            .pipe(map((result: boolean) => result));
  }

  convertToInstructor(userId: number): Observable<boolean> {
       return this.http.get<boolean>(`${this.baseUrl}/superuser/users/${userId}/convert-to-instructor`);
   }

  linkPackage(userId: number, model: SuperUserPackageLinkViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/users/${userId}/linkPackage`, model)
            .pipe(map((result: boolean) => result));
  }

  sendReceipt(userId: number, chargeId: StringViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/users/${userId}/receipts/`, chargeId)
            .pipe(map((result: boolean) => result));
  }

  linkCourseEvent(userId: number, model: SuperUserCourseEventLinkViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/users/${userId}/linkCourseEvent`, model)
            .pipe(map((result: boolean) => result));
  }

  searchCourseEvents(parameters: CourseSearchParameters): Observable<CourseEventViewModel[]> {
       return this.http.post<CourseEventViewModel[]>(`${this.baseUrl}/superuser/course-events/search`, parameters)
            .pipe(map((result: CourseEventViewModel[]) => result));
  }

  issueCEUs(userId: number, eventId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/users/${userId}/events/${eventId}/issueCeus`, null)
            .pipe(map((result: boolean) => result));
  }

  createSegment(courseId: number, model: CreateSegmentViewModel): Observable<CreateSegmentViewModel> {
       return this.http.post<CreateSegmentViewModel>(`${this.baseUrl}/superuser/courses/${courseId}/segments/`, model)
            .pipe(map((result: CreateSegmentViewModel) => result));
  }

  deleteUserPackagePurchase(packageId: number, userId: number, refundModel: DeletePackageModel): Observable<StringViewModel> {
       return this.http.post<StringViewModel>(`${this.baseUrl}/superuser/packages/${packageId}/delete/${userId}`, refundModel)
            .pipe(map((result: StringViewModel) => result));
  }

  refundIndividual(courseEventId: number, userId: number): Observable<StringViewModel> {
       return this.http.post<StringViewModel>(`${this.baseUrl}/superuser/courseEvents/${courseEventId}/refund/${userId}`, null)
            .pipe(map((result: StringViewModel) => result));
  }

  deleteIndividual(courseEventId: number, userId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/courseEvents/${courseEventId}/delete/${userId}`, null)
            .pipe(map((result: boolean) => result));
  }

  getGeneralLedgerForCourseEvent(courseEventId: number): Observable<GeneralLedgerViewModel[]> {
       return this.http.get<GeneralLedgerViewModel[]>(`${this.baseUrl}/superuser/courseEvents/${courseEventId}/ledger`);
   }

  payOutBalance(courseEventId: number): Observable<GeneralLedgerViewModel[]> {
       return this.http.post<GeneralLedgerViewModel[]>(`${this.baseUrl}/superuser/courseEvents/${courseEventId}/ledger/payOutBalance`, null)
            .pipe(map((result: GeneralLedgerViewModel[]) => result));
  }

  getCourseEventsForConference(conferenceId: number): Observable<CourseEventDropdownViewModel[]> {
       return this.http.get<CourseEventDropdownViewModel[]>(`${this.baseUrl}/superuser/conferences/${conferenceId}/courseEvents`);
   }

  getInternalNotesForConference(conferenceId: number): Observable<StringViewModel> {
       return this.http.get<StringViewModel>(`${this.baseUrl}/superuser/conferences/${conferenceId}/notes`);
   }

  setInternalNotesForConference(conferenceId: number, model: StringViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/superuser/conferences/${conferenceId}/notes`, model)
            .pipe(map((result: boolean) => result));
  }

  getCourseEventsForOrganization(organizationIdOrSlug: string): Observable<CourseEventDropdownViewModel[]> {
       return this.http.get<CourseEventDropdownViewModel[]>(`${this.baseUrl}/superuser/organizations/${organizationIdOrSlug}/courseEvents`);
   }

  getAllPackagesForConference(conferenceId: number): Observable<PackageDropdownViewModel[]> {
       return this.http.get<PackageDropdownViewModel[]>(`${this.baseUrl}/superuser/conferences/${conferenceId}/packages`);
   }

  getPackageById(organizationIdOrSlug: string, packageId: number): Observable<CreateUpdatePackageViewModel> {
       return this.http.get<CreateUpdatePackageViewModel>(`${this.baseUrl}/superuser/organization/${organizationIdOrSlug}/packages/${packageId}`);
   }

  markCEUsPaid(packageId: number, userId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/packages/${packageId}/mark-ceu-paid/${userId}`, null)
            .pipe(map((result: boolean) => result));
  }

  updatePackage(conferenceId: number, packageId: number, model: CreateUpdatePackageViewModel): Observable<PackageDropdownViewModel> {
       return this.http.put<PackageDropdownViewModel>(`${this.baseUrl}/superuser/conferences/${conferenceId}/packages/${packageId}`, model)
            .pipe(map((result: PackageDropdownViewModel) => result));
  }

  updatePackageForOrganization(organizationIdOrSlug: string, packageId: number, model: CreateUpdatePackageViewModel): Observable<PackageDropdownViewModel> {
       return this.http.put<PackageDropdownViewModel>(`${this.baseUrl}/superuser/organizatons/${organizationIdOrSlug}/packages/${packageId}`, model)
            .pipe(map((result: PackageDropdownViewModel) => result));
  }

  clonePackage(organizationIdOrSlug: string, conferenceId: number, packageId: number): Observable<PackageDropdownViewModel> {
       return this.http.post<PackageDropdownViewModel>(`${this.baseUrl}/superuser/organizations/${organizationIdOrSlug}/conferences/${conferenceId}/packages/${packageId}/clone`, null)
            .pipe(map((result: PackageDropdownViewModel) => result));
  }

  addPackage(conferenceId: number, model: CreateUpdatePackageViewModel): Observable<PackageDropdownViewModel> {
       return this.http.post<PackageDropdownViewModel>(`${this.baseUrl}/superuser/conferences/${conferenceId}/packages/`, model)
            .pipe(map((result: PackageDropdownViewModel) => result));
  }

  addPackageForOrganization(organizationIdOrSlug: string, model: CreateUpdatePackageViewModel): Observable<PackageDropdownViewModel> {
       return this.http.post<PackageDropdownViewModel>(`${this.baseUrl}/superuser/organizations/${organizationIdOrSlug}/packages/`, model)
            .pipe(map((result: PackageDropdownViewModel) => result));
  }

  updateSegment(courseId: number, segmentId: number, model: CreateSegmentViewModel): Observable<CreateSegmentViewModel> {
       return this.http.put<CreateSegmentViewModel>(`${this.baseUrl}/superuser/courses/${courseId}/segments/${segmentId}`, model)
            .pipe(map((result: CreateSegmentViewModel) => result));
  }

  createEvent(model: CreateEventViewModel): Observable<EventViewModel> {
       return this.http.post<EventViewModel>(`${this.baseUrl}/superuser/events/`, model)
            .pipe(map((result: EventViewModel) => result));
  }

  updateEvent(eventId: number, model: CreateEventViewModel): Observable<EventViewModel> {
       return this.http.put<EventViewModel>(`${this.baseUrl}/superuser/${eventId}`, model)
            .pipe(map((result: EventViewModel) => result));
  }

  updateEventModerators(eventId: number, model: UpdateEventModeratorsViewModel): Observable<EventViewModel> {
       return this.http.put<EventViewModel>(`${this.baseUrl}/superuser/${eventId}/moderators`, model)
            .pipe(map((result: EventViewModel) => result));
  }

  duplicateEvent(eventId: number): Observable<EventViewModel> {
       return this.http.post<EventViewModel>(`${this.baseUrl}/superuser/${eventId}/duplicate`, null)
            .pipe(map((result: EventViewModel) => result));
  }

  duplicateCourse(courseId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/courses/${courseId}/duplicate`, null)
            .pipe(map((result: boolean) => result));
  }

  getContract(courseId: number): Observable<ContractViewModel[]> {
       return this.http.get<ContractViewModel[]>(`${this.baseUrl}/superuser/courses/${courseId}/contracts`);
   }

  updateContract(courseId: number, model: UpdateContractViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/superuser/courses/${courseId}/contracts`, model)
            .pipe(map((result: boolean) => result));
  }

  getMaterials(courseId: number): Observable<MaterialViewModel[]> {
       return this.http.get<MaterialViewModel[]>(`${this.baseUrl}/superuser/courses/${courseId}/materials`);
   }

  getMaterial(courseEventId: number, materialId: number): Observable<MaterialViewModel> {
       return this.http.get<MaterialViewModel>(`${this.baseUrl}/superuser/courseEvents/${courseEventId}/materials/${materialId}`);
   }

  updateMaterial(courseEventId: number, materialId: number, model: MaterialViewModel): Observable<MaterialViewModel> {
       return this.http.put<MaterialViewModel>(`${this.baseUrl}/superuser/courseEvents/${courseEventId}/materials/${materialId}`, model)
            .pipe(map((result: MaterialViewModel) => result));
  }

  createMaterial(courseId: number, model: MaterialViewModel): Observable<MaterialViewModel> {
       return this.http.post<MaterialViewModel>(`${this.baseUrl}/superuser/courses/${courseId}/materials/`, model)
            .pipe(map((result: MaterialViewModel) => result));
  }

  convertToEvent(courseId: number): Observable<MaterialViewModel> {
       return this.http.post<MaterialViewModel>(`${this.baseUrl}/superuser/courses/${courseId}/convertToEvent/`, null)
            .pipe(map((result: MaterialViewModel) => result));
  }

  getChannels(): Observable<WowzaChannelViewModel[]> {
       return this.http.get<WowzaChannelViewModel[]>(`${this.baseUrl}/superuser/get-channels`);
   }

  startChannel(channelName: string): Observable<string> {
       return this.http.get<string>(`${this.baseUrl}/superuser/channels/start?channelName=${channelName}`);
   }

  stopChannel(channelName: string): Observable<string> {
       return this.http.get<string>(`${this.baseUrl}/superuser/channels/stop?channelName=${channelName}`);
   }

  convertEventToCourse(eventId: number, hasOnDemandAccess: boolean): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/events/${eventId}/convertEventToCourse/?hasOnDemandAccess=${hasOnDemandAccess}`, null)
            .pipe(map((result: boolean) => result));
  }

  trimAsset(courseId: number, startSeconds: number, endSeconds: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/courses/${courseId}/trimAsset/${startSeconds}:${endSeconds}`, null)
            .pipe(map((result: boolean) => result));
  }

  getSASForArchive(eventId: number): Observable<StringViewModel> {
       return this.http.get<StringViewModel>(`${this.baseUrl}/superuser/events/${eventId}/getSASForArchive/`);
   }

  getSASForSecondaryArchive(eventId: number): Observable<StringViewModel> {
       return this.http.get<StringViewModel>(`${this.baseUrl}/superuser/events/${eventId}/getSASForSecondaryArchive/`);
   }

  updateSlug(eventId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/events/${eventId}/updateSlug/`, null)
            .pipe(map((result: boolean) => result));
  }

  conferenceRegistrationFix(userId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/conferenceFix/${userId}`, null)
            .pipe(map((result: boolean) => result));
  }

  getSASForVideoContainer(model: StringViewModel): Observable<AzureBlobSASViewModel> {
       return this.http.post<AzureBlobSASViewModel>(`${this.baseUrl}/superuser/upload-sas`, model)
            .pipe(map((result: AzureBlobSASViewModel) => result));
  }

  uploadComplete(courseId: number, model: AzureBlobSASViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/courses/${courseId}/uploadComplete`, model)
            .pipe(map((result: boolean) => result));
  }

  getCertificationBodiesPaged(model: SuperUserCertBodySearchParameters, page: number, pageSize: number): Observable<PagedResult<CertificationBodyViewModel>> {
       return this.http.post<PagedResult<CertificationBodyViewModel>>(`${this.baseUrl}/superuser/certification-bodies/paged/?page=${page}&pageSize=${pageSize}`, model)
            .pipe(map((result: PagedResult<CertificationBodyViewModel>) => result));
  }

  getCertificationBody(certificationBodyId: number): Observable<CertificationBodyViewModel> {
       return this.http.get<CertificationBodyViewModel>(`${this.baseUrl}/superuser/certification-bodies/${certificationBodyId}/`);
   }

  getCertificationBodyFeedbackSurveys(): Observable<CertificationBodyFeedbackSurveyViewModel[]> {
       return this.http.get<CertificationBodyFeedbackSurveyViewModel[]>(`${this.baseUrl}/superuser/certification-bodies/feedback-surveys/`);
   }

  searchCertificationBodyFeedbackSurveysPaged(model: BasicSearchParameters, page: number, pageSize: number): Observable<PagedResult<CertificationBodyFeedbackSurveyViewModel>> {
       return this.http.post<PagedResult<CertificationBodyFeedbackSurveyViewModel>>(`${this.baseUrl}/superuser/certification-bodies/feedback-surveys/paged/?page=${page}&pageSize=${pageSize}`, model)
            .pipe(map((result: PagedResult<CertificationBodyFeedbackSurveyViewModel>) => result));
  }

  createCertificationBody(model: CertificationBodyViewModel): Observable<CertificationBodyViewModel> {
       return this.http.post<CertificationBodyViewModel>(`${this.baseUrl}/superuser/certification-bodies`, model)
            .pipe(map((result: CertificationBodyViewModel) => result));
  }

  updateCertificationBody(certificationBodyId: number, model: CertificationBodyViewModel): Observable<CertificationBodyViewModel> {
       return this.http.put<CertificationBodyViewModel>(`${this.baseUrl}/superuser/certification-bodies/${certificationBodyId}/`, model)
            .pipe(map((result: CertificationBodyViewModel) => result));
  }

  deleteSponsorshipOrder(organizationIdOrSlug: string, conferenceId: number, orderId: number): Observable<StringViewModel> {
       return this.http.delete<StringViewModel>(`${this.baseUrl}/superuser/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/orders/${orderId}/delete`);
   }

  getSponsorshipOrder(organizationIdOrSlug: string, conferenceId: number, orderId: number): Observable<SponsorshipOrderEditViewModel> {
       return this.http.get<SponsorshipOrderEditViewModel>(`${this.baseUrl}/superuser/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/orders/${orderId}`);
   }

  updateSponsorshipOrder(organizationIdOrSlug: string, conferenceId: number, orderId: number, model: SponsorshipOrderEditViewModel): Observable<SponsorshipOrderEditViewModel> {
       return this.http.put<SponsorshipOrderEditViewModel>(`${this.baseUrl}/superuser/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/orders/${orderId}`, model)
            .pipe(map((result: SponsorshipOrderEditViewModel) => result));
  }

  reprocessCEUsForUser(userId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/superuser/users/${userId}/reprocess-ceus`, null)
            .pipe(map((result: boolean) => result));
  }

  addOrganizationContract(organizationIdOrSlug: string, model: OrganizationContractViewModel): Observable<OrganizationContractViewModel> {
       return this.http.post<OrganizationContractViewModel>(`${this.baseUrl}/superuser/organizations/${organizationIdOrSlug}/contracts/`, model)
            .pipe(map((result: OrganizationContractViewModel) => result));
  }

  updateOrganizationContract(organizationContractId: number, model: OrganizationContractViewModel): Observable<OrganizationContractViewModel> {
       return this.http.put<OrganizationContractViewModel>(`${this.baseUrl}/superuser/organizations/contracts/${organizationContractId}`, model)
            .pipe(map((result: OrganizationContractViewModel) => result));
  }

  getOrganizationContract(contractId: number): Observable<OrganizationContractViewModel> {
       return this.http.get<OrganizationContractViewModel>(`${this.baseUrl}/superuser/organizations/contracts/${contractId}`);
   }

  getOrganizationContractsPaged(model: OrganizationContractSearchParameters, page: number, pageSize: number): Observable<PagedResult<OrganizationContractViewModel>> {
       return this.http.post<PagedResult<OrganizationContractViewModel>>(`${this.baseUrl}/superuser/organizations/contracts/search?page=${page}&pageSize=${pageSize}`, model)
            .pipe(map((result: PagedResult<OrganizationContractViewModel>) => result));
  }

  createCertificationBodyFeedbackSurvey(): Observable<CertificationBodyFeedbackSurveyViewModel> {
       return this.http.post<CertificationBodyFeedbackSurveyViewModel>(`${this.baseUrl}/superuser/certification-bodies/feedback-surveys`, null)
            .pipe(map((result: CertificationBodyFeedbackSurveyViewModel) => result));
  }

  saveCertificationBodyFeedbackSurvey(surveyId: number, model: CertificationBodyFeedbackSurveyViewModel): Observable<CertificationBodyFeedbackSurveyViewModel> {
       return this.http.put<CertificationBodyFeedbackSurveyViewModel>(`${this.baseUrl}/superuser/certification-bodies/feedback-surveys/${surveyId}`, model)
            .pipe(map((result: CertificationBodyFeedbackSurveyViewModel) => result));
  }

  searchConferencePurchaseOrders(model: ConferencePurchaseOrderSearchParameters): Observable<PagedResult<ConferencePurchaseOrderViewModel>> {
       return this.http.post<PagedResult<ConferencePurchaseOrderViewModel>>(`${this.baseUrl}/superuser/conference-purchase-orders/paged/`, model)
            .pipe(map((result: PagedResult<ConferencePurchaseOrderViewModel>) => result));
  }

  getOutstandingEventPayouts(): Observable<GeneralLedgerSummaryViewModel[]> {
       return this.http.get<GeneralLedgerSummaryViewModel[]>(`${this.baseUrl}/superuser/event-payouts`);
   }

  getTotalUnpaidEventPayoutAmount(): Observable<GeneralLedgerUnpaidTotalViewModel> {
       return this.http.get<GeneralLedgerUnpaidTotalViewModel>(`${this.baseUrl}/superuser/event-payouts/total`);
   }

  getConferenceLineItemCategories(): Observable<ConferenceLineItemCategoryViewModel[]> {
       return this.http.get<ConferenceLineItemCategoryViewModel[]>(`${this.baseUrl}/superuser/conferences/line-item-categories`);
   }

  addConferenceLineItem(conferenceId: number, model: ConferenceLineItemViewModel): Observable<ConferenceLineItemViewModel> {
       return this.http.post<ConferenceLineItemViewModel>(`${this.baseUrl}/superuser/conferences/${conferenceId}/line-items`, model)
            .pipe(map((result: ConferenceLineItemViewModel) => result));
  }

  getConferenceLineItems(conferenceId: number): Observable<ConferenceLineItemViewModel[]> {
       return this.http.get<ConferenceLineItemViewModel[]>(`${this.baseUrl}/superuser/conferences/${conferenceId}/line-items`);
   }

  updateConferenceLineItem(conferenceId: number, lineItemId: number, model: ConferenceLineItemViewModel): Observable<ConferenceLineItemViewModel> {
       return this.http.put<ConferenceLineItemViewModel>(`${this.baseUrl}/superuser/conferences/${conferenceId}/line-items/${lineItemId}`, model)
            .pipe(map((result: ConferenceLineItemViewModel) => result));
  }

  deleteConferenceLineItem(conferenceId: number, lineItemId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/superuser/conferences/${conferenceId}/line-items/${lineItemId}`);
   }

  removeWorkshopFromRegistration(userId: number, packageId: number, eventAddOnId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/superuser/users/${userId}/packages/${packageId}/workshops/${eventAddOnId}`);
   }

}
@Injectable()
export class SuperUserReadOptimizedService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getEventSummaries(model: SuperUserEventSearchParameters, page: number, pageSize: number): Observable<PagedResult<EventSummarySearchViewModel>> {
       return this.http.post<PagedResult<EventSummarySearchViewModel>>(`${this.baseUrl}/superuser/events/search?page=${page}&pageSize=${pageSize}`, model)
            .pipe(map((result: PagedResult<EventSummarySearchViewModel>) => result));
  }

  getConferencesPaged(model: SuperUserConferenceSearchParameters, page: number, pageSize: number): Observable<PagedResult<ConferenceSearchViewModel>> {
       return this.http.post<PagedResult<ConferenceSearchViewModel>>(`${this.baseUrl}/superuser/conferences/paged/?page=${page}&pageSize=${pageSize}`, model)
            .pipe(map((result: PagedResult<ConferenceSearchViewModel>) => result));
  }

  getCourseSummaries(model: SuperUserCourseSearchParameters, page: number, pageSize: number): Observable<PagedResult<CourseSearchViewModel>> {
       return this.http.post<PagedResult<CourseSearchViewModel>>(`${this.baseUrl}/superuser/courses/search?page=${page}&pageSize=${pageSize}`, model)
            .pipe(map((result: PagedResult<CourseSearchViewModel>) => result));
  }

}
@Injectable()
export class WebRtcRecordingService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getRecordingsPaged(model: StreamCaseRecordingSearchParameters, page: number, pageSize: number): Observable<PagedResult<StreamCaseRecordingViewModel>> {
       return this.http.post<PagedResult<StreamCaseRecordingViewModel>>(`${this.baseUrl}/superuser/web-rtc-recordings/paged/?page=${page}&pageSize=${pageSize}`, model)
            .pipe(map((result: PagedResult<StreamCaseRecordingViewModel>) => result));
  }

  getStreamRecordingDownloadUrl(courseEventId: number, archiveSlot: any): Observable<StreamRecordingDownloadUrlViewModel> {
       return this.http.get<StreamRecordingDownloadUrlViewModel>(`${this.baseUrl}/superuser/web-rtc-recordings/${courseEventId}/download-url/${archiveSlot}/`);
   }

  getTranscodedDownloadUrl(courseEventId: number, archiveSlot: any): Observable<StreamRecordingDownloadUrlViewModel> {
       return this.http.get<StreamRecordingDownloadUrlViewModel>(`${this.baseUrl}/superuser/web-rtc-recordings/${courseEventId}/transcoded-download/${archiveSlot}/`);
   }

  startStreamRecordingTranscode(courseEventId: number, archiveSlot: any): Observable<StreamRecordingTranscodeResultViewModel> {
       return this.http.post<StreamRecordingTranscodeResultViewModel>(`${this.baseUrl}/superuser/web-rtc-recordings/${courseEventId}/${archiveSlot}/transcode/`, null)
            .pipe(map((result: StreamRecordingTranscodeResultViewModel) => result));
  }

}
@Injectable()
export class AdManagerService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getCampaignsForOrganization(organizationIdOrSlug: string): Observable<AdCampaignSummaryViewModel[]> {
       return this.http.get<AdCampaignSummaryViewModel[]>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/ad-campaigns`);
   }

  getCampaignById(organizationIdOrSlug: string, campaignId: number): Observable<AdCampaignViewModel> {
       return this.http.get<AdCampaignViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/ad-campaigns/${campaignId}`);
   }

  updateAdCampaign(organizationIdOrSlug: string, campaignId: number, model: AdCampaignViewModel): Observable<AdCampaignViewModel> {
       return this.http.put<AdCampaignViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/ad-campaigns/${campaignId}`, model)
            .pipe(map((result: AdCampaignViewModel) => result));
  }

  createCampaign(organizationIdOrSlug: string, model: AdCampaignViewModel): Observable<AdCampaignViewModel> {
       return this.http.put<AdCampaignViewModel>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/ad-campaigns`, model)
            .pipe(map((result: AdCampaignViewModel) => result));
  }

  serveAd(clientIdentifier: string): Observable<ServedAdViewModel> {
       return this.http.get<ServedAdViewModel>(`${this.longRunningServerUrl}/serve-ad?clientIdentifier=${clientIdentifier}`);
   }

  clickAd(auctionIdentifier: string, clientIdentifier: string): Observable<number> {
       return this.http.get<number>(`${this.baseUrl}/click-ad/${auctionIdentifier}?clientIdentifier=${clientIdentifier}`);
   }

  logAttribution(clickId: number, amount: number, organizationId: number): Observable<number> {
       return this.http.get<number>(`${this.baseUrl}/log-attribution/${clickId}?amount=${amount}&organizationId=${organizationId}`);
   }

}
@Injectable()
export class CallForPapersService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getPaperTypesForConference(conferenceIdOrSlug: string): Observable<PaperTypeViewModel[]> {
       return this.http.get<PaperTypeViewModel[]>(`${this.baseUrl}/conferences/${conferenceIdOrSlug}/paper-types`);
   }

  savePaperState(conferenceIdOrSlug: string, model: CallForPapersViewModel): Observable<CallForPapersViewModel> {
       return this.http.put<CallForPapersViewModel>(`${this.baseUrl}/conferences/${conferenceIdOrSlug}/paper`, model)
            .pipe(map((result: CallForPapersViewModel) => result));
  }

  submitPaper(conferenceIdOrSlug: string, model: CallForPapersViewModel): Observable<CallForPapersViewModel> {
       return this.http.put<CallForPapersViewModel>(`${this.baseUrl}/conferences/${conferenceIdOrSlug}/paper/submit`, model)
            .pipe(map((result: CallForPapersViewModel) => result));
  }

  getPaperState(conferenceIdOrSlug: string, paperId: number): Observable<CallForPapersViewModel> {
       return this.http.get<CallForPapersViewModel>(`${this.baseUrl}/conferences/${conferenceIdOrSlug}/paper/${paperId}`);
   }

  finalizePaper(conferenceIdOrSlug: string, paperId: number, model: FinalizePaperModel): Observable<CallForPapersViewModel> {
       return this.http.post<CallForPapersViewModel>(`${this.baseUrl}/conferences/${conferenceIdOrSlug}/paper/${paperId}/finalize`, model)
            .pipe(map((result: CallForPapersViewModel) => result));
  }

  generatePaperTypes(conferenceIdOrSlug: string): Observable<PaperTypeViewModel[]> {
       return this.http.post<PaperTypeViewModel[]>(`${this.baseUrl}/conferences/${conferenceIdOrSlug}/generate-paper-types`, null)
            .pipe(map((result: PaperTypeViewModel[]) => result));
  }

}
@Injectable()
export class CallForSponsorsService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  checkPromoCode(conferenceIdOrSlug: string, model: PromoCodeSponsorshipCheckViewModel): Observable<PromoCodeSponsorshipResultViewModel> {
       return this.http.put<PromoCodeSponsorshipResultViewModel>(`${this.baseUrl}/conferences/${conferenceIdOrSlug}/checkPromoCode`, model)
            .pipe(map((result: PromoCodeSponsorshipResultViewModel) => result));
  }

  getSponsorStoreSettings(conferenceIdOrSlug: string): Observable<SponsorStoreSettings> {
       return this.http.get<SponsorStoreSettings>(`${this.baseUrl}/conferences/${conferenceIdOrSlug}/sponsor-store-settings`);
   }

  getMapForConference(conferenceIdOrSlug: string): Observable<ConferenceMapViewModel> {
       return this.http.get<ConferenceMapViewModel>(`${this.baseUrl}/conferences/${conferenceIdOrSlug}/exhibit-map`);
   }

  getMapForConferenceWithSponsorInfo(conferenceIdOrSlug: string): Observable<ConferenceMapViewModelWithSponsorInfo> {
       return this.http.get<ConferenceMapViewModelWithSponsorInfo>(`${this.baseUrl}/conferences/${conferenceIdOrSlug}/exhibit-map-with-sponsor-info`);
   }

  getProductsForConference(conferenceIdOrSlug: string): Observable<SponsorshipProductViewModel[]> {
       return this.http.get<SponsorshipProductViewModel[]>(`${this.baseUrl}/conferences/${conferenceIdOrSlug}/products`);
   }

  getSubProductsForProduct(conferenceIdOrSlug: string, productId: number): Observable<SponsorshipProductViewModel[]> {
       return this.http.get<SponsorshipProductViewModel[]>(`${this.baseUrl}/conferences/${conferenceIdOrSlug}/products/${productId}/sub-products`);
   }

  getSingleProduct(conferenceIdOrSlug: string, productId: number): Observable<SponsorshipProductViewModel> {
       return this.http.get<SponsorshipProductViewModel>(`${this.baseUrl}/conferences/${conferenceIdOrSlug}/products/${productId}`);
   }

  processSponsorshipOrder(model: SponsorshipOrderModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/conferences/sponsors/process-order`, model)
            .pipe(map((result: boolean) => result));
  }

  getAssociatedSponsorOrganizations(): Observable<SponsorOrganizationViewModel[]> {
       return this.http.get<SponsorOrganizationViewModel[]>(`${this.baseUrl}/conferences/sponsors/associated-sponsor-organizations`);
   }

  getAssociatedSponsorOrganizationsByEmail(model: StringViewModel): Observable<SponsorOrganizationViewModel[]> {
       return this.http.post<SponsorOrganizationViewModel[]>(`${this.baseUrl}/conferences/sponsors/associated-sponsor-organizations/by-email`, model)
            .pipe(map((result: SponsorOrganizationViewModel[]) => result));
  }

}
@Injectable()
export class ConferenceTaskService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getAllTasksForConference(organizationIdOrSlug: string, conferenceId: number, taskSearchParameters: TaskSearchParameters): Observable<ConferenceGroupWithTasksViewModel[]> {
       return this.http.post<ConferenceGroupWithTasksViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/search-tasks`, taskSearchParameters)
            .pipe(map((result: ConferenceGroupWithTasksViewModel[]) => result));
  }

  updateTaskName(organizationIdOrSlug: string, conferenceId: number, taskId: number, model: StringViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/tasks/${taskId}/UpdateName`, model)
            .pipe(map((result: boolean) => result));
  }

  updateTaskDescription(organizationIdOrSlug: string, conferenceId: number, taskId: number, model: StringViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/tasks/${taskId}/UpdateDescription`, model)
            .pipe(map((result: boolean) => result));
  }

  updateTaskDueDate(organizationIdOrSlug: string, conferenceId: number, taskId: number, model: DateTimeViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/tasks/${taskId}/UpdateDueDate`, model)
            .pipe(map((result: boolean) => result));
  }

  createTask(organizationIdOrSlug: string, conferenceId: number, model: ConferenceTaskViewModel): Observable<ConferenceTaskViewModel> {
       return this.http.post<ConferenceTaskViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/tasks`, model)
            .pipe(map((result: ConferenceTaskViewModel) => result));
  }

  updateTaskOrder(organizationIdOrSlug: string, conferenceId: number, model: TaskOrderUpdateViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/tasks/UpdateOrder`, model)
            .pipe(map((result: boolean) => result));
  }

  bulkMoveTasksToGroup(organizationIdOrSlug: string, conferenceId: number, groupId: number, model: TaskOrderUpdateViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/groups/${groupId}/bulk-move-tasks`, model)
            .pipe(map((result: boolean) => result));
  }

  bulkDeleteTasks(organizationIdOrSlug: string, conferenceId: number, model: TaskOrderUpdateViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/tasks/bulk-delete-tasks`, model)
            .pipe(map((result: boolean) => result));
  }

  bulkDuplicateTasks(organizationIdOrSlug: string, conferenceId: number, model: TaskOrderUpdateViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/tasks/bulk-duplicate-tasks`, model)
            .pipe(map((result: boolean) => result));
  }

  getTask(organizationIdOrSlug: string, conferenceId: number, taskId: number): Observable<ConferenceTaskViewModel> {
       return this.http.get<ConferenceTaskViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/tasks/${taskId}`);
   }

  addAssigneeToTask(organizationIdOrSlug: string, conferenceId: number, taskId: number, userId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/tasks/${taskId}/Assignee/${userId}`, null)
            .pipe(map((result: boolean) => result));
  }

  updateOrderAndGroupForTask(organizationIdOrSlug: string, conferenceId: number, taskId: number, model: UpdateTaskOrderAndGroupViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/tasks/${taskId}/update-order`, model)
            .pipe(map((result: boolean) => result));
  }

  getAssigneeList(organizationIdOrSlug: string): Observable<InstructorViewModel[]> {
       return this.http.get<InstructorViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/task-assignees`);
   }

  uploadTasksFromSpreadsheets(organizationIdOrSlug: string, conferenceId: number, model: UploadSpreadsheetModel): Observable<number> {
       return this.http.post<number>(`${this.longRunningServerUrl}/organizations/${organizationIdOrSlug}/conferences/${conferenceId}/tasks/import`, model)
            .pipe(map((result: number) => result));
  }

  updateAllAssigneesForTask(organizationIdOrSlug: string, conferenceId: number, taskId: number, assignees: UpdateAssigneesViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/tasks/${taskId}/assignees`, assignees)
            .pipe(map((result: boolean) => result));
  }

  removeAssigneeFromTask(organizationIdOrSlug: string, conferenceId: number, taskId: number, userId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/tasks/${taskId}/Assignee/${userId}`);
   }

  updateTask(organizationIdOrSlug: string, conferenceId: number, taskId: number, model: ConferenceTaskViewModel): Observable<ConferenceTaskViewModel> {
       return this.http.put<ConferenceTaskViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/tasks/${taskId}`, model)
            .pipe(map((result: ConferenceTaskViewModel) => result));
  }

  deleteTask(organizationIdOrSlug: string, conferenceId: number, taskId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/tasks/${taskId}`);
   }

  updateStatusForTask(organizationIdOrSlug: string, conferenceId: number, taskId: number, statusId: number): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/tasks/${taskId}/UpdateStatus/${statusId}`, null)
            .pipe(map((result: boolean) => result));
  }

  getAllTaskGroupsForConference(organizationIdOrSlug: string, conferenceId: number): Observable<ConferenceTaskGroupViewModel[]> {
       return this.http.get<ConferenceTaskGroupViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/taskgroups`);
   }

  createTaskGroup(organizationIdOrSlug: string, conferenceId: number, model: ConferenceTaskGroupViewModel): Observable<ConferenceTaskGroupViewModel> {
       return this.http.post<ConferenceTaskGroupViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/taskgroups`, model)
            .pipe(map((result: ConferenceTaskGroupViewModel) => result));
  }

  getTaskGroup(organizationIdOrSlug: string, conferenceId: number, groupId: number): Observable<ConferenceTaskGroupViewModel> {
       return this.http.get<ConferenceTaskGroupViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/taskgroups/${groupId}`);
   }

  updateTaskGroup(organizationIdOrSlug: string, conferenceId: number, groupId: number, model: ConferenceTaskGroupViewModel): Observable<ConferenceTaskGroupViewModel> {
       return this.http.put<ConferenceTaskGroupViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/taskgroups/${groupId}`, model)
            .pipe(map((result: ConferenceTaskGroupViewModel) => result));
  }

  updateTaskGroupName(organizationIdOrSlug: string, conferenceId: number, groupId: number, model: StringViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/taskgroups/${groupId}/name`, model)
            .pipe(map((result: boolean) => result));
  }

  updateTaskGroupOrder(organizationIdOrSlug: string, conferenceId: number, model: GroupOrderUpdateViewModel): Observable<ConferenceTaskGroupViewModel> {
       return this.http.put<ConferenceTaskGroupViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/taskgroups/order`, model)
            .pipe(map((result: ConferenceTaskGroupViewModel) => result));
  }

  deleteTaskGroup(organizationIdOrSlug: string, conferenceId: number, groupId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/taskgroups/${groupId}`);
   }

  getAllTaskStatusesForConference(organizationIdOrSlug: string, conferenceId: number): Observable<ConferenceTaskStatusViewModel[]> {
       return this.http.get<ConferenceTaskStatusViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/taskstatuses`);
   }

  createTaskStatus(organizationIdOrSlug: string, conferenceId: number, model: ConferenceTaskStatusViewModel): Observable<ConferenceTaskStatusViewModel> {
       return this.http.post<ConferenceTaskStatusViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/taskstatuses`, model)
            .pipe(map((result: ConferenceTaskStatusViewModel) => result));
  }

  getTaskStatus(organizationIdOrSlug: string, conferenceId: number, statusId: number): Observable<ConferenceTaskStatusViewModel> {
       return this.http.get<ConferenceTaskStatusViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/taskstatuses/${statusId}`);
   }

  updateTaskStatus(organizationIdOrSlug: string, conferenceId: number, statusId: number, model: ConferenceTaskStatusViewModel): Observable<ConferenceTaskStatusViewModel> {
       return this.http.put<ConferenceTaskStatusViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/taskstatuses/${statusId}`, model)
            .pipe(map((result: ConferenceTaskStatusViewModel) => result));
  }

  deleteTaskStatus(organizationIdOrSlug: string, conferenceId: number, statusId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/taskstatuses/${statusId}`);
   }

  createTaskComment(organizationIdOrSlug: string, conferenceId: number, taskId: number, model: ConferenceTaskCommentViewModel): Observable<ConferenceTaskCommentViewModel> {
       return this.http.post<ConferenceTaskCommentViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/tasks/${taskId}/comments`, model)
            .pipe(map((result: ConferenceTaskCommentViewModel) => result));
  }

  cloneTask(organizationIdOrSlug: string, conferenceId: number, taskId: number): Observable<ConferenceTaskViewModel> {
       return this.http.post<ConferenceTaskViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/tasks/${taskId}/Clone`, null)
            .pipe(map((result: ConferenceTaskViewModel) => result));
  }

  cloneTaskGroup(organizationIdOrSlug: string, conferenceId: number, groupId: number): Observable<number> {
       return this.http.post<number>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/taskgroups/${groupId}/Clone`, null)
            .pipe(map((result: number) => result));
  }

  getAllCommentsForTask(organizationIdOrSlug: string, conferenceId: number, taskId: number): Observable<ConferenceTaskCommentViewModel[]> {
       return this.http.get<ConferenceTaskCommentViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/tasks/${taskId}/comments`);
   }

  getTaskComment(organizationIdOrSlug: string, conferenceId: number, commentId: number): Observable<ConferenceTaskCommentViewModel> {
       return this.http.get<ConferenceTaskCommentViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/taskcomments/${commentId}`);
   }

  updateTaskComment(organizationIdOrSlug: string, conferenceId: number, commentId: number, model: ConferenceTaskCommentViewModel): Observable<ConferenceTaskCommentViewModel> {
       return this.http.put<ConferenceTaskCommentViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/taskcomments/${commentId}`, model)
            .pipe(map((result: ConferenceTaskCommentViewModel) => result));
  }

  deleteTaskComment(organizationIdOrSlug: string, conferenceId: number, commentId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/taskcomments/${commentId}`);
   }

}
@Injectable()
export class MobileCMSService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getNonConferenceUserEvents(): Observable<MobileEventSummaryViewModel[]> {
       return this.http.get<MobileEventSummaryViewModel[]>(`${this.baseUrl}/mobile-cms/events/`);
   }

  getConferenceEvents(conferenceId: number, searchText: StringViewModel): Observable<MobileEventSummaryViewModel[]> {
       return this.http.post<MobileEventSummaryViewModel[]>(`${this.baseUrl}/mobile-cms/conferences/${conferenceId}/events/`, searchText)
            .pipe(map((result: MobileEventSummaryViewModel[]) => result));
  }

  getLiveEvent(eventIdOrSlug: string): Observable<EventViewModel> {
       return this.http.get<EventViewModel>(`https://bxlimages.blob.core.windows.net/live-event-cache/${eventIdOrSlug}-liveEvent.json?v=`+ UUID.UUID())
            .pipe(catchError(() => {return this.http.get<EventViewModel>(`${this.baseUrl}/events/${eventIdOrSlug}/live-mobile`)}));
   }

  getLiveEventIgnoreCache(eventIdOrSlug: string): Observable<EventViewModel> {
       return this.http.get<EventViewModel>(`${this.baseUrl}/events/${eventIdOrSlug}/live-mobile`);
   }

}
@Injectable()
export class PointOfSaleService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  stripeToken(): Observable<string> {
       return this.http.get<string>(`${this.baseUrl}/connection_token`);
   }

  getOrganizationForReader(serialNumber: string): Observable<OrganizationViewModelSimple> {
       return this.http.get<OrganizationViewModelSimple>(`${this.baseUrl}/pos/readers/${serialNumber}/organizations`);
   }

  getCategoriesForReader(serialNumber: string): Observable<PosCategoryViewModel[]> {
       return this.http.get<PosCategoryViewModel[]>(`${this.baseUrl}/pos/readers/${serialNumber}/categories`);
   }

  getProductsForCategory(serialNumber: string, categoryId: number): Observable<PosProductViewModel[]> {
       return this.http.get<PosProductViewModel[]>(`${this.baseUrl}/pos/readers/${serialNumber}/categories/${categoryId}/products`);
   }

  getAllProducts(serialNumber: string): Observable<PosProductViewModel[]> {
       return this.http.get<PosProductViewModel[]>(`${this.baseUrl}/pos/readers/${serialNumber}/products`);
   }

  createOrder(serialNumber: string, model: CreatePosOrderViewModel): Observable<PosOrderViewModel> {
       return this.http.post<PosOrderViewModel>(`${this.baseUrl}/pos/readers/${serialNumber}/orders`, model)
            .pipe(map((result: PosOrderViewModel) => result));
  }

  getCategoriesForOrganization(organizationIdOrSlug: string): Observable<PosCategoryViewModel[]> {
       return this.http.get<PosCategoryViewModel[]>(`${this.baseUrl}/pos/organizations/${organizationIdOrSlug}/categories`);
   }

  getCategory(organizationIdOrSlug: string, categoryId: number): Observable<PosCategoryViewModel> {
       return this.http.get<PosCategoryViewModel>(`${this.baseUrl}/pos/organizations/${organizationIdOrSlug}/categories/${categoryId}`);
   }

  createCategory(organizationIdOrSlug: string, model: CreateUpdatePosCategoryViewModel): Observable<PosCategoryViewModel> {
       return this.http.post<PosCategoryViewModel>(`${this.baseUrl}/pos/organizations/${organizationIdOrSlug}/categories`, model)
            .pipe(map((result: PosCategoryViewModel) => result));
  }

  updateCategory(organizationIdOrSlug: string, categoryId: number, model: CreateUpdatePosCategoryViewModel): Observable<PosCategoryViewModel> {
       return this.http.put<PosCategoryViewModel>(`${this.baseUrl}/pos/organizations/${organizationIdOrSlug}/categories/${categoryId}`, model)
            .pipe(map((result: PosCategoryViewModel) => result));
  }

  deleteCategory(organizationIdOrSlug: string, categoryId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/pos/organizations/${organizationIdOrSlug}/categories/${categoryId}`);
   }

  reorderCategories(organizationIdOrSlug: string, model: OrderedIdModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/pos/organizations/${organizationIdOrSlug}/categories/reorder`, model)
            .pipe(map((result: boolean) => result));
  }

  getProductsForOrganization(organizationIdOrSlug: string): Observable<PosProductViewModel[]> {
       return this.http.get<PosProductViewModel[]>(`${this.baseUrl}/pos/organizations/${organizationIdOrSlug}/products`);
   }

  getProduct(organizationIdOrSlug: string, productId: number): Observable<PosProductViewModel> {
       return this.http.get<PosProductViewModel>(`${this.baseUrl}/pos/organizations/${organizationIdOrSlug}/products/${productId}`);
   }

  createProduct(organizationIdOrSlug: string, model: CreateUpdatePosProductViewModel): Observable<PosProductViewModel> {
       return this.http.post<PosProductViewModel>(`${this.baseUrl}/pos/organizations/${organizationIdOrSlug}/products`, model)
            .pipe(map((result: PosProductViewModel) => result));
  }

  updateProduct(organizationIdOrSlug: string, productId: number, model: CreateUpdatePosProductViewModel): Observable<PosProductViewModel> {
       return this.http.put<PosProductViewModel>(`${this.baseUrl}/pos/organizations/${organizationIdOrSlug}/products/${productId}`, model)
            .pipe(map((result: PosProductViewModel) => result));
  }

  deleteProduct(organizationIdOrSlug: string, productId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/pos/organizations/${organizationIdOrSlug}/products/${productId}`);
   }

  reorderProducts(organizationIdOrSlug: string, model: OrderedIdModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/pos/organizations/${organizationIdOrSlug}/products/reorder`, model)
            .pipe(map((result: boolean) => result));
  }

}
@Injectable()
export class UserService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  deleteUserAccount(): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/users`);
   }

  getProfile(): Observable<UserProfileViewModel> {
       return this.http.get<UserProfileViewModel>(`${this.baseUrl}/users/profile`);
   }

  getUserSubscription(): Observable<UserSubscriptionViewModel> {
       return this.http.get<UserSubscriptionViewModel>(`${this.baseUrl}/users/profile/subscription`);
   }

  startSubscription(model: CreatePaymentMethodViewModel): Observable<UserSubscriptionViewModel> {
       return this.http.post<UserSubscriptionViewModel>(`${this.baseUrl}/users/profile/subscription`, model)
            .pipe(map((result: UserSubscriptionViewModel) => result));
  }

  getStripeSubscriptionForUser(): Observable<OrganizationSubscriptionViewModel> {
       return this.http.get<OrganizationSubscriptionViewModel>(`${this.baseUrl}/users/profile/subscription/stripe`);
   }

  getCertifications(): Observable<UserCertificationViewModel[]> {
       return this.http.get<UserCertificationViewModel[]>(`${this.baseUrl}/users/certifications`);
   }

  addPaymentMethod(model: CreatePaymentMethodViewModel): Observable<UserSubscriptionViewModel> {
       return this.http.post<UserSubscriptionViewModel>(`${this.baseUrl}/users/addPaymentMethod`, model)
            .pipe(map((result: UserSubscriptionViewModel) => result));
  }

  createCertification(model: UserCertificationViewModel): Observable<UserCertificationViewModel> {
       return this.http.post<UserCertificationViewModel>(`${this.baseUrl}/users/certifications`, model)
            .pipe(map((result: UserCertificationViewModel) => result));
  }

  updateCertification(certificationId: number, model: UserCertificationViewModel): Observable<UserCertificationViewModel> {
       return this.http.put<UserCertificationViewModel>(`${this.baseUrl}/users/certifications/${certificationId}`, model)
            .pipe(map((result: UserCertificationViewModel) => result));
  }

  getConferenceWhereCEUAdmin(): Observable<ConferenceCEUScannerViewModel[]> {
       return this.http.get<ConferenceCEUScannerViewModel[]>(`${this.baseUrl}/users/ceu-admin/conferences`);
   }

  getUpcomingConferences(): Observable<ConferenceViewModelSimple[]> {
       return this.http.get<ConferenceViewModelSimple[]>(`${this.baseUrl}/users/upcoming-conferences`);
   }

  getUpcomingConferencesAndEvents(count: number): Observable<ConferenceOrEventSummaryViewModel[]> {
       return this.http.get<ConferenceOrEventSummaryViewModel[]>(`${this.baseUrl}/users/upcoming-conferences-and-events?count=${count}`);
   }

  getRegisteredConferences(): Observable<ConferenceViewModeMobileApp[]> {
       return this.http.get<ConferenceViewModeMobileApp[]>(`${this.baseUrl}/users/conferences`);
   }

  getRegisteredConferencesV2(): Observable<ConferenceViewModeMobileAppV2[]> {
       return this.http.get<ConferenceViewModeMobileAppV2[]>(`${this.baseUrl}/users/conferences/v2`);
   }

  getConferenceWhereExhibitAdmin(): Observable<ExhibitCEUScannerViewModel[]> {
       return this.http.get<ExhibitCEUScannerViewModel[]>(`${this.baseUrl}/users/exhibit-admin/conferences`);
   }

  getCurrentCEUAdToDisplay(): Observable<CEUScanAdvertisement> {
       return this.http.get<CEUScanAdvertisement>(`${this.baseUrl}/users/ceu-ad`);
   }

  updateProfile(model: UpdateProfileViewModel): Observable<UserProfileViewModel> {
       return this.http.post<UserProfileViewModel>(`${this.baseUrl}/users/updateProfile`, model)
            .pipe(map((result: UserProfileViewModel) => result));
  }

  updateProfileV2(model: UpdateProfileViewModelV2): Observable<UserProfileViewModel> {
       return this.http.post<UserProfileViewModel>(`${this.baseUrl}/users/updateProfile/v2`, model)
            .pipe(map((result: UserProfileViewModel) => result));
  }

  getUserRegistrationFields(): Observable<UserRegistrationFieldsViewModel> {
       return this.http.get<UserRegistrationFieldsViewModel>(`${this.baseUrl}/users/registrationFields`);
   }

  updateUserRegistrationFields(model: UserRegistrationFieldsViewModel): Observable<UserRegistrationFieldsViewModel> {
       return this.http.post<UserRegistrationFieldsViewModel>(`${this.baseUrl}/users/registrationFields`, model)
            .pipe(map((result: UserRegistrationFieldsViewModel) => result));
  }

  lookupByEmail(model: StringViewModel): Observable<UserLookupViewModel> {
       return this.http.post<UserLookupViewModel>(`${this.baseUrl}/users/lookupByEmail`, model)
            .pipe(map((result: UserLookupViewModel) => result));
  }

  isEmailDuplicate(email: string, existingUserId: (any|number)): Observable<boolean> {
       return this.http.get<boolean>(`${this.baseUrl}/users/duplicateEmail?email=${email}&existingUserId=${existingUserId}`).pipe(debounceTime(500));
   }

  mobileLogin(userDto: LoginViewModel): Observable<UserAuthenticationViewModel> {
       return this.http.post<UserAuthenticationViewModel>(`${this.baseUrl}/users/mobile-login`, userDto)
            .pipe(map((result: UserAuthenticationViewModel) => result));
  }

  completeStripeOauth(model: StringViewModel): Observable<UserProfileViewModel> {
       return this.http.post<UserProfileViewModel>(`${this.baseUrl}/users/completeStripeOauth/`, model)
            .pipe(map((result: UserProfileViewModel) => result));
  }

  completeStripeOauthContractors(model: StringViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/users/completeStripeOauthcontractors/`, model)
            .pipe(map((result: boolean) => result));
  }

  createStripeConnectedAccount(organizationIdOrSlug: string): Observable<AuthenticatedDomainViewModel[]> {
       return this.http.get<AuthenticatedDomainViewModel[]>(`${this.baseUrl}/users/connected-account`);
   }

  isUserCourseEventFavorited(courseEventId: number): Observable<boolean> {
       return this.http.get<boolean>(`${this.baseUrl}/users/favorite/${courseEventId}/is-favorited`);
   }

  favoriteCourseEvent(courseEventId: number): Observable<boolean> {
       return this.http.get<boolean>(`${this.baseUrl}/users/favorite/${courseEventId}`);
   }

  unFavoriteCourseEvent(courseEventId: number): Observable<boolean> {
       return this.http.get<boolean>(`${this.baseUrl}/users/un-favorite/${courseEventId}`);
   }

  getStripeData(): Observable<StripeDataViewModel> {
       return this.http.get<StripeDataViewModel>(`${this.baseUrl}/users/stripeData/`);
   }

  getEvents(): Observable<EventViewModel[]> {
       return this.http.get<EventViewModel[]>(`${this.baseUrl}/users/events/`);
   }

  getAllEvents(): Observable<EventViewModel[]> {
       return this.http.get<EventViewModel[]>(`${this.baseUrl}/users/events/all`);
   }

  getConferenceEvents(conferenceId: number): Observable<EventViewModel[]> {
       return this.http.get<EventViewModel[]>(`${this.baseUrl}/users/conference/${conferenceId}/events/`);
   }

  getConferenceEventsV2(conferenceId: number, model: StringViewModel, page: number, pageSize: number): Observable<MobileAppEventListingViewModel> {
       return this.http.post<MobileAppEventListingViewModel>(`${this.baseUrl}/users/conference/${conferenceId}/events/v2?page=${page}&pageSize=${pageSize}`, model)
            .pipe(map((result: MobileAppEventListingViewModel) => result));
  }

  getIndividualEventsPaged(page: number, pageSize: number): Observable<PagedResult<EventViewModel>> {
       return this.http.get<PagedResult<EventViewModel>>(`${this.baseUrl}/users/events/paged-individual?page=${page}&pageSize=${pageSize}`);
   }

  getAllEventsPaged(page: number, pageSize: number): Observable<PagedResult<EventViewModel>> {
       return this.http.get<PagedResult<EventViewModel>>(`${this.baseUrl}/users/events/paged-all?page=${page}&pageSize=${pageSize}`);
   }

  getConferenceEventsPaged(conferenceId: number, page: number, pageSize: number): Observable<PagedResult<EventViewModel>> {
       return this.http.get<PagedResult<EventViewModel>>(`${this.baseUrl}/users/conference/${conferenceId}/events/paged?page=${page}&pageSize=${pageSize}`);
   }

  getConferenceEventFavoritesPaged(conferenceId: number, page: number, pageSize: number): Observable<PagedResult<EventViewModel>> {
       return this.http.get<PagedResult<EventViewModel>>(`${this.baseUrl}/users/conference/${conferenceId}/events/paged-favorites?page=${page}&pageSize=${pageSize}`);
   }

  getConferenceEventReservations(conferenceIdOrSlug: string): Observable<EventViewModel[]> {
       return this.http.get<EventViewModel[]>(`${this.baseUrl}/users/conference/${conferenceIdOrSlug}/events/reservations`);
   }

  getCourses(page: number, pageSize: number): Observable<PagedResult<CourseViewModelSimple>> {
       return this.http.get<PagedResult<CourseViewModelSimple>>(`${this.baseUrl}/users/purchasedCourses/?page=${page}&pageSize=${pageSize}`);
   }

  searchPurchasedCourses(parameters: CourseSearchParameters): Observable<PagedResult<CourseViewModelSimple>> {
       return this.http.post<PagedResult<CourseViewModelSimple>>(`${this.baseUrl}/users/purchasedCourses/search`, parameters)
            .pipe(map((result: PagedResult<CourseViewModelSimple>) => result));
  }

  getReferralStats(): Observable<ReferralBonusViewModel> {
       return this.http.get<ReferralBonusViewModel>(`${this.baseUrl}/users/getReferralStats/`);
   }

  getSalesHistory(): Observable<SalesHistoryViewModel[]> {
       return this.http.get<SalesHistoryViewModel[]>(`${this.baseUrl}/users/salesHistory/`);
   }

  cEUCheckin(model: CEUCheckinModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/users/ceu-checkin/`, model)
            .pipe(map((result: boolean) => result));
  }

  getCeuHistory(): Observable<CEUHistory[]> {
       return this.http.get<CEUHistory[]>(`${this.baseUrl}/users/ceuHistory/`);
   }

  getPendingCeuHistory(): Observable<CEUScanHistory[]> {
       return this.http.get<CEUScanHistory[]>(`${this.baseUrl}/users/ceuHistory/pending`);
   }

  getTeachingCEUHistory(): Observable<CEUHistory[]> {
       return this.http.get<CEUHistory[]>(`${this.baseUrl}/users/ceuHistory/teaching`);
   }

  getCeuHistoryForConference(conferenceId: number): Observable<ConferenceCEUModel> {
       return this.http.get<ConferenceCEUModel>(`${this.baseUrl}/users/ceuHistory/${conferenceId}`);
   }

  getConferencesWithCertificates(): Observable<ConferenceViewModel[]> {
       return this.http.get<ConferenceViewModel[]>(`${this.baseUrl}/users/ceuHistory/conferences`);
   }

  getCoursesListedByUser(): Observable<UsersAuthoredCoursesViewModel[]> {
       return this.http.get<UsersAuthoredCoursesViewModel[]>(`${this.baseUrl}/users/courses`);
   }

  getEventsListedByUser(hidePastEvents: boolean): Observable<UsersAuthoredEventsViewModel[]> {
       return this.http.get<UsersAuthoredEventsViewModel[]>(`${this.baseUrl}/users/event-listings?hidePastEvents=${hidePastEvents}`);
   }

  submitCourse(model: AuthorCourseVewModel): Observable<CourseViewModel> {
       return this.http.post<CourseViewModel>(`${this.baseUrl}/users/courses`, model)
            .pipe(map((result: CourseViewModel) => result));
  }

  getConferencesWithExpenses(): Observable<ConferenceViewModelSimple[]> {
       return this.http.get<ConferenceViewModelSimple[]>(`${this.baseUrl}/users/conferences-with-expenses`);
   }

  assetUploadComplete(courseId: number, model: AzureBlobSASViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/users/courses/${courseId}/azureAsset/complete`, model)
            .pipe(map((result: boolean) => result));
  }

  changePassword(userDto: ChangePasswordViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/users/changePassword`, userDto)
            .pipe(map((result: boolean) => result));
  }

  initiatePasswordReset(model: StringViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/users/initatePasswordReset`, model)
            .pipe(map((result: boolean) => result));
  }

  resetPassword(model: ResetPasswordViewModel): Observable<UserAuthenticationViewModel> {
       return this.http.post<UserAuthenticationViewModel>(`${this.baseUrl}/users/resetPassword`, model)
            .pipe(map((result: UserAuthenticationViewModel) => result));
  }

  getPaperSubmissions(): Observable<PaperSubmissionListViewModel[]> {
       return this.http.get<PaperSubmissionListViewModel[]>(`${this.baseUrl}/users/papers`);
   }

  deletePaperDraft(paperId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/users/papers/${paperId}`);
   }

  hasRegisteredForConference(conferenceIdOrSlug: string): Observable<UserPackagePurchaseViewModel> {
       return this.http.get<UserPackagePurchaseViewModel>(`${this.baseUrl}/users/has-registered-for-conference/${conferenceIdOrSlug}`);
   }

  getImageAsBase64(): Observable<StringViewModel> {
       return this.http.get<StringViewModel>(`${this.baseUrl}/users/getAvatar`);
   }

  getImageAsBase64FromFileName(fileName: string): Observable<StringViewModel> {
       return this.http.get<StringViewModel>(`${this.baseUrl}/users/getAvatarFromFileName?fileName=${fileName}`);
   }

  sendEmailVerification(): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/users/emailverification`, null)
            .pipe(map((result: boolean) => result));
  }

  sendEmailVerificationForEmail(userId: number, model: StringViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/users/emailverification/${userId}`, model)
            .pipe(map((result: boolean) => result));
  }

  createFilter(model: SavedJobSearchParameters): Observable<SavedJobSearchParameters> {
       return this.http.post<SavedJobSearchParameters>(`${this.baseUrl}/users/filters`, model)
            .pipe(map((result: SavedJobSearchParameters) => result));
  }

  updateFilter(filterId: number, model: SavedJobSearchParameters): Observable<SavedJobSearchParameters> {
       return this.http.put<SavedJobSearchParameters>(`${this.baseUrl}/users/filters/${filterId}`, model)
            .pipe(map((result: SavedJobSearchParameters) => result));
  }

  deleteFilter(filterId: number): Observable<SavedJobSearchParameters> {
       return this.http.delete<SavedJobSearchParameters>(`${this.baseUrl}/users/filters/${filterId}`);
   }

  getFilters(): Observable<SavedJobSearchParameters[]> {
       return this.http.get<SavedJobSearchParameters[]>(`${this.baseUrl}/users/filters`);
   }

  getOrganizationsWithAssignments(): Observable<OrganizationViewModelSimple[]> {
       return this.http.get<OrganizationViewModelSimple[]>(`${this.baseUrl}/users/organizations/with-assignments`);
   }

}
@Injectable()
export class SponsorshipsService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getAllSponsorshipOrganizations(): Observable<SponsorOrganizationViewModel[]> {
       return this.http.get<SponsorOrganizationViewModel[]>(`${this.baseUrl}/sponsorships/organizations`);
   }

  getSponsorOrganizationsPaged(model: SuperUserSponsorOrganizationSearchParameters, page: number, pageSize: number): Observable<PagedResult<SponsorOrganizationViewModel>> {
       return this.http.post<PagedResult<SponsorOrganizationViewModel>>(`${this.baseUrl}/sponsorships/organizations/paged/?page=${page}&pageSize=${pageSize}`, model)
            .pipe(map((result: PagedResult<SponsorOrganizationViewModel>) => result));
  }

  getUsersForSponsorOrg(sponsorOrganizationId: number): Observable<UserViewModel[]> {
       return this.http.get<UserViewModel[]>(`${this.baseUrl}/sponsorships/${sponsorOrganizationId}/users`);
   }

  linkAdminUserToOrganization(sponsorOrganizationId: number, userId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/sponsorships/${sponsorOrganizationId}/admin-users/${userId}`, null)
            .pipe(map((result: boolean) => result));
  }

  deleteAdminUserForSponsorOrganization(sponsorOrganizationId: number, userId: number): Observable<UserViewModel[]> {
       return this.http.delete<UserViewModel[]>(`${this.baseUrl}/sponsorships/${sponsorOrganizationId}/admin-users/${userId}`);
   }

  getSponsorOrganization(sponsorOrganizationId: number): Observable<SponsorOrganizationViewModel> {
       return this.http.get<SponsorOrganizationViewModel>(`${this.baseUrl}/sponsorships/${sponsorOrganizationId}`);
   }

  updateSponsorOrganizationName(sponsorOrganizationId: number, model: StringViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/sponsorships/${sponsorOrganizationId}/name`, model)
            .pipe(map((result: boolean) => result));
  }

  getConferencesForSponsor(sponsorOrganizationId: number): Observable<ConferenceSponsorOrganizationViewModel[]> {
       return this.http.get<ConferenceSponsorOrganizationViewModel[]>(`${this.baseUrl}/sponsorships/${sponsorOrganizationId}/conferences`);
   }

  getConference(sponsorOrganizationId: number, conferenceId: number): Observable<ConferenceViewModel> {
       return this.http.get<ConferenceViewModel>(`${this.baseUrl}/sponsorships/${sponsorOrganizationId}/conferences/${conferenceId}`);
   }

  getPurchases(sponsorOrganizationId: number, conferenceId: number): Observable<SponsorshipOrderItemViewModel[]> {
       return this.http.get<SponsorshipOrderItemViewModel[]>(`${this.baseUrl}/sponsorships/${sponsorOrganizationId}/conferences/${conferenceId}/purchases`);
   }

  getAssets(sponsorOrganizationId: number, conferenceId: number): Observable<SponsorshipAssetViewModel[]> {
       return this.http.get<SponsorshipAssetViewModel[]>(`${this.baseUrl}/sponsorships/${sponsorOrganizationId}/conferences/${conferenceId}/assets`);
   }

  getVouchers(sponsorOrganizationId: number, conferenceId: number): Observable<ViewSponsorshipVoucherViewModel[]> {
       return this.http.get<ViewSponsorshipVoucherViewModel[]>(`${this.baseUrl}/sponsorships/${sponsorOrganizationId}/conferences/${conferenceId}/vouchers`);
   }

  leadRetreivalEnabled(sponsorOrganizationId: number, conferenceId: number): Observable<boolean> {
       return this.http.get<boolean>(`${this.baseUrl}/sponsorships/${sponsorOrganizationId}/conferences/${conferenceId}/lead-retrieval`);
   }

  getLandingPageForConference(sponsorOrganizationId: number, conferenceIdOrSlug: string): Observable<SponsorshipLandingPageViewModel> {
       return this.http.get<SponsorshipLandingPageViewModel>(`${this.baseUrl}/sponsorships/${sponsorOrganizationId}/conferences/${conferenceIdOrSlug}/landing-page`);
   }

  getAllLandingPagesForSponsorOrg(sponsorOrganizationId: number): Observable<SponsorshipLandingPageViewModel[]> {
       return this.http.get<SponsorshipLandingPageViewModel[]>(`${this.baseUrl}/sponsorships/${sponsorOrganizationId}/landing-pages`);
   }

  createLandingPageForConference(sponsorOrganizationId: number, conferenceId: number, model: SponsorshipLandingPageViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/sponsorships/${sponsorOrganizationId}/conferences/${conferenceId}/landing-page`, model)
            .pipe(map((result: boolean) => result));
  }

  cloneLandingPage(sponsorOrganizationId: number, conferenceId: number, existingLandingPageConferenceId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/sponsorships/${sponsorOrganizationId}/conferences/${conferenceId}/landing-page/clone/${existingLandingPageConferenceId}`, null)
            .pipe(map((result: boolean) => result));
  }

  updateLandingPageForConference(sponsorOrganizationId: number, conferenceId: number, model: SponsorshipLandingPageViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/sponsorships/${sponsorOrganizationId}/conferences/${conferenceId}/landing-page`, model)
            .pipe(map((result: boolean) => result));
  }

  getScanData(sponsorOrganizationId: number, conferenceId: number): Observable<SponsorshipConferenceScanResultViewModel[]> {
       return this.http.get<SponsorshipConferenceScanResultViewModel[]>(`${this.baseUrl}/sponsorships/${sponsorOrganizationId}/conferences/${conferenceId}/scan-results`);
   }

  exportScanData(sponsorOrganizationId: number, conferenceId: number): Observable<Blob> {
       return this.http.get(`${this.longRunningServerUrl}/sponsorships/${sponsorOrganizationId}/conferences/${conferenceId}/scan-results/export`, {responseType: 'blob' });
   }

  updateExhibitNotes(sponsorOrganizationId: number, conferenceId: number, userId: number, model: StringViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/sponsorships/${sponsorOrganizationId}/conferences/${conferenceId}/scan-results/${userId}/notes`, model)
            .pipe(map((result: boolean) => result));
  }

  logVisitor(sponsorOrganizationId: number, conferenceId: number, userId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/sponsorships/${sponsorOrganizationId}/conferences/${conferenceId}/scan-results/${userId}`, null)
            .pipe(map((result: boolean) => result));
  }

  claimVouchers(sponsorOrganizationId: number, conferenceId: number, voucherId: number, lineItemId: number, users: UserViewModel[]): Observable<ViewSponsorshipVoucherViewModel[]> {
       return this.http.post<ViewSponsorshipVoucherViewModel[]>(`${this.baseUrl}/sponsorships/${sponsorOrganizationId}/conferences/${conferenceId}/vouchers/${voucherId}/${lineItemId}`, users)
            .pipe(map((result: ViewSponsorshipVoucherViewModel[]) => result));
  }

  getSponsorConfiguration(organizationIdOrSlug: string, conferenceId: number): Observable<SponsorConfigurationViewModel> {
       return this.http.get<SponsorConfigurationViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/conferences/${conferenceId}/sponsor-configuration`);
   }

  saveAssetMetadata(organizationIdOrSlug: string, conferenceId: number, assetId: number, assetMetadata: AssetMetadataViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/conferences/${conferenceId}/assets/${assetId}/metadata`, assetMetadata)
            .pipe(map((result: boolean) => result));
  }

  getExhibits(sponsorOrganizationId: number, conferenceId: number): Observable<SponsorshipExhibitViewModel[]> {
       return this.http.get<SponsorshipExhibitViewModel[]>(`${this.baseUrl}/sponsorships/${sponsorOrganizationId}/conferences/${conferenceId}/exhibits`);
   }

  getSponsorDashboard(sponsorOrganizationId: number, conferenceId: number): Observable<SponsorDashboardViewModel> {
       return this.http.get<SponsorDashboardViewModel>(`${this.baseUrl}/sponsorships/${sponsorOrganizationId}/conferences/${conferenceId}/dashboard`);
   }

  getExhibitScanners(sponsorOrganizationId: number, conferenceId: number): Observable<UserViewModel[]> {
       return this.http.get<UserViewModel[]>(`${this.baseUrl}/sponsorships/${sponsorOrganizationId}/conferences/${conferenceId}/exhibits/scanners`);
   }

  linkExhibitScanner(sponsorOrganizationId: number, conferenceId: number, userId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/sponsorships/${sponsorOrganizationId}/conferences/${conferenceId}/exhibits/scanners/${userId}`, null)
            .pipe(map((result: boolean) => result));
  }

  deleteExhibitScanner(sponsorOrganizationId: number, conferenceId: number, userId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/sponsorships/${sponsorOrganizationId}/conferences/${conferenceId}/exhibits/scanners/${userId}`);
   }

}
@Injectable()
export class AdminCallForPapersService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getSubmissionsForConference(organizationIdOrSlug: string, conferenceId: number, currentUserOnly: boolean, filter: PaperSubmissionFilterViewModel, currentPage: number, pageSize: number): Observable<PagedResult<PaperSubmissionSummaryViewModel>> {
       return this.http.post<PagedResult<PaperSubmissionSummaryViewModel>>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/papers/submissions?currentUserOnly=${currentUserOnly}&currentPage=${currentPage}&pageSize=${pageSize}`, filter)
            .pipe(map((result: PagedResult<PaperSubmissionSummaryViewModel>) => result));
  }

  getOtherSubmissionsForPresenter(organizationIdOrSlug: string, conferenceId: number, userId: number): Observable<PaperSubmissionSummaryViewModel[]> {
       return this.http.get<PaperSubmissionSummaryViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/papers/submissions/users/${userId}`);
   }

  cloneAbstractConfiguration(organizationIdOrSlug: string, conferenceId: number, conferenceIdToClone: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/abstractManagement/clone/${conferenceIdToClone}`, null)
            .pipe(map((result: boolean) => result));
  }

  getInbox(organizationIdOrSlug: string, conferenceId: number, showCleared: boolean): Observable<PaperEmailViewModel[]> {
       return this.http.post<PaperEmailViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/papers/inbox?showCleared=${showCleared}`, null)
            .pipe(map((result: PaperEmailViewModel[]) => result));
  }

  getTagsForConference(organizationIdOrSlug: string, conferenceId: number): Observable<PaperTagViewModel[]> {
       return this.http.post<PaperTagViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/paper-tags`, null)
            .pipe(map((result: PaperTagViewModel[]) => result));
  }

  clearInboxItem(organizationIdOrSlug: string, conferenceId: number, messageId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/papers/inbox/${messageId}`, null)
            .pipe(map((result: boolean) => result));
  }

  getSubmissionById(organizationIdOrSlug: string, conferenceId: number, submissionId: number): Observable<PaperSubmissionViewModel> {
       return this.http.get<PaperSubmissionViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/papers/submissions/${submissionId}`);
   }

  searchPaperPeople(organizationIdOrSlug: string, conferenceId: number, submissionId: number, searchText: string): Observable<InstructorViewModel[]> {
       return this.http.get<InstructorViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/papers/submissions/${submissionId}/paper-people?searchText=${searchText}`);
   }

  getPaperTypeById(organizationIdOrSlug: string, conferenceId: number, paperTypeId: number): Observable<PaperTypeViewModel> {
       return this.http.get<PaperTypeViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/paper-types/${paperTypeId}`);
   }

  exportPaperSubmissions(organizationIdOrSlug: string, conferenceId: number): Observable<Blob> {
       return this.http.get(`${this.longRunningServerUrl}/organization/${organizationIdOrSlug}/conferences/${conferenceId}/papers/export`, {responseType: 'blob' });
   }

  getPaperConfiguration(organizationIdOrSlug: string, conferenceId: number): Observable<PaperConfigurationViewModel> {
       return this.http.get<PaperConfigurationViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/paper-configuration`);
   }

  updatePaperConfiguration(organizationIdOrSlug: string, conferenceId: number, model: PaperConfigurationViewModel): Observable<PaperConfigurationViewModel> {
       return this.http.put<PaperConfigurationViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/paper-configuration`, model)
            .pipe(map((result: PaperConfigurationViewModel) => result));
  }

  deletePaperType(organizationIdOrSlug: string, conferenceId: number, paperTypeId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/paper-types/${paperTypeId}`);
   }

  updatePaperType(organizationIdOrSlug: string, conferenceId: number, paperTypeId: number, model: PaperTypeViewModel): Observable<PaperTypeViewModel> {
       return this.http.put<PaperTypeViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/paper-types/${paperTypeId}`, model)
            .pipe(map((result: PaperTypeViewModel) => result));
  }

  createPaperType(organizationIdOrSlug: string, conferenceId: number, model: PaperTypeViewModel): Observable<PaperTypeViewModel> {
       return this.http.post<PaperTypeViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/paper-types`, model)
            .pipe(map((result: PaperTypeViewModel) => result));
  }

  searchAdminUsers(organizationIdOrSlug: string, name: string): Observable<InstructorViewModel[]> {
       return this.http.get<InstructorViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/search-admin-users?name=${name}`);
   }

  createNoteComment(organizationIdOrSlug: string, conferenceId: number, paperNoteId: number, model: StringViewModel): Observable<PaperNotesViewModel> {
       return this.http.post<PaperNotesViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/paper-notes/${paperNoteId}/comments`, model)
            .pipe(map((result: PaperNotesViewModel) => result));
  }

  createNote(organizationIdOrSlug: string, conferenceId: number, paperNoteId: number, model: StringViewModel): Observable<PaperNotesViewModel[]> {
       return this.http.post<PaperNotesViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/paper-notes/${paperNoteId}/notes`, model)
            .pipe(map((result: PaperNotesViewModel[]) => result));
  }

  sendEmail(organizationIdOrSlug: string, conferenceId: number, submissionId: number, model: ComposeEmailViewModel): Observable<PaperEmailViewModel[]> {
       return this.http.post<PaperEmailViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/papers/submissions/${submissionId}/emails`, model)
            .pipe(map((result: PaperEmailViewModel[]) => result));
  }

  submitPaperReview(organizationIdOrSlug: string, conferenceId: number, submissionId: number, model: PaperReviewModel): Observable<PaperSubmissionViewModel> {
       return this.http.post<PaperSubmissionViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/papers/submissions/${submissionId}/reviews`, model)
            .pipe(map((result: PaperSubmissionViewModel) => result));
  }

  updateReviewCriteria(organizationIdOrSlug: string, conferenceId: number, submissionId: number, criteriaId: number, model: BooleanViewModel): Observable<PaperSubmissionViewModel> {
       return this.http.post<PaperSubmissionViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/papers/submissions/${submissionId}/criteria/${criteriaId}`, model)
            .pipe(map((result: PaperSubmissionViewModel) => result));
  }

  updateAssignee(organizationIdOrSlug: string, conferenceId: number, submissionId: number, assigneeId: number): Observable<InstructorViewModel> {
       return this.http.put<InstructorViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/papers/submissions/${submissionId}/assignee/${assigneeId}`, null)
            .pipe(map((result: InstructorViewModel) => result));
  }

  updateReviewers(organizationIdOrSlug: string, conferenceId: number, submissionId: number, reviewers: OrderedIdModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/papers/submissions/${submissionId}/reviewers`, reviewers)
            .pipe(map((result: boolean) => result));
  }

  updateTags(organizationIdOrSlug: string, conferenceId: number, submissionId: number, tags: PaperTagViewModel[]): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/papers/submissions/${submissionId}/tags`, tags)
            .pipe(map((result: boolean) => result));
  }

  updateSubmissionField(organizationIdOrSlug: string, conferenceId: number, submissionId: number, fieldName: string, value: StringViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/papers/submissions/${submissionId}/properties/${fieldName}/${value}`, value)
            .pipe(map((result: boolean) => result));
  }

  acceptPaper(organizationIdOrSlug: string, conferenceId: number, submissionId: number): Observable<PaperSubmissionViewModel> {
       return this.http.post<PaperSubmissionViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/papers/submissions/${submissionId}/accept`, null)
            .pipe(map((result: PaperSubmissionViewModel) => result));
  }

  addPresenterToPaper(organizationIdOrSlug: string, conferenceId: number, submissionId: number, userId: number): Observable<PaperSubmissionViewModel> {
       return this.http.post<PaperSubmissionViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/papers/submissions/${submissionId}/presenters/${userId}`, null)
            .pipe(map((result: PaperSubmissionViewModel) => result));
  }

  addPanelistToPaper(organizationIdOrSlug: string, conferenceId: number, submissionId: number, userId: number): Observable<PaperSubmissionViewModel> {
       return this.http.post<PaperSubmissionViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/papers/submissions/${submissionId}/panelists/${userId}`, null)
            .pipe(map((result: PaperSubmissionViewModel) => result));
  }

  removePresenterFromPaper(organizationIdOrSlug: string, conferenceId: number, submissionId: number, userId: number): Observable<PaperSubmissionViewModel> {
       return this.http.delete<PaperSubmissionViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/papers/submissions/${submissionId}/presenters/${userId}`);
   }

  removePanelistFromPaper(organizationIdOrSlug: string, conferenceId: number, submissionId: number, userId: number): Observable<PaperSubmissionViewModel> {
       return this.http.delete<PaperSubmissionViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/papers/submissions/${submissionId}/panelists/${userId}`);
   }

  reNotifyAcceptedPaper(organizationIdOrSlug: string, conferenceId: number, submissionId: number): Observable<PaperSubmissionViewModel> {
       return this.http.post<PaperSubmissionViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/papers/submissions/${submissionId}/re-notify`, null)
            .pipe(map((result: PaperSubmissionViewModel) => result));
  }

  rejectPaper(organizationIdOrSlug: string, conferenceId: number, submissionId: number, sendEmail: boolean): Observable<PaperSubmissionViewModel> {
       return this.http.post<PaperSubmissionViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/papers/submissions/${submissionId}/reject?sendEmail=${sendEmail}`, null)
            .pipe(map((result: PaperSubmissionViewModel) => result));
  }

  convertToEvent(organizationIdOrSlug: string, conferenceId: number, submissionId: number, model: ConvertToEventViewModel): Observable<PaperSubmissionViewModel> {
       return this.http.post<PaperSubmissionViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/papers/submissions/${submissionId}/convert-to-event`, model)
            .pipe(map((result: PaperSubmissionViewModel) => result));
  }

  getCustomSurveyData(organizationIdOrSlug: string, conferenceId: number, submissionId: number, excludeHiddenQuestionsForBlindPaperReview: boolean): Observable<CustomSurveyReturnModel[]> {
       return this.http.get<CustomSurveyReturnModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/papers/submissions/${submissionId}/custom-fields?excludeHiddenQuestionsForBlindPaperReview=${excludeHiddenQuestionsForBlindPaperReview}`);
   }

}
@Injectable()
export class AdminConferenceSettingsService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getConferenceIntegrationSettings(organizationIdOrSlug: string, conferenceId: number): Observable<OrganizationIntegrationViewModel[]> {
       return this.http.get<OrganizationIntegrationViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/integrations`);
   }

  getConferenceCheckInSettings(organizationIdOrSlug: string, conferenceId: number): Observable<ConferenceCheckinSettingsViewModel> {
       return this.http.get<ConferenceCheckinSettingsViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/checkin-settings`);
   }

  saveConferenceCheckInSettings(organizationIdOrSlug: string, conferenceId: number, model: ConferenceCheckinSettingsViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/checkin-settings`, model)
            .pipe(map((result: boolean) => result));
  }

  getConferenceRegistrationSettings(organizationIdOrSlug: string, conferenceId: number): Observable<ConferenceRegistrationSettingsViewModel> {
       return this.http.get<ConferenceRegistrationSettingsViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/registration-settings`);
   }

  saveConferenceRegistrationSettings(organizationIdOrSlug: string, conferenceId: number, model: ConferenceRegistrationSettingsViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/registration-settings`, model)
            .pipe(map((result: boolean) => result));
  }

  getSpeakersForConference(organizationIdOrSlug: string, conferenceId: number, currentPage: number, pageSize: number, searchParams: ConferenceSpeakerSearchParameters): Observable<PagedResult<ConferenceSpeakerViewModel>> {
       return this.http.post<PagedResult<ConferenceSpeakerViewModel>>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/speakers?currentPage=${currentPage}&pageSize=${pageSize}`, searchParams)
            .pipe(map((result: PagedResult<ConferenceSpeakerViewModel>) => result));
  }

  getPeopleWithGuestRoomsForConference(organizationIdOrSlug: string, conferenceId: number): Observable<ConferenceSpeakerViewModel[]> {
       return this.http.get<ConferenceSpeakerViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/people/guest-rooms`);
   }

  exportPeopleWithGuestRoomsForConference(organizationIdOrSlug: string, conferenceId: number): Observable<Blob> {
       return this.http.get(`${this.longRunningServerUrl}/organization/${organizationIdOrSlug}/${conferenceId}/people/guest-rooms/export`, {responseType: 'blob' });
   }

  updatePersonsGuestRoom(conferenceId: number, userId: number, model: ConferenceSpeakerViewModel, sendChangeNotification: boolean): Observable<ConferenceSpeakerViewModel[]> {
       return this.http.post<ConferenceSpeakerViewModel[]>(`${this.baseUrl}/organization/conferences/${conferenceId}/people/guest-rooms/${userId}?sendChangeNotification=${sendChangeNotification}`, model)
            .pipe(map((result: ConferenceSpeakerViewModel[]) => result));
  }

  getGuestRoomTypesForConference(conferenceIdOrSlug: string, onlyPublic: boolean): Observable<ConferenceGuestRoomTypeViewModel[]> {
       return this.http.get<ConferenceGuestRoomTypeViewModel[]>(`${this.baseUrl}/organization/conferences/${conferenceIdOrSlug}/guest-room-types?onlyPublic=${onlyPublic}`);
   }

  uploadAttendeesFromSpreadsheet(organizationIdOrSlug: string, conferenceId: number, model: AttendeeUploadViewModel): Observable<number> {
       return this.http.post<number>(`${this.longRunningServerUrl}/organizations/${organizationIdOrSlug}/conferences/${conferenceId}/spreadsheet`, model)
            .pipe(map((result: number) => result));
  }

  linkSpeakerToConference(organizationIdOrSlug: string, conferenceId: number, userId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/${organizationIdOrSlug}/conferences/${conferenceId}/speakers/${userId}`, null)
            .pipe(map((result: boolean) => result));
  }

  linkUserToGuestRooms(organizationIdOrSlug: string, conferenceId: number, userId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/${organizationIdOrSlug}/conferences/${conferenceId}/guest-rooms/${userId}`, null)
            .pipe(map((result: boolean) => result));
  }

  unLinkSpeakerFromConference(organizationIdOrSlug: string, conferenceId: number, userId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/${organizationIdOrSlug}/conferences/${conferenceId}/speakers/${userId}`);
   }

  unlinkUserToGuestRoom(organizationIdOrSlug: string, conferenceId: number, userId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/${organizationIdOrSlug}/conferences/${conferenceId}/guest-rooms/${userId}`);
   }

  reorderRooms(conferenceId: number, model: OrderedIdModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/conferences/${conferenceId}/rooms/reorder`, model)
            .pipe(map((result: boolean) => result));
  }

  createConferenceRoom(organizationIdOrSlug: string, conferenceId: number, model: ConferenceRoomViewModel): Observable<OrganizationIntegrationViewModel[]> {
       return this.http.post<OrganizationIntegrationViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/rooms`, model)
            .pipe(map((result: OrganizationIntegrationViewModel[]) => result));
  }

  deleteConferenceRoom(organizationIdOrSlug: string, conferenceId: number, roomId: number, replacementRoomId: number): Observable<OrganizationIntegrationViewModel[]> {
       return this.http.delete<OrganizationIntegrationViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/rooms/${roomId}?replacementRoomId=${replacementRoomId}`);
   }

  editConferenceRoom(organizationIdOrSlug: string, conferenceId: number, roomId: number, model: ConferenceRoomViewModel): Observable<OrganizationIntegrationViewModel[]> {
       return this.http.post<OrganizationIntegrationViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/rooms/${roomId}`, model)
            .pipe(map((result: OrganizationIntegrationViewModel[]) => result));
  }

  getPackageAddonsForConference(organizationIdOrSlug: string, conferenceId: number): Observable<PackageAddonViewModel[]> {
       return this.http.get<PackageAddonViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/packages/addons`);
   }

  getPackageAddonDetailsForConference(organizationIdOrSlug: string, conferenceId: number): Observable<PackageAddonDetailsViewModel[]> {
       return this.http.get<PackageAddonDetailsViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/packages/addons/details`);
   }

  getPackageEventAddonsForConference(organizationIdOrSlug: string, conferenceId: number): Observable<PackageAddonViewModel[]> {
       return this.http.get<PackageAddonViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/packages/event-addons`);
   }

  getPackageAddon(organizationIdOrSlug: string, conferenceId: number, addOnId: number): Observable<PackageAddonViewModel> {
       return this.http.get<PackageAddonViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/packages/addons/${addOnId}`);
   }

  updatePackageAddon(organizationIdOrSlug: string, conferenceId: number, addOnId: number, model: PackageAddonViewModel): Observable<PackageAddonViewModel> {
       return this.http.put<PackageAddonViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/packages/addons/${addOnId}`, model)
            .pipe(map((result: PackageAddonViewModel) => result));
  }

  createPackageAddon(organizationIdOrSlug: string, conferenceId: number, model: PackageAddonViewModel): Observable<PackageAddonViewModel> {
       return this.http.post<PackageAddonViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/packages/addons`, model)
            .pipe(map((result: PackageAddonViewModel) => result));
  }

  getRegistrantDetails(organizationIdOrSlug: string, conferenceId: number, userId: number, packageId: number): Observable<RegistrantDetailsViewModel> {
       return this.http.post<RegistrantDetailsViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/registrants/${userId}/${packageId}`, null)
            .pipe(map((result: RegistrantDetailsViewModel) => result));
  }

  getRegistrantDetailsExcludeSurveyData(organizationIdOrSlug: string, conferenceId: number, userId: number, packageId: number): Observable<RegistrantDetailsViewModel> {
       return this.http.post<RegistrantDetailsViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/registrants/${userId}/${packageId}/exclude-survey-data`, null)
            .pipe(map((result: RegistrantDetailsViewModel) => result));
  }

  getSponsorshipProductsForOrganization(organizationIdOrSlug: string, conferenceId: number): Observable<SponsorshipProductViewModel[]> {
       return this.http.get<SponsorshipProductViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/products`);
   }

  getBadgeTemplates(organizationIdOrSlug: string, conferenceId: number): Observable<BadgeTemplateViewModel[]> {
       return this.http.get<BadgeTemplateViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/badge-templates`);
   }

  createBadgeTemplate(organizationIdOrSlug: string, conferenceId: number, model: BadgeTemplateViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/badge-templates`, model)
            .pipe(map((result: boolean) => result));
  }

  updateBadgeTemplate(organizationIdOrSlug: string, conferenceId: number, templateId: number, model: BadgeTemplateViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/badge-templates/${templateId}`, model)
            .pipe(map((result: boolean) => result));
  }

  deleteBadgeTemplate(organizationIdOrSlug: string, conferenceId: number, templateId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/badge-templates/${templateId}`);
   }

  updateConferenceBadgeSize(organizationIdOrSlug: string, conferenceId: number, badgeSize: number): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/badge-size?badgeSize=${badgeSize}`, null)
            .pipe(map((result: boolean) => result));
  }

  getSponsorshipAddOnsForOrganization(organizationIdOrSlug: string, conferenceId: number): Observable<SponsorshipProductAddOnViewModel[]> {
       return this.http.get<SponsorshipProductAddOnViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/add-ons`);
   }

  getSponsorshipOrdersForOrganization(organizationIdOrSlug: string, conferenceId: number): Observable<SponsorshipOrderViewModel[]> {
       return this.http.get<SponsorshipOrderViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/orders`);
   }

  refundSponsorshipOrder(organizationIdOrSlug: string, conferenceId: number, orderId: number): Observable<StringViewModel> {
       return this.http.delete<StringViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/orders/${orderId}`);
   }

  getSponsorshipOrdersForOrganizationExport(organizationIdOrSlug: string, conferenceId: number): Observable<Blob> {
       return this.http.get(`${this.longRunningServerUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/orders/export`, {responseType: 'blob' });
   }

  getSponsorshipAssetsForOrganization(organizationIdOrSlug: string, conferenceId: number): Observable<SponsorshipAssetListingViewModel[]> {
       return this.http.get<SponsorshipAssetListingViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/assets`);
   }

  getSponsorshipVouchersForOrganization(organizationIdOrSlug: string, conferenceId: number, searchParams: VoucherSearchParams): Observable<SponsorshipVoucherItemViewModel[]> {
       return this.http.post<SponsorshipVoucherItemViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/vouchers`, searchParams)
            .pipe(map((result: SponsorshipVoucherItemViewModel[]) => result));
  }

  registerUserFromVoucher(organizationIdOrSlug: string, conferenceId: number, voucherId: number, packageId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/vouchers/${voucherId}/redeem/${packageId}`, null)
            .pipe(map((result: boolean) => result));
  }

  searchPurchaseOrdersPaged(organizationIdOrSlug: string, conferenceId: number, currentPage: number, pageSize: number, searchParams: PurchaseOrderSearchViewModel): Observable<PagedResult<PurchaseOrderViewModel>> {
       return this.http.post<PagedResult<PurchaseOrderViewModel>>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/purchase-orders/paged?currentPage=${currentPage}&pageSize=${pageSize}`, searchParams)
            .pipe(map((result: PagedResult<PurchaseOrderViewModel>) => result));
  }

  getPurchaseOrderTotals(organizationIdOrSlug: string, conferenceId: number): Observable<PurchaseOrderTotalsViewModel> {
       return this.http.post<PurchaseOrderTotalsViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/purchase-orders/totals`, null)
            .pipe(map((result: PurchaseOrderTotalsViewModel) => result));
  }

  getConferencePurchaseOrderTotals(organizationIdOrSlug: string, conferenceId: number): Observable<PurchaseOrderTotalsViewModel> {
       return this.http.post<PurchaseOrderTotalsViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/conference-purchase-orders/totals`, null)
            .pipe(map((result: PurchaseOrderTotalsViewModel) => result));
  }

  deleteClaimedVoucher(organizationIdOrSlug: string, conferenceId: number, voucherId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/vouchers/${voucherId}`);
   }

  getExhibitsForConference(organizationIdOrSlug: string, conferenceId: number): Observable<SponsorshipExhibitViewModel[]> {
       return this.http.get<SponsorshipExhibitViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/exhibits`);
   }

  updateExhibitAssignment(organizationIdOrSlug: string, conferenceId: number, orderId: number, newBoothId: number): Observable<SponsorshipExhibitViewModel[]> {
       return this.http.get<SponsorshipExhibitViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/exhibits/${orderId}/update-assignment/${newBoothId}`);
   }

  updateBoothLayout(organizationIdOrSlug: string, conferenceId: number, boothId: number, model: ConferenceMapBoothViewModel): Observable<SponsorshipExhibitViewModel[]> {
       return this.http.put<SponsorshipExhibitViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/booths/${boothId}`, model)
            .pipe(map((result: SponsorshipExhibitViewModel[]) => result));
  }

  addBooth(organizationIdOrSlug: string, conferenceId: number, model: ConferenceMapBoothViewModel): Observable<SponsorshipExhibitViewModel[]> {
       return this.http.post<SponsorshipExhibitViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/booths`, model)
            .pipe(map((result: SponsorshipExhibitViewModel[]) => result));
  }

  updateBooth(organizationIdOrSlug: string, conferenceId: number, boothId: number, model: ConferenceMapBoothViewModel): Observable<SponsorshipExhibitViewModel[]> {
       return this.http.put<SponsorshipExhibitViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/booths/${boothId}/update`, model)
            .pipe(map((result: SponsorshipExhibitViewModel[]) => result));
  }

  deleteBooth(organizationIdOrSlug: string, conferenceId: number, boothId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/booths/${boothId}`, null)
            .pipe(map((result: boolean) => result));
  }

  updateConferenceMap(organizationIdOrSlug: string, conferenceId: number, model: ConferenceMapViewModelSimple): Observable<ConferenceMapViewModelSimple[]> {
       return this.http.put<ConferenceMapViewModelSimple[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/map/update`, model)
            .pipe(map((result: ConferenceMapViewModelSimple[]) => result));
  }

  exportSponsorshipVouchersForOrganization(organizationIdOrSlug: string, conferenceId: number, searchParams: VoucherSearchParams): Observable<Blob> {
       return this.http.post(`${this.longRunningServerUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/vouchers/export`, searchParams, {responseType: 'blob' })
            .pipe(map((result: Blob) => result));
  }

  linkSponsorOrderToSponsorOrganization(organizationIdOrSlug: string, conferenceId: number, orderId: number, model: LinkSponsorOrderToSponsorOrganizationModel): Observable<SponsorshipOrderViewModel[]> {
       return this.http.post<SponsorshipOrderViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/orders/${orderId}/linkOrganization`, model)
            .pipe(map((result: SponsorshipOrderViewModel[]) => result));
  }

  unLinkSponsorOrderToSponsorOrganization(organizationIdOrSlug: string, conferenceId: number, orderId: number): Observable<SponsorshipOrderViewModel[]> {
       return this.http.delete<SponsorshipOrderViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/orders/${orderId}/unlinkOrganization`);
   }

  getSponsorshipProduct(organizationIdOrSlug: string, conferenceId: number, productId: number): Observable<SponsorshipProductViewModel> {
       return this.http.get<SponsorshipProductViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/products/${productId}`);
   }

  getSponsorshipProductTags(organizationIdOrSlug: string, conferenceId: number): Observable<SponsorshipProductTagViewModel[]> {
       return this.http.get<SponsorshipProductTagViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/tags`);
   }

  getSponsorshipProductAddOn(organizationIdOrSlug: string, conferenceId: number, addOnId: number): Observable<SponsorshipProductAddOnViewModel> {
       return this.http.get<SponsorshipProductAddOnViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/add-ons/${addOnId}`);
   }

  updateProduct(organizationIdOrSlug: string, conferenceId: number, productId: number, model: SponsorshipProductViewModel): Observable<SponsorshipProductViewModel> {
       return this.http.put<SponsorshipProductViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/products/${productId}`, model)
            .pipe(map((result: SponsorshipProductViewModel) => result));
  }

  cloneProduct(organizationIdOrSlug: string, conferenceId: number, productId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/products/${productId}`, null)
            .pipe(map((result: boolean) => result));
  }

  deleteProduct(organizationIdOrSlug: string, conferenceId: number, productId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/products/${productId}`);
   }

  createAddOn(organizationIdOrSlug: string, conferenceId: number, model: SponsorshipProductAddOnViewModel): Observable<SponsorshipProductAddOnViewModel> {
       return this.http.post<SponsorshipProductAddOnViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/add-ons`, model)
            .pipe(map((result: SponsorshipProductAddOnViewModel) => result));
  }

  updateAddOn(organizationIdOrSlug: string, conferenceId: number, addOnId: number, model: SponsorshipProductAddOnViewModel): Observable<SponsorshipProductAddOnViewModel> {
       return this.http.put<SponsorshipProductAddOnViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/add-ons/${addOnId}`, model)
            .pipe(map((result: SponsorshipProductAddOnViewModel) => result));
  }

  createProduct(organizationIdOrSlug: string, conferenceId: number, model: SponsorshipProductViewModel): Observable<SponsorshipProductViewModel> {
       return this.http.post<SponsorshipProductViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/products`, model)
            .pipe(map((result: SponsorshipProductViewModel) => result));
  }

  cloneSponsorStore(organizationIdOrSlug: string, conferenceId: number, conferenceIdToClone: number): Observable<SponsorshipProductViewModel> {
       return this.http.post<SponsorshipProductViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorships/products/clone/${conferenceIdToClone}`, null)
            .pipe(map((result: SponsorshipProductViewModel) => result));
  }

  cloneWebsite(organizationIdOrSlug: string, conferenceId: number, conferenceIdToClone: number): Observable<SponsorshipProductViewModel> {
       return this.http.post<SponsorshipProductViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/website/clone/${conferenceIdToClone}`, null)
            .pipe(map((result: SponsorshipProductViewModel) => result));
  }

  cloneFromConference(organizationIdOrSlug: string, conferenceId: number, model: CloneFromConferenceViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/cloneFromConference`, model)
            .pipe(map((result: boolean) => result));
  }

  updateConferenceIntegrationSettings(organizationIdOrSlug: string, conferenceId: number, integrationId: number, model: OrganizationIntegrationViewModel): Observable<OrganizationIntegrationViewModel[]> {
       return this.http.put<OrganizationIntegrationViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/integrations/${integrationId}`, model)
            .pipe(map((result: OrganizationIntegrationViewModel[]) => result));
  }

  getConferenceWebsiteSettings(organizationIdOrSlug: string, conferenceId: number): Observable<WebsiteSettings> {
       return this.http.get<WebsiteSettings>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/website/settings`);
   }

  updateConferenceWebsiteSettings(organizationIdOrSlug: string, conferenceId: number, settings: WebsiteSettings): Observable<WebsiteSettings> {
       return this.http.post<WebsiteSettings>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/website/settings`, settings)
            .pipe(map((result: WebsiteSettings) => result));
  }

  getCEUScannersForConference(organizationIdOrSlug: string, conferenceId: number): Observable<ConferenceCEUScannerViewModel[]> {
       return this.http.get<ConferenceCEUScannerViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/ceu-scanners`);
   }

  getPaperReviewersForConference(organizationIdOrSlug: string, conferenceId: number): Observable<ConferencePaperReviewerViewModel[]> {
       return this.http.get<ConferencePaperReviewerViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/paper-reviewers`);
   }

  deletePaperReviewer(organizationIdOrSlug: string, conferenceId: number, userId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/paper-reviewers/${userId}`);
   }

  remindPaperRevier(organizationIdOrSlug: string, conferenceId: number, userId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/paper-reviewers/${userId}/notify`, null)
            .pipe(map((result: boolean) => result));
  }

  linkCEUScannerToConference(organizationIdOrSlug: string, conferenceId: number, userId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/ceu-scanners/${userId}`, null)
            .pipe(map((result: boolean) => result));
  }

  linkPaperReviewerToConference(organizationIdOrSlug: string, conferenceId: number, userId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/paper-reviewers/${userId}`, null)
            .pipe(map((result: boolean) => result));
  }

  deleteCEUScanner(organizationIdOrSlug: string, conferenceId: number, userId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/ceu-scanners/${userId}`);
   }

  getSponsorConfiguration(organizationIdOrSlug: string, conferenceId: number): Observable<SponsorConfigurationViewModel> {
       return this.http.get<SponsorConfigurationViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsor-configuration`);
   }

  updateSponsorConfiguration(organizationIdOrSlug: string, conferenceId: number, model: SponsorConfigurationViewModel): Observable<SponsorConfigurationViewModel> {
       return this.http.put<SponsorConfigurationViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsor-configuration`, model)
            .pipe(map((result: SponsorConfigurationViewModel) => result));
  }

  changeReviewerBlindStatus(organizationIdOrSlug: string, conferenceId: number, userId: number, blind: boolean): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/reviewers/${userId}/blind/${blind}`, null)
            .pipe(map((result: boolean) => result));
  }

  updateRoomLockForScanner(organizationIdOrSlug: string, conferenceId: number, userId: number, roomId: (any|number)): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/ceu-scanners/${userId}/lock-to-room?roomId=${roomId}`, null)
            .pipe(map((result: boolean) => result));
  }

  updateScanMode(organizationIdOrSlug: string, conferenceId: number, userId: number, mode: any): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/ceu-scanners/${userId}/mode?mode=${mode}`, null)
            .pipe(map((result: boolean) => result));
  }

  updateLockInOut(organizationIdOrSlug: string, conferenceId: number, userId: number, inOut: any): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/ceu-scanners/${userId}/lock-in-out?inOut=${inOut}`, null)
            .pipe(map((result: boolean) => result));
  }

  getPrinters(organizationIdOrSlug: string, conferenceId: number): Observable<BadgePrinterViewModel[]> {
       return this.http.put<BadgePrinterViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/badge-printers`, null)
            .pipe(map((result: BadgePrinterViewModel[]) => result));
  }

  getBadgePDF(organizationIdOrSlug: string, conferenceId: number, param: RegistrantSearchParameters): Observable<Blob> {
       return this.http.post(`${this.longRunningServerUrl}/organization/${organizationIdOrSlug}/${conferenceId}/badge-pdf`, param, {responseType: 'blob' })
            .pipe(map((result: Blob) => result));
  }

  printBadges(organizationIdOrSlug: string, conferenceId: number, printerId: (any|number), param: RegistrantSearchParameters): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/badge-print?printerId=${printerId}`, param)
            .pipe(map((result: boolean) => result));
  }

  getPrintNodeComputers(): Observable<PrintNodeComputerViewModel[]> {
       return this.http.get<PrintNodeComputerViewModel[]>(`${this.baseUrl}/organization/print-node-computers`);
   }

  getMobileTilesForConference(organizationIdOrSlug: string, conferenceId: number): Observable<ConferenceViewModeMobileAppV2> {
       return this.http.get<ConferenceViewModeMobileAppV2>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/mobile-tiles`);
   }

  updateMobileTilesForConference(organizationIdOrSlug: string, conferenceId: number, model: ConferenceViewModeMobileAppV2): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/mobile-tiles`, model)
            .pipe(map((result: boolean) => result));
  }

  getCEUSheet(organizationIdOrSlug: string, conferenceId: number, singlePage: boolean): Observable<Blob> {
       return this.http.get(`${this.longRunningServerUrl}/organization/${organizationIdOrSlug}/${conferenceId}/ceu-pdf?singlePage=${singlePage}`, {responseType: 'blob' });
   }

  getCEUSheetForRoom(organizationIdOrSlug: string, conferenceId: number, roomId: number, singlePage: boolean): Observable<Blob> {
       return this.http.get(`${this.longRunningServerUrl}/organization/${organizationIdOrSlug}/${conferenceId}/ceu-pdf/${roomId}?singlePage=${singlePage}`, {responseType: 'blob' });
   }

  reorderProducts(conferenceId: number, model: OrderedIdModel): Observable<SponsorshipProductViewModel[]> {
       return this.http.post<SponsorshipProductViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/products/reorder`, model)
            .pipe(map((result: SponsorshipProductViewModel[]) => result));
  }

  getCardReadersForConference(organizationIdOrSlug: string, conferenceId: number): Observable<CardReaderDisplayViewModel[]> {
       return this.http.get<CardReaderDisplayViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/card-readers`);
   }

  getConferenceDashboardStats(organizationIdOrSlug: string, conferenceId: number, previousConferenceId: number): Observable<ConferenceDashboardStatsViewModel> {
       return this.http.get<ConferenceDashboardStatsViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/dashboard?previousConferenceId=${previousConferenceId}`);
   }

  updatePreviousConferenceId(organizationIdOrSlug: string, conferenceId: number, previousConferenceId: number): Observable<ConferenceDashboardStatsViewModel> {
       return this.http.put<ConferenceDashboardStatsViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/dashboard?previousConferenceId=${previousConferenceId}`, null)
            .pipe(map((result: ConferenceDashboardStatsViewModel) => result));
  }

  addCardReader(organizationIdOrSlug: string, conferenceId: number, model: CardReaderDisplayViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/card-readers`, model)
            .pipe(map((result: boolean) => result));
  }

  updateCardReader(organizationIdOrSlug: string, conferenceId: number, readerId: number, model: CardReaderDisplayViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/card-readers/${readerId}`, model)
            .pipe(map((result: boolean) => result));
  }

  deleteCardReader(organizationIdOrSlug: string, conferenceId: number, readerId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/card-readers/${readerId}`);
   }

  updateCardReaderMode(organizationIdOrSlug: string, conferenceId: number, readerId: number, mode: any): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/card-readers/${readerId}/mode?mode=${mode}`, null)
            .pipe(map((result: boolean) => result));
  }

  updateReaderRoom(organizationIdOrSlug: string, conferenceId: number, readerId: number, roomId: number): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/card-readers/${readerId}/room?roomId=${roomId}`, null)
            .pipe(map((result: boolean) => result));
  }

  addManualAddOnsToRegistrant(organizationIdOrSlug: string, conferenceId: number, userId: number, packageId: number, model: ManualAddOnViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/registrants/${userId}/${packageId}/manual-add-ons`, model)
            .pipe(map((result: boolean) => result));
  }

  getConferenceWebsiteAds(conferenceId: number): Observable<ConferenceWebsiteAdViewModel[]> {
       return this.http.get<ConferenceWebsiteAdViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/website-ads`);
   }

  getConferenceWebsiteAd(conferenceId: number, conferenceWebsiteAdId: number): Observable<ConferenceWebsiteAdViewModel> {
       return this.http.get<ConferenceWebsiteAdViewModel>(`${this.baseUrl}/conferences/${conferenceId}/website-ads/${conferenceWebsiteAdId}`);
   }

  addConferenceWebsiteAd(conferenceId: number, model: ConferenceWebsiteAdViewModel): Observable<ConferenceWebsiteAdViewModel> {
       return this.http.post<ConferenceWebsiteAdViewModel>(`${this.baseUrl}/conferences/${conferenceId}/website-ads`, model)
            .pipe(map((result: ConferenceWebsiteAdViewModel) => result));
  }

  updateConferenceWebsiteAd(conferenceId: number, conferenceWebsiteAdId: number, model: ConferenceWebsiteAdViewModel): Observable<ConferenceWebsiteAdViewModel> {
       return this.http.put<ConferenceWebsiteAdViewModel>(`${this.baseUrl}/conferences/${conferenceId}/website-ads/${conferenceWebsiteAdId}`, model)
            .pipe(map((result: ConferenceWebsiteAdViewModel) => result));
  }

  deleteConferenceWebsiteAd(conferenceId: number, conferenceWebsiteAdId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/conferences/${conferenceId}/website-ads/${conferenceWebsiteAdId}`);
   }

  deleteConferencePurchaseOrder(organizationIdOrSlug: string, conferenceId: number, purchaseOrderId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/conferences/${conferenceId}/purchase-orders/${purchaseOrderId}`);
   }

  updateConferenceSponsorOrganization(organizationIdOrSlug: string, conferenceId: number, sponsorOrganizationId: number, isPublished: boolean): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorOrganizations/${sponsorOrganizationId}/update-published-status?isPublished=${isPublished}`, null)
            .pipe(map((result: boolean) => result));
  }

  updateSponsorshipOrderPurchasingUser(organizationIdOrSlug: string, conferenceId: number, sponsorshipOrderId: number, userId: number): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorship-orders/${sponsorshipOrderId}/update-purchasing-user/${userId}`, null)
            .pipe(map((result: boolean) => result));
  }

  paySponsorshipOrder(organizationIdOrSlug: string, conferenceId: number, sponsorshipOrderId: number, paymentReceivedByOrg: boolean): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/sponsorship-orders/${sponsorshipOrderId}/pay?paymentReceivedByOrg=${paymentReceivedByOrg}`, null)
            .pipe(map((result: boolean) => result));
  }

}
@Injectable()
export class AdminMembershipService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  profileSearch(organizationIdOrSlug: string, filter: ProfileSearchParams): Observable<PagedResult<MembershipProfileViewModel>> {
       return this.http.post<PagedResult<MembershipProfileViewModel>>(`${this.baseUrl}/organization/${organizationIdOrSlug}/membership/profiles/search`, filter)
            .pipe(map((result: PagedResult<MembershipProfileViewModel>) => result));
  }

  getIndividualProfile(organizationIdOrSlug: string, profileId: number): Observable<MembershipProfileViewModel> {
       return this.http.get<MembershipProfileViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/membership/profiles/${profileId}`);
   }

  getMembershipTypes(organizationIdOrSlug: string): Observable<MembershipTypeViewModel[]> {
       return this.http.get<MembershipTypeViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/membership/types`);
   }

  linkExistingUserToProfiles(organizationIdOrSlug: string, userId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/membership/${userId}`, null)
            .pipe(map((result: boolean) => result));
  }

}
@Injectable()
export class AdminOrganizationSettingsService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getAPIKeyForOrganization(organizationIdOrSlug: string): Observable<StringViewModel> {
       return this.http.get<StringViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/settings/api-keys`);
   }

  createAPIKeyForOrganization(organizationIdOrSlug: string): Observable<StringViewModel> {
       return this.http.post<StringViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/settings/api-keys`, null)
            .pipe(map((result: StringViewModel) => result));
  }

  deleteAPIKeyForOrganization(organizationIdOrSlug: string): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/settings/api-keys`);
   }

  getIntegrationsForOrganization(organizationIdOrSlug: string): Observable<OrganizationIntegrationViewModel[]> {
       return this.http.get<OrganizationIntegrationViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/settings/integrations`);
   }

  getOnDemandReportForOrganization(organizationIdOrSlug: string): Observable<OnDemandReportViewModel[]> {
       return this.http.get<OnDemandReportViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/reporting/on-demand`);
   }

  getLiveEventReportForOrganization(organizationIdOrSlug: string): Observable<OnDemandReportViewModel[]> {
       return this.http.get<OnDemandReportViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/reporting/live-events`);
   }

  getOnDemandReportForOrganizationExport(organizationIdOrSlug: string): Observable<Blob> {
       return this.http.get(`${this.longRunningServerUrl}/organization/${organizationIdOrSlug}/reporting/on-demand/export`, {responseType: 'blob' });
   }

  getLiveEventReportForOrganizationExport(organizationIdOrSlug: string): Observable<Blob> {
       return this.http.get(`${this.longRunningServerUrl}/organization/${organizationIdOrSlug}/reporting/live-events/export`, {responseType: 'blob' });
   }

  getAttendanceReportForOrganization(organizationIdOrSlug: string, model: DateRangeViewModel, page: number, pageSize: number): Observable<PagedResult<AttendanceReportViewModel>> {
       return this.http.post<PagedResult<AttendanceReportViewModel>>(`${this.baseUrl}/organization/${organizationIdOrSlug}/reporting/attendance?page=${page}&pageSize=${pageSize}`, model)
            .pipe(map((result: PagedResult<AttendanceReportViewModel>) => result));
  }

  getAttendanceReportForOrganizationExport(organizationIdOrSlug: string, model: DateRangeViewModel): Observable<Blob> {
       return this.http.post(`${this.longRunningServerUrl}/organization/${organizationIdOrSlug}/reporting/attendance/export`, model, {responseType: 'blob' })
            .pipe(map((result: Blob) => result));
  }

  getAttendanceSummaryReportForOrganization(organizationIdOrSlug: string, model: DateRangeViewModel, page: number, pageSize: number): Observable<PagedResult<AttendanceSummaryReportViewModel>> {
       return this.http.post<PagedResult<AttendanceSummaryReportViewModel>>(`${this.baseUrl}/organization/${organizationIdOrSlug}/reporting/attendance-summary?page=${page}&pageSize=${pageSize}`, model)
            .pipe(map((result: PagedResult<AttendanceSummaryReportViewModel>) => result));
  }

  getAttendanceSummaryReportForOrganizationExport(organizationIdOrSlug: string, model: DateRangeViewModel): Observable<Blob> {
       return this.http.post(`${this.longRunningServerUrl}/organization/${organizationIdOrSlug}/reporting/attendance-summary/export`, model, {responseType: 'blob' })
            .pipe(map((result: Blob) => result));
  }

  getStripeData(organizationIdOrSlug: string): Observable<StripeDataViewModel> {
       return this.http.get<StripeDataViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/stripeData/`);
   }

  completeStripeOauth(organizationIdOrSlug: string, model: StringViewModel): Observable<OrganizationViewModel> {
       return this.http.post<OrganizationViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/completeStripeOauth/`, model)
            .pipe(map((result: OrganizationViewModel) => result));
  }

  getCourseSummaries(organizationIdOrSlug: string, model: OrganizationCourseSearchParameters): Observable<PagedResult<CourseSummaryViewModel>> {
       return this.http.post<PagedResult<CourseSummaryViewModel>>(`${this.baseUrl}/organization/${organizationIdOrSlug}/courses`, model)
            .pipe(map((result: PagedResult<CourseSummaryViewModel>) => result));
  }

  getSpecificCourse(organizationIdOrSlug: string, courseIdOrSlug: string): Observable<CourseViewModel> {
       return this.http.post<CourseViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/courses/${courseIdOrSlug}`, null)
            .pipe(map((result: CourseViewModel) => result));
  }

  addIntegration(organizationIdOrSlug: string, model: OrganizationIntegrationViewModel): Observable<OrganizationIntegrationViewModel[]> {
       return this.http.post<OrganizationIntegrationViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/settings/integrations`, model)
            .pipe(map((result: OrganizationIntegrationViewModel[]) => result));
  }

  deleteUserForOrganization(organizationIdOrSlug: string, userId: number): Observable<UserViewModel[]> {
       return this.http.delete<UserViewModel[]>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/admin-users/${userId}`);
   }

  updateIntegration(organizationIdOrSlug: string, integrationId: number, model: OrganizationIntegrationViewModel): Observable<OrganizationIntegrationViewModel[]> {
       return this.http.put<OrganizationIntegrationViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/settings/integrations/${integrationId}`, model)
            .pipe(map((result: OrganizationIntegrationViewModel[]) => result));
  }

}
@Injectable()
export class AdminPointOfSaleService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  searchCustomers(organizationIdOrSlug: string, filter: PosCustomerSearchParams): Observable<PagedResult<PosCustomerListItemViewModel>> {
       return this.http.post<PagedResult<PosCustomerListItemViewModel>>(`${this.baseUrl}/organization/${organizationIdOrSlug}/pos/customers/search`, filter)
            .pipe(map((result: PagedResult<PosCustomerListItemViewModel>) => result));
  }

  getCustomer(organizationIdOrSlug: string, customerId: number): Observable<PosCustomerDetailViewModel> {
       return this.http.get<PosCustomerDetailViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/pos/customers/${customerId}`);
   }

  updateCustomer(organizationIdOrSlug: string, customerId: number, model: UpdatePosCustomerViewModel): Observable<PosCustomerViewModel> {
       return this.http.put<PosCustomerViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/pos/customers/${customerId}`, model)
            .pipe(map((result: PosCustomerViewModel) => result));
  }

  getCustomerOrders(organizationIdOrSlug: string, customerId: number, currentPage: number, pageSize: number): Observable<PagedResult<PosOrderListItemViewModel>> {
       return this.http.get<PagedResult<PosOrderListItemViewModel>>(`${this.baseUrl}/organization/${organizationIdOrSlug}/pos/customers/${customerId}/orders?currentPage=${currentPage}&pageSize=${pageSize}`);
   }

  searchOrders(organizationIdOrSlug: string, filter: PosOrderSearchParams): Observable<PagedResult<PosOrderListItemViewModel>> {
       return this.http.post<PagedResult<PosOrderListItemViewModel>>(`${this.baseUrl}/organization/${organizationIdOrSlug}/pos/orders/search`, filter)
            .pipe(map((result: PagedResult<PosOrderListItemViewModel>) => result));
  }

  getOrdersSummary(organizationIdOrSlug: string, filter: PosOrderSearchParams): Observable<PosOrderSummaryViewModel> {
       return this.http.post<PosOrderSummaryViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/pos/orders/summary`, filter)
            .pipe(map((result: PosOrderSummaryViewModel) => result));
  }

  getOrder(organizationIdOrSlug: string, orderId: number): Observable<PosOrderViewModel> {
       return this.http.get<PosOrderViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/pos/orders/${orderId}`);
   }

  getOrderStatuses(organizationIdOrSlug: string): Observable<PosOrderStatusViewModel[]> {
       return this.http.get<PosOrderStatusViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/pos/order-statuses`);
   }

  refundOrder(organizationIdOrSlug: string, orderId: number): Observable<PosOrderViewModel> {
       return this.http.post<PosOrderViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/pos/orders/${orderId}/refund`, null)
            .pipe(map((result: PosOrderViewModel) => result));
  }

  cancelOrder(organizationIdOrSlug: string, orderId: number): Observable<PosOrderViewModel> {
       return this.http.post<PosOrderViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/pos/orders/${orderId}/cancel`, null)
            .pipe(map((result: PosOrderViewModel) => result));
  }

}
@Injectable()
export class BadgeDesignerService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getBadge(organizationIdOrSlug: string, conferenceId: number, badgeTemplateId: number): Observable<BadgeTemplateViewModel> {
       return this.http.get<BadgeTemplateViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/get-badge/${badgeTemplateId}`);
   }

  updateBadgeElement(organizationIdOrSlug: string, elementId: number, model: ConferenceBadgeElementViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/badge-element/${elementId}`, model)
            .pipe(map((result: boolean) => result));
  }

  addBadgeElement(organizationIdOrSlug: string, badgeTemplateId: number, model: ConferenceBadgeElementViewModel): Observable<ConferenceBadgeElementViewModel> {
       return this.http.post<ConferenceBadgeElementViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/badges/${badgeTemplateId}/add-element`, model)
            .pipe(map((result: ConferenceBadgeElementViewModel) => result));
  }

  deleteBadgeElement(organizationIdOrSlug: string, elementId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/badge-element/${elementId}`);
   }

}
@Injectable()
export class ConferenceExpenseTrackingService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  inviteSpeakerToExpenseTracking(organizationIdOrSlug: string, conferenceId: number, userId: number): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/conferences/${conferenceId}/speakers/${userId}/expenses/invite`, null)
            .pipe(map((result: boolean) => result));
  }

  setExpenseTracking(organizationIdOrSlug: string, conferenceId: number, userId: number, model: BooleanViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/conferences/${conferenceId}/speakers/${userId}/expenses/tracking`, model)
            .pipe(map((result: boolean) => result));
  }

  setGuestRoomTracking(organizationIdOrSlug: string, conferenceId: number, userId: number, model: BooleanViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/conferences/${conferenceId}/speakers/${userId}/guestRrooms/tracking`, model)
            .pipe(map((result: boolean) => result));
  }

  setSpeakerVIP(organizationIdOrSlug: string, conferenceId: number, userId: number, model: BooleanViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/conferences/${conferenceId}/speakers/${userId}/vip`, model)
            .pipe(map((result: boolean) => result));
  }

  getConferenceSpeakerWithExpenses(organizationIdOrSlug: string, conferenceId: number, userId: number): Observable<ConferenceSpeakerViewModel> {
       return this.http.get<ConferenceSpeakerViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/conferences/${conferenceId}/speakers/${userId}`);
   }

  getConferenceSpeakerExpenses(organizationIdOrSlug: string, conferenceId: number, currentPage: number, pageSize: number, searchParams: ConferenceSpeakerExpenseSearchParameters): Observable<PagedResult<ConferenceSpeakerExpenseDetailsViewModel>> {
       return this.http.post<PagedResult<ConferenceSpeakerExpenseDetailsViewModel>>(`${this.baseUrl}/organization/${organizationIdOrSlug}/conferences/${conferenceId}/speakers?currentPage=${currentPage}&pageSize=${pageSize}`, searchParams)
            .pipe(map((result: PagedResult<ConferenceSpeakerExpenseDetailsViewModel>) => result));
  }

  getMyExpenses(conferenceId: number): Observable<ConferenceSpeakerViewModel> {
       return this.http.get<ConferenceSpeakerViewModel>(`${this.baseUrl}/users/conferences/${conferenceId}/expenses`);
   }

  addExpense(organizationIdOrSlug: string, conferenceId: number, userId: number, model: ConferenceSpeakerExpenseViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/conferences/${conferenceId}/speakers/${userId}/expenses`, model)
            .pipe(map((result: boolean) => result));
  }

  updateExpense(organizationIdOrSlug: string, conferenceId: number, userId: number, expenseId: number, model: ConferenceSpeakerExpenseViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/conferences/${conferenceId}/speakers/${userId}/expenses/${expenseId}`, model)
            .pipe(map((result: boolean) => result));
  }

  addPersonalExpense(conferenceId: number, model: ConferenceSpeakerExpenseViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/users/conferences/${conferenceId}/expenses`, model)
            .pipe(map((result: boolean) => result));
  }

  updatePersonalExpense(conferenceId: number, expenseId: number, model: ConferenceSpeakerExpenseViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/users/conferences/${conferenceId}/expenses/${expenseId}`, model)
            .pipe(map((result: boolean) => result));
  }

  deleteExpense(organizationIdOrSlug: string, conferenceId: number, userId: number, expenseId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/conferences/${conferenceId}/speakers/${userId}/expenses/${expenseId}`);
   }

  payoutExpense(organizationIdOrSlug: string, conferenceId: number, userId: number, expenseId: number, model: ConferenceSpeakerExpenseViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/conferences/${conferenceId}/speakers/${userId}/expenses/${expenseId}/payout`, model)
            .pipe(map((result: boolean) => result));
  }

  exportConferenceSpeakerExpenseData(organizationIdOrSlug: string, conferenceId: number): Observable<Blob> {
       return this.http.get(`${this.longRunningServerUrl}/organization/${organizationIdOrSlug}/conferences/${conferenceId}/speakers/expenses/export`, {responseType: 'blob' });
   }

}
@Injectable()
export class ConferenceMessagingService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getCampaignsForConference(organizationIdOrSlug: string, conferenceId: number): Observable<ListCampaignsViewModel[]> {
       return this.http.get<ListCampaignsViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/campaigns`);
   }

  getCampaignTemplates(): Observable<ListCampaignsViewModel[]> {
       return this.http.get<ListCampaignsViewModel[]>(`${this.baseUrl}/campaigns/templates`);
   }

  getTestEmailUsers(organizationIdOrSlug: string): Observable<InstructorViewModel[]> {
       return this.http.get<InstructorViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/test-email-users`);
   }

  getTestEmailImpersonations(organizationIdOrSlug: string, conferenceId: number, campaignId: number, searchText: string): Observable<CampaignUser[]> {
       return this.http.get<CampaignUser[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/campaigns/${campaignId}/impersonations?searchText=${searchText}`);
   }

  getCampaignById(organizationIdOrSlug: string, conferenceId: number, campaignId: number): Observable<CampaignViewModel> {
       return this.http.get<CampaignViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/campaigns/${campaignId}`);
   }

  validateCampaign(organizationIdOrSlug: string, conferenceId: number, campaignId: number): Observable<CampaignValidationResult> {
       return this.http.get<CampaignValidationResult>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/campaigns/${campaignId}/validate`);
   }

  saveCampaignForConference(organizationIdOrSlug: string, conferenceId: number, campaignId: number, model: CampaignViewModel): Observable<CampaignViewModel> {
       return this.http.put<CampaignViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/campaigns/${campaignId}`, model)
            .pipe(map((result: CampaignViewModel) => result));
  }

  cloneCampaign(organizationIdOrSlug: string, conferenceId: number, campaignId: number): Observable<CampaignSummary> {
       return this.http.put<CampaignSummary>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/campaigns/${campaignId}/clone`, null)
            .pipe(map((result: CampaignSummary) => result));
  }

  cloneList(organizationIdOrSlug: string, conferenceId: number, listId: number): Observable<CampaignListViewModel> {
       return this.http.put<CampaignListViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/lists/${listId}/clone`, null)
            .pipe(map((result: CampaignListViewModel) => result));
  }

  deleteCampaign(organizationIdOrSlug: string, conferenceId: number, campaignId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/campaigns/${campaignId}`);
   }

  createCampaign(organizationIdOrSlug: string, conferenceId: number): Observable<CampaignSummary> {
       return this.http.post<CampaignSummary>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/campaigns`, null)
            .pipe(map((result: CampaignSummary) => result));
  }

  createCampaignFromTemplate(organizationIdOrSlug: string, conferenceId: number, templateId: number): Observable<CampaignSummary> {
       return this.http.post<CampaignSummary>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/campaigns/template/${templateId}`, null)
            .pipe(map((result: CampaignSummary) => result));
  }

  scheduleCampaign(organizationIdOrSlug: string, conferenceId: number, campaignId: number): Observable<CampaignSummary> {
       return this.http.post<CampaignSummary>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/campaigns/${campaignId}/schedule`, null)
            .pipe(map((result: CampaignSummary) => result));
  }

  unScheduleCampaign(organizationIdOrSlug: string, conferenceId: number, campaignId: number): Observable<CampaignSummary> {
       return this.http.delete<CampaignSummary>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/campaigns/${campaignId}/schedule`);
   }

  sendTestEmail(organizationIdOrSlug: string, conferenceId: number, campaignId: number, model: TestEmailViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/campaigns/${campaignId}/test-email`, model)
            .pipe(map((result: boolean) => result));
  }

  getListsForConference(organizationIdOrSlug: string, conferenceId: number): Observable<CampaignListViewModel[]> {
       return this.http.get<CampaignListViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/lists`);
   }

  createList(organizationIdOrSlug: string, conferenceId: number): Observable<CampaignListViewModel> {
       return this.http.post<CampaignListViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/lists`, null)
            .pipe(map((result: CampaignListViewModel) => result));
  }

  getListById(organizationIdOrSlug: string, conferenceId: number, listId: number): Observable<CampaignListViewModel> {
       return this.http.get<CampaignListViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/lists/${listId}`);
   }

  updateList(organizationIdOrSlug: string, conferenceId: number, listId: number, model: CampaignListViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/lists/${listId}`, model)
            .pipe(map((result: boolean) => result));
  }

  deleteList(organizationIdOrSlug: string, conferenceId: number, listId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/lists/${listId}`);
   }

  getListFilters(): Observable<FilterProperty[]> {
       return this.http.get<FilterProperty[]>(`${this.baseUrl}/static-data/list-filters`);
   }

  previewList(organizationIdOrSlug: string, conferenceId: number, model: CampaignFilter): Observable<CampaignListResult> {
       return this.http.put<CampaignListResult>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/preview-list`, model)
            .pipe(map((result: CampaignListResult) => result));
  }

  searchLists(organizationIdOrSlug: string, conferenceId: number, model: CampaignListSearchParams): Observable<CampaignUser[]> {
       return this.http.put<CampaignUser[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/preview-lists`, model)
            .pipe(map((result: CampaignUser[]) => result));
  }

  previewEmail(organizationIdOrSlug: string, conferenceId: number, campaignId: number): Observable<CampaignUser[]> {
       return this.http.get<CampaignUser[]>(`${this.baseUrl}/~/organizations/${organizationIdOrSlug}/admin/conferences/${conferenceId}/messaging/campaigns/${campaignId}/preview-email`);
   }

}
@Injectable()
export class ConferenceSchedulerService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getProgramEvents(organizationIdOrSlug: string, conferenceId: number): Observable<ProgramEventViewModel[]> {
       return this.http.get<ProgramEventViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/program-events`);
   }

  generateProgram(organizationIdOrSlug: string, conferenceId: number, model: GenerateProgramViewModel): Observable<StringViewModel> {
       return this.http.post<StringViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/generate-program`, model)
            .pipe(map((result: StringViewModel) => result));
  }

  getProgramExportTemplates(organizationIdOrSlug: string, conferenceId: number): Observable<ProgramExportTemplateViewModel[]> {
       return this.http.get<ProgramExportTemplateViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/program-templates`);
   }

  getSingleProgramExportTemplate(organizationIdOrSlug: string, conferenceId: number, templateId: number): Observable<ProgramExportTemplateViewModel> {
       return this.http.get<ProgramExportTemplateViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/program-templates/${templateId}`);
   }

  updateExportTemplate(organizationIdOrSlug: string, conferenceId: number, templateId: number, model: ProgramExportTemplateViewModel): Observable<ProgramExportTemplateViewModel> {
       return this.http.put<ProgramExportTemplateViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/program-templates/${templateId}`, model)
            .pipe(map((result: ProgramExportTemplateViewModel) => result));
  }

  deleteExportTemplate(organizationIdOrSlug: string, conferenceId: number, templateId: number): Observable<ProgramExportTemplateViewModel> {
       return this.http.delete<ProgramExportTemplateViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/program-templates/${templateId}`);
   }

  cloneProgramTemplate(organizationIdOrSlug: string, conferenceId: number, templateId: number): Observable<ProgramExportTemplateViewModel> {
       return this.http.post<ProgramExportTemplateViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/program-templates/${templateId}`, null)
            .pipe(map((result: ProgramExportTemplateViewModel) => result));
  }

  createExportTemplate(organizationIdOrSlug: string, conferenceId: number, model: ProgramExportTemplateViewModel): Observable<ProgramExportTemplateViewModel> {
       return this.http.post<ProgramExportTemplateViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/program-templates`, model)
            .pipe(map((result: ProgramExportTemplateViewModel) => result));
  }

  reorderTemplates(conferenceId: number, model: OrderedIdModel): Observable<ProgramExportTemplateViewModel[]> {
       return this.http.post<ProgramExportTemplateViewModel[]>(`${this.baseUrl}/conferences/${conferenceId}/program-templates/reorder`, model)
            .pipe(map((result: ProgramExportTemplateViewModel[]) => result));
  }

  getScheduledEvents(organizationIdOrSlug: string, conferenceId: number, dayNum: number): Observable<SchedulerSettingsViewModel> {
       return this.http.get<SchedulerSettingsViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/scheduled-events?dayNum=${dayNum}`);
   }

  updateEventFromSchedule(organizationIdOrSlug: string, conferenceId: number, eventId: number, model: UpdateEventFromScheduleViewModel): Observable<SchedulerSettingsViewModel> {
       return this.http.put<SchedulerSettingsViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/scheduled-events/${eventId}`, model)
            .pipe(map((result: SchedulerSettingsViewModel) => result));
  }

}
@Injectable()
export class ConferenceSurveyService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getSurveysForConference(organizationIdOrSlug: string, conferenceId: number): Observable<SurveySummaryViewModel[]> {
       return this.http.get<SurveySummaryViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/surveys`);
   }

  getSurveyById(organizationIdOrSlug: string, conferenceId: number, surveyId: number): Observable<SurveyViewModel> {
       return this.http.get<SurveyViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/surveys/${surveyId}`);
   }

  getSurveyData(organizationIdOrSlug: string, conferenceId: number, surveyId: number): Observable<SurveyWithDataViewModel> {
       return this.http.get<SurveyWithDataViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/surveys/${surveyId}/data`);
   }

  cloneSurvey(organizationIdOrSlug: string, conferenceId: number, surveyId: number, toConferenceId: number): Observable<SurveyViewModel> {
       return this.http.put<SurveyViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/surveys/${surveyId}/clone?toConferenceId=${toConferenceId}`, null)
            .pipe(map((result: SurveyViewModel) => result));
  }

  publish(organizationIdOrSlug: string, conferenceId: number, surveyId: number): Observable<SurveyViewModel> {
       return this.http.put<SurveyViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/conferences/${conferenceId}/surveys/${surveyId}/publish`, null)
            .pipe(map((result: SurveyViewModel) => result));
  }

  unpublish(organizationIdOrSlug: string, conferenceId: number, surveyId: number): Observable<SurveyViewModel> {
       return this.http.put<SurveyViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/conferences/${conferenceId}/surveys/${surveyId}/unpublish`, null)
            .pipe(map((result: SurveyViewModel) => result));
  }

  getSurveyBySlug(conferenceIdOrSlug: string, surveySlug: string): Observable<SurveyViewModel> {
       return this.http.get<SurveyViewModel>(`${this.baseUrl}/conferences/${conferenceIdOrSlug}/surveys/${surveySlug}`);
   }

  addSurveyResult(conferenceIdOrSlug: string, surveySlug: string, model: AddSurveyResultModel): Observable<SurveyViewModel> {
       return this.http.post<SurveyViewModel>(`${this.baseUrl}/conferences/${conferenceIdOrSlug}/surveys/${surveySlug}`, model)
            .pipe(map((result: SurveyViewModel) => result));
  }

  createSurvey(organizationIdOrSlug: string, conferenceId: number): Observable<SurveyViewModel> {
       return this.http.post<SurveyViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/surveys`, null)
            .pipe(map((result: SurveyViewModel) => result));
  }

  saveSurvey(organizationIdOrSlug: string, conferenceId: number, surveyId: number, model: SurveyViewModel): Observable<SurveyViewModel> {
       return this.http.put<SurveyViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/surveys/${surveyId}`, model)
            .pipe(map((result: SurveyViewModel) => result));
  }

  deleteSurvey(organizationIdOrSlug: string, conferenceId: number, surveyId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/${conferenceId}/surveys/${surveyId}`);
   }

}
@Injectable()
export class OrganizationLMSService {
  private baseUrl;
  private longRunningServerUrl;

  constructor(private http: HttpClient, settings: SettingsProvider) {
    this.baseUrl = settings.configuration.baseUrl;
    this.longRunningServerUrl = settings.configuration.longRunningServerUrl;
  }

  getSecurityGroupsForOrganization(organizationIdOrSlug: string): Observable<SecurityGroupViewModel[]> {
       return this.http.get<SecurityGroupViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/security-groups`);
   }

  getSecurityGroupById(organizationIdOrSlug: string, securityGroupId: number): Observable<SecurityGroupViewModel> {
       return this.http.get<SecurityGroupViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/security-groups/${securityGroupId}`);
   }

  createSecurityGroup(organizationIdOrSlug: string, model: SecurityGroupViewModel): Observable<SecurityGroupViewModel> {
       return this.http.post<SecurityGroupViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/security-groups`, model)
            .pipe(map((result: SecurityGroupViewModel) => result));
  }

  getDefaultSecurityGroupForOrganization(organizationIdOrSlug: string): Observable<SecurityGroupViewModel> {
       return this.http.get<SecurityGroupViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/default-security-group`);
   }

  updateSecurityGroup(organizationIdOrSlug: string, securityGroupId: number, model: SecurityGroupViewModel): Observable<SecurityGroupViewModel> {
       return this.http.put<SecurityGroupViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/security-groups/${securityGroupId}`, model)
            .pipe(map((result: SecurityGroupViewModel) => result));
  }

  deleteSecurityGroup(organizationIdOrSlug: string, securityGroupId: number): Observable<SecurityGroupViewModel> {
       return this.http.delete<SecurityGroupViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/security-groups/${securityGroupId}`);
   }

  updateDefaultSecurityGroup(organizationIdOrSlug: string, securityGroupId: (any|number)): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/default-security-group`, securityGroupId)
            .pipe(map((result: boolean) => result));
  }

  getEmploymentTagsForOrganization(organizationIdOrSlug: string): Observable<EmploymentTagViewModel[]> {
       return this.http.get<EmploymentTagViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/employment-tags`);
   }

  getEmploymentTagById(organizationIdOrSlug: string, employmentTagId: number): Observable<EmploymentTagViewModel> {
       return this.http.get<EmploymentTagViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/employment-tags/${employmentTagId}`);
   }

  createEmploymentTag(organizationIdOrSlug: string, model: EmploymentTagViewModel): Observable<EmploymentTagViewModel> {
       return this.http.post<EmploymentTagViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/employment-tags`, model)
            .pipe(map((result: EmploymentTagViewModel) => result));
  }

  updateEmploymentTag(organizationIdOrSlug: string, employmentTagId: number, model: EmploymentTagViewModel): Observable<EmploymentTagViewModel> {
       return this.http.put<EmploymentTagViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/employment-tags/${employmentTagId}`, model)
            .pipe(map((result: EmploymentTagViewModel) => result));
  }

  deleteEmploymentTag(organizationIdOrSlug: string, employmentTagId: number): Observable<EmploymentTagViewModel> {
       return this.http.delete<EmploymentTagViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/employment-tags/${employmentTagId}`);
   }

  searchAllUsersForOrganization(organizationIdOrSlug: string, searchParams: OrganizationUserSearchParams): Observable<PagedResult<OrganizationUserViewModel>> {
       return this.http.post<PagedResult<OrganizationUserViewModel>>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/users/search`, searchParams)
            .pipe(map((result: PagedResult<OrganizationUserViewModel>) => result));
  }

  bulkUpdateOrganizationUsers(organizationIdOrSlug: string, model: BulkUpdateOrganizationUsersViewModel): Observable<number> {
       return this.http.post<number>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/users/bulk-update`, model)
            .pipe(map((result: number) => result));
  }

  searchAllUsersForOrganizationSimple(organizationIdOrSlug: string, searchParams: EmployeeSearchParams): Observable<PagedResult<OrganizationUserViewModelSimple>> {
       return this.http.post<PagedResult<OrganizationUserViewModelSimple>>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/users/search-simple`, searchParams)
            .pipe(map((result: PagedResult<OrganizationUserViewModelSimple>) => result));
  }

  getOrganizationUserListByIds(organizationIdOrSlug: string, userIds: ArrayViewModel): Observable<OrganizationUserViewModelSimple[]> {
       return this.http.post<OrganizationUserViewModelSimple[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/users/list-by-id`, userIds)
            .pipe(map((result: OrganizationUserViewModelSimple[]) => result));
  }

  doesOrgUserExistByEmail(organizationIdOrSlug: string, model: StringViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/users/exists`, model)
            .pipe(map((result: boolean) => result));
  }

  getOrganizationPermissionsForUser(organizationIdOrSlug: string): Observable<OrganizationUserPermissionsViewModel> {
       return this.http.get<OrganizationUserPermissionsViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/users/permissions`);
   }

  getOrganizationUserById(organizationIdOrSlug: string, userId: number): Observable<CreateUpdateOrganizationUserViewModel> {
       return this.http.get<CreateUpdateOrganizationUserViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/users/${userId}`);
   }

  createOrLinkUserToOrganization(organizationIdOrSlug: string, model: CreateUpdateOrganizationUserViewModel): Observable<number> {
       return this.http.post<number>(`${this.baseUrl}/organization/${organizationIdOrSlug}/users`, model)
            .pipe(map((result: number) => result));
  }

  updateOrganizationUser(organizationIdOrSlug: string, userId: number, model: CreateUpdateOrganizationUserViewModel): Observable<boolean> {
       return this.http.put<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/users/${userId}`, model)
            .pipe(map((result: boolean) => result));
  }

  searchLearningPlansForOrganization(organizationIdOrSlug: string, searchParams: LearningPlanSearchParams): Observable<PagedResult<LearningPlanListViewModel>> {
       return this.http.post<PagedResult<LearningPlanListViewModel>>(`${this.baseUrl}/organization/${organizationIdOrSlug}/learning-plans/search`, searchParams)
            .pipe(map((result: PagedResult<LearningPlanListViewModel>) => result));
  }

  getAllLearningPlansForOrganization(organizationIdOrSlug: string): Observable<LearningPlanListViewModel[]> {
       return this.http.get<LearningPlanListViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/learning-plans`);
   }

  getCategoriesForOrganization(organizationIdOrSlug: string): Observable<CategoryViewModel[]> {
       return this.http.get<CategoryViewModel[]>(`${this.baseUrl}/organization/${organizationIdOrSlug}/categories`);
   }

  searchCourseEvents(organizationIdOrSlug: string, searchParams: BasicSearchParameters, currentPage: number): Observable<PagedResult<CourseEventViewModelSimple>> {
       return this.http.post<PagedResult<CourseEventViewModelSimple>>(`${this.baseUrl}/organization/${organizationIdOrSlug}/learning-plans/available-courses/search?currentPage=${currentPage}`, searchParams)
            .pipe(map((result: PagedResult<CourseEventViewModelSimple>) => result));
  }

  getLearningPlanById(organizationIdOrSlug: string, learningPlanId: number): Observable<LearningPlanViewModel> {
       return this.http.get<LearningPlanViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/learning-plans/${learningPlanId}`);
   }

  createLearningPlan(organizationIdOrSlug: string, model: CreateUpdateLearningPlanViewModel): Observable<LearningPlanViewModel> {
       return this.http.post<LearningPlanViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/learning-plans`, model)
            .pipe(map((result: LearningPlanViewModel) => result));
  }

  updateLearningPlan(organizationIdOrSlug: string, learningPlanId: number, model: CreateUpdateLearningPlanViewModel): Observable<LearningPlanViewModel> {
       return this.http.put<LearningPlanViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/learning-plans/${learningPlanId}`, model)
            .pipe(map((result: LearningPlanViewModel) => result));
  }

  deleteLearningPlan(organizationIdOrSlug: string, learningPlanId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/learning-plans/${learningPlanId}`);
   }

  searchLearningPlanAssignmentsOrganization(organizationIdOrSlug: string, searchParams: ContentAssignmentSearchParams, currentPage: number, pageSize: number): Observable<PagedResult<UserLearningPlanAssignmentListViewModel>> {
       return this.http.post<PagedResult<UserLearningPlanAssignmentListViewModel>>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/learning-plan-assignments/search?currentPage=${currentPage}&pageSize=${pageSize}`, searchParams)
            .pipe(map((result: PagedResult<UserLearningPlanAssignmentListViewModel>) => result));
  }

  searchIndividualContentAssignmentsOrganization(organizationIdOrSlug: string, searchParams: ContentAssignmentSearchParams, currentPage: number, pageSize: number): Observable<PagedResult<IndividualUserCourseEventAssignmentViewModel>> {
       return this.http.post<PagedResult<IndividualUserCourseEventAssignmentViewModel>>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/content-assignments/search?currentPage=${currentPage}&pageSize=${pageSize}`, searchParams)
            .pipe(map((result: PagedResult<IndividualUserCourseEventAssignmentViewModel>) => result));
  }

  createBulkContentAssignment(organizationIdOrSlug: string, model: CreateBulkContentAssignmentViewModel): Observable<boolean> {
       return this.http.post<boolean>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/content-assignments`, model)
            .pipe(map((result: boolean) => result));
  }

  getOrganizationUserAssignmentSummary(organizationIdOrSlug: string, userId: number): Observable<OrganizationUserAssignmentSummaryViewModel> {
       return this.http.get<OrganizationUserAssignmentSummaryViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/users/${userId}/content-assignments/summary`);
   }

  searchOrganizationUserEventAssignments(organizationIdOrSlug: string, userId: number, searchParams: OrganizationUserAssignmentEventSearchParams): Observable<PagedResult<UserCourseEventAssignmentViewModel>> {
       return this.http.post<PagedResult<UserCourseEventAssignmentViewModel>>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/users/${userId}/content-assignments/events-search`, searchParams)
            .pipe(map((result: PagedResult<UserCourseEventAssignmentViewModel>) => result));
  }

  searchOrganizationUserLearningPlanAssignments(organizationIdOrSlug: string, userId: number, searchParams: OrganizationUserAssignmentOnDemandSearchParams, currentPage: number, pageSize: number): Observable<PagedResult<UserLearningPlanAssignmentViewModel>> {
       return this.http.post<PagedResult<UserLearningPlanAssignmentViewModel>>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/users/${userId}/content-assignments/learning-plan-search?currentPage=${currentPage}&pageSize=${pageSize}`, searchParams)
            .pipe(map((result: PagedResult<UserLearningPlanAssignmentViewModel>) => result));
  }

  searchOrganizationUserOnDemandIndividualAssignments(organizationIdOrSlug: string, userId: number, searchParams: OrganizationUserAssignmentOnDemandSearchParams, currentPage: number, pageSize: number): Observable<PagedResult<UserCourseEventAssignmentViewModel>> {
       return this.http.post<PagedResult<UserCourseEventAssignmentViewModel>>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/users/${userId}/content-assignments/on-demand-search?currentPage=${currentPage}&pageSize=${pageSize}`, searchParams)
            .pipe(map((result: PagedResult<UserCourseEventAssignmentViewModel>) => result));
  }

  getUserLearningPlanAssignmentDetails(organizationIdOrSlug: string, userId: number, learningPlanId: number): Observable<UserLearningPlanAssignmentDetailsViewModel> {
       return this.http.get<UserLearningPlanAssignmentDetailsViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/users/${userId}/learning-plan-assignments/${learningPlanId}`);
   }

  getUserCourseEventAssignmentDetails(organizationIdOrSlug: string, userId: number, courseEventId: number): Observable<UserCourseEventAssignmentDetailsViewModel> {
       return this.http.get<UserCourseEventAssignmentDetailsViewModel>(`${this.baseUrl}/organization/${organizationIdOrSlug}/users/${userId}/course-event-assignments/${courseEventId}`);
   }

  removeUserLearningPlanAssignment(organizationIdOrSlug: string, userId: number, learningPlanId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/users/${userId}/learning-plan-assignments/${learningPlanId}`);
   }

  removeUserCourseEventAssignment(organizationIdOrSlug: string, userId: number, courseEventId: number): Observable<boolean> {
       return this.http.delete<boolean>(`${this.baseUrl}/organization/${organizationIdOrSlug}/users/${userId}/course-event-assignments/${courseEventId}`);
   }

  searchUserCertificationEducationTracking(organizationIdOrSlug: string, filter: EducationTrackingSearchParams, currentPage: number, pageSize: number): Observable<PagedResult<UserCertificationDetailsViewModel>> {
       return this.http.post<PagedResult<UserCertificationDetailsViewModel>>(`${this.baseUrl}/organizations/${organizationIdOrSlug}/user-certifications/education-tracking-search?currentPage=${currentPage}&pageSize=${pageSize}`, filter)
            .pipe(map((result: PagedResult<UserCertificationDetailsViewModel>) => result));
  }

  exportUserCertificationEducationTracking(organizationIdOrSlug: string, filter: EducationTrackingSearchParams): Observable<Blob> {
       return this.http.post(`${this.longRunningServerUrl}/organizations/${organizationIdOrSlug}/education-tracking/export`, filter, {responseType: 'blob' })
            .pipe(map((result: Blob) => result));
  }

}
